window.HansoTheme = window.HansoTheme || {};

window.HansoTheme.openLiveChat = function openLiveChat() {
  if (typeof window.Intercom !== 'function') {
    return false;
  }

  window.Intercom('show');
  return true;
};

document.addEventListener('click', function handleLiveChatTrigger(event) {
  var trigger = event.target.closest && event.target.closest('[data-hanso-live-chat]');

  if (!trigger) {
    return;
  }

  if (window.HansoTheme.openLiveChat()) {
    event.preventDefault();
  }
});

window.HansoTheme.utils = {
  setScrollLock(shouldLock) {
    document.documentElement.classList.toggle('hideScroll', shouldLock);
    document.body.classList.toggle('hideScroll', shouldLock);
  },
};

window.HansoTheme.onReady = function onReady(callback) {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', callback, { once: true });
    return;
  }

  callback();
};

window.HansoTheme.onSectionEvent = function onSectionEvent(eventName, callback) {
  document.addEventListener(eventName, callback);
};

window.HansoTheme.gallerySliders = window.HansoTheme.gallerySliders || new Map();
window.HansoTheme.carouselGalleries = window.HansoTheme.carouselGalleries || new Map();
  window.HansoTheme.collectionPergolaGrids = window.HansoTheme.collectionPergolaGrids || new Map();
  window.HansoTheme.louverTechnologySections = window.HansoTheme.louverTechnologySections || new Map();
window.HansoTheme.pdpLouverFeatureGrids = window.HansoTheme.pdpLouverFeatureGrids || new Map();
window.HansoTheme.pdpGridGalleryCarousels = window.HansoTheme.pdpGridGalleryCarousels || new Map();
  window.HansoTheme.productMainGalleries = window.HansoTheme.productMainGalleries || new Map();
window.HansoTheme.productGridCarousels = window.HansoTheme.productGridCarousels || new Map();
window.HansoTheme.videoTestimonials = window.HansoTheme.videoTestimonials || new Map();
window.HansoTheme.blogPosts = window.HansoTheme.blogPosts || new Map();
window.HansoTheme.pressSpotlights = window.HansoTheme.pressSpotlights || new Map();
window.HansoTheme.animatedStats = window.HansoTheme.animatedStats || new Map();
window.HansoTheme.behindScenesSections = window.HansoTheme.behindScenesSections || new Map();
window.HansoTheme.pdpFullVideos = window.HansoTheme.pdpFullVideos || new Map();
window.HansoTheme.pdpBestReviews = window.HansoTheme.pdpBestReviews || new Map();
window.HansoTheme.pdpFaqSections = window.HansoTheme.pdpFaqSections || new Map();
window.HansoTheme.productAddons = window.HansoTheme.productAddons || new Map();
window.HansoTheme.productMainFaqs = window.HansoTheme.productMainFaqs || new Map();
window.HansoTheme.logoShowcaseTickers = window.HansoTheme.logoShowcaseTickers || new Map();
window.HansoTheme.logoShowcaseQuotes = window.HansoTheme.logoShowcaseQuotes || new Map();
window.HansoTheme.logoShowcaseCarousels = window.HansoTheme.logoShowcaseCarousels || new Map();
window.HansoTheme.logoShowcaseResponsiveHandlers = window.HansoTheme.logoShowcaseResponsiveHandlers || new Map();
window.HansoTheme.promoBanners = window.HansoTheme.promoBanners || new Map();
window.HansoTheme.customHeaders = window.HansoTheme.customHeaders || new Map();
window.HansoTheme.menuDrawers = window.HansoTheme.menuDrawers || new Map();
window.HansoTheme.footers = window.HansoTheme.footers || new Map();
window.HansoTheme.desktopMegaMenusInitialized = window.HansoTheme.desktopMegaMenusInitialized || false;
window.HansoTheme.flickity = window.HansoTheme.flickity || {
  instances: new Map(),
};

window.HansoTheme.motion = window.HansoTheme.motion || {
  lenis: null,
  gsap: window.gsap || null,
  ScrollTrigger: window.ScrollTrigger || null,
  tickerHandler: null,
  initialized: false,
};

window.HansoTheme.initMotion = function initMotion() {
  var motion = window.HansoTheme.motion;
  var Lenis = window.Lenis;

  motion.gsap = window.gsap || motion.gsap;
  motion.ScrollTrigger = window.ScrollTrigger || motion.ScrollTrigger;

  if (motion.initialized || !Lenis) {
    return motion;
  }

  if (motion.gsap && motion.ScrollTrigger) {
    motion.gsap.registerPlugin(motion.ScrollTrigger);
  }

  motion.lenis = new Lenis({
    smoothWheel: true,
    autoResize: true,
  });

  if (motion.ScrollTrigger) {
    motion.lenis.on('scroll', motion.ScrollTrigger.update);
  }

  if (motion.gsap) {
    motion.tickerHandler = function tickerHandler(time) {
      if (motion.lenis) {
        motion.lenis.raf(time * 1000);
      }
    };

    motion.gsap.ticker.add(motion.tickerHandler);
    motion.gsap.ticker.lagSmoothing(0);
  } else {
    var raf = function raf(time) {
      if (!motion.lenis) {
        return;
      }

      motion.lenis.raf(time);
      window.requestAnimationFrame(raf);
    };

    window.requestAnimationFrame(raf);
  }

  motion.initialized = true;

  return motion;
};

window.HansoTheme.refreshMotion = function refreshMotion() {
  var motion = window.HansoTheme.motion;

  if (motion.lenis && typeof motion.lenis.resize === 'function') {
    motion.lenis.resize();
  }

  if (motion.ScrollTrigger) {
    motion.ScrollTrigger.refresh();
  }
};

window.HansoTheme.syncViewportFillHero = function syncViewportFillHero(hero) {
  if (!hero || hero.dataset.fillViewportWithBanner !== 'true') {
    return;
  }

  var heroSection = hero.closest('.shopify-section');
  var nextSection = heroSection ? heroSection.nextElementSibling : hero.nextElementSibling;
  var promoBanner = nextSection ? nextSection.querySelector('.hanso-promo-banner-section') : null;
  var linkedBannerHeight = promoBanner ? promoBanner.getBoundingClientRect().height : 0;

  hero.style.setProperty('--hero-linked-banner-height', Math.round(linkedBannerHeight) + 'px');
};

window.HansoTheme.initViewportFillHeroes = function initViewportFillHeroes(scope) {
  var root = scope || document;
  var heroes = root.querySelectorAll('[data-hanso-hero][data-fill-viewport-with-banner="true"]');

  heroes.forEach(function (hero) {
    window.HansoTheme.syncViewportFillHero(hero);
  });
};

window.HansoTheme.initPromoBanner = function initPromoBanner(section) {
  if (!section || window.HansoTheme.promoBanners.has(section)) {
    return;
  }

  if (section.dataset.stickyBottom !== 'true') {
    return;
  }

  var dock = section.querySelector('[data-hanso-promo-banner-dock]');
  if (!dock) {
    return;
  }

  var gsapInstance = window.HansoTheme.motion && window.HansoTheme.motion.gsap;
  var state = {
    section: section,
    dock: dock,
    isDocked: false,
  };

  function measure() {
    section.style.setProperty('--promo-docked-height', Math.round(dock.getBoundingClientRect().height) + 'px');
  }

  function animateDock(shouldDock) {
    if (!gsapInstance) {
      return;
    }

    var surface = dock.querySelector('.hanso-promo-banner__surface');
    if (!surface) {
      return;
    }

    gsapInstance.killTweensOf(surface);
    gsapInstance.fromTo(
      surface,
      { y: shouldDock ? 14 : 0, autoAlpha: shouldDock ? 0.88 : 1 },
      {
        y: 0,
        autoAlpha: 1,
        duration: shouldDock ? 0.28 : 0.18,
        ease: 'power2.out',
        clearProps: 'transform,translate,rotate,scale,opacity,visibility',
      }
    );
  }

  function update() {
    var rect = section.getBoundingClientRect();
    var dockHeight = dock.getBoundingClientRect().height;
    var shouldDock = rect.top > window.innerHeight - dockHeight;

    if (shouldDock === state.isDocked) {
      return;
    }

    state.isDocked = shouldDock;
    section.classList.toggle('is-docked', shouldDock);
    animateDock(shouldDock);
  }

  state.measure = measure;
  state.update = update;

  measure();
  update();
  window.HansoTheme.promoBanners.set(section, state);
};

window.HansoTheme.initPromoBanners = function initPromoBanners(scope) {
  var root = scope || document;
  var sections = root.querySelectorAll('[data-hanso-promo-banner]');

  sections.forEach(function (section) {
    window.HansoTheme.initPromoBanner(section);
  });
};

window.HansoTheme.refreshPromoBanners = function refreshPromoBanners() {
  window.HansoTheme.promoBanners.forEach(function (state) {
    if (!state) {
      return;
    }

    state.measure();
    state.update();
  });
};

window.HansoTheme.destroyPromoBanner = function destroyPromoBanner(section) {
  if (!section || !window.HansoTheme.promoBanners.has(section)) {
    return;
  }

  section.classList.remove('is-docked');
  section.style.removeProperty('--promo-docked-height');
  window.HansoTheme.promoBanners.delete(section);
};

window.HansoTheme.initCustomHeader = function initCustomHeader(header) {
  if (!header || window.HansoTheme.customHeaders.has(header)) {
    return;
  }

  if (header.dataset.stickyEnabled !== 'true') {
    return;
  }

  var headerMain = header.querySelector('[data-hanso-header-main]');
  var topbarShell = header.querySelector('[data-hanso-topbar-shell]');

  if (!headerMain) {
    return;
  }

  var state = {
    header: header,
    headerMain: headerMain,
    topbarShell: topbarShell,
    stickyType: header.dataset.stickyType || 'always',
    active: false,
    threshold: 0,
    lastScrollTop: window.scrollY || window.pageYOffset || 0,
  };

  function syncTopbarVisibility() {
    var topbarVisible = !!(
      topbarShell &&
      topbarShell.offsetParent !== null &&
      topbarShell.getBoundingClientRect().bottom > 0
    );

    header.classList.toggle('is-topbar-visible', topbarVisible);
  }

    function setMeasurements() {
      header.classList.remove('is-nav-sticky');
      state.active = false;
      state.threshold = headerMain.getBoundingClientRect().top + window.scrollY;
      header.style.setProperty('--hanso-sticky-nav-height', headerMain.offsetHeight + 'px');
      header.style.setProperty('--hanso-mobile-header-bottom', headerMain.getBoundingClientRect().bottom + 'px');
      header.style.setProperty('--hanso-mobile-topbar-height', topbarShell ? topbarShell.offsetHeight + 'px' : '0px');
      syncTopbarVisibility();
    }

  function update() {
    var scrollTop = window.scrollY || window.pageYOffset;
    var pastThreshold = scrollTop >= state.threshold;
    var scrollDelta = scrollTop - state.lastScrollTop;
    var shouldStick = pastThreshold;

    if (state.stickyType === 'on-scroll-up') {
      if (scrollDelta < -2) {
        shouldStick = pastThreshold;
      } else if (scrollDelta > 2) {
        shouldStick = false;
      } else {
        shouldStick = state.active && pastThreshold;
      }
    }

    state.lastScrollTop = scrollTop;

    if (shouldStick === state.active) {
      return;
    }

      state.active = shouldStick;
      header.classList.toggle('is-nav-sticky', shouldStick);
      header.style.setProperty('--hanso-mobile-header-bottom', headerMain.getBoundingClientRect().bottom + 'px');
      header.style.setProperty('--hanso-mobile-topbar-height', topbarShell ? topbarShell.offsetHeight + 'px' : '0px');
      syncTopbarVisibility();
    }

  state.setMeasurements = setMeasurements;
  state.update = update;

  setMeasurements();
  update();

  window.HansoTheme.customHeaders.set(header, state);
};

window.HansoTheme.closeDesktopMegaMenus = function closeDesktopMegaMenus(exceptDetails) {
  var openMenus = document.querySelectorAll('.hanso-nav__details--mega[open]');

  openMenus.forEach(function (details) {
    if (exceptDetails && details === exceptDetails) {
      return;
    }

    details.removeAttribute('open');
  });
};

window.HansoTheme.bindDesktopMegaHover = function bindDesktopMegaHover(details) {
  if (!details || details.dataset.desktopMegaBound === 'true') {
    return;
  }

  var closeTimer = null;
  var summary = details.querySelector('summary');

  function isDesktopMegaEnabled() {
    return window.matchMedia('(min-width: 992px)').matches;
  }

  function openMenu() {
    if (!isDesktopMegaEnabled()) {
      return;
    }

    if (closeTimer) {
      window.clearTimeout(closeTimer);
      closeTimer = null;
    }

    window.HansoTheme.closeDesktopMegaMenus(details);
    details.setAttribute('open', '');
  }

  function closeMenu() {
    if (!isDesktopMegaEnabled()) {
      return;
    }

    if (closeTimer) {
      window.clearTimeout(closeTimer);
    }

    closeTimer = window.setTimeout(function () {
      details.removeAttribute('open');
    }, 120);
  }

  details.addEventListener('mouseenter', openMenu);
  details.addEventListener('mouseleave', closeMenu);

  if (summary) {
    summary.addEventListener('click', function onSummaryClick(event) {
      if (event.target.closest('.hanso-nav__summary-link')) {
        return;
      }

      if (!isDesktopMegaEnabled()) {
        return;
      }

      event.preventDefault();
      if (details.hasAttribute('open')) {
        closeMenu();
      } else {
        openMenu();
      }
    });
  }

  details.dataset.desktopMegaBound = 'true';
};

window.HansoTheme.initDesktopMegaMenus = function initDesktopMegaMenus() {
  if (window.HansoTheme.desktopMegaMenusInitialized) {
    return;
  }

  document.querySelectorAll('.hanso-nav__details--mega').forEach(function (details) {
    window.HansoTheme.bindDesktopMegaHover(details);
  });

  document.addEventListener('toggle', function onDesktopMegaToggle(event) {
    var details = event.target;

    if (!details || !details.matches || !details.matches('.hanso-nav__details--mega')) {
      return;
    }

    if (details.hasAttribute('open')) {
      window.HansoTheme.closeDesktopMegaMenus(details);
    }
  }, true);

  document.addEventListener('click', function onDocumentClick(event) {
    if (event.target.closest('[data-hanso-header]')) {
      return;
    }

    window.HansoTheme.closeDesktopMegaMenus();
  });

  document.addEventListener('keydown', function onDocumentKeydown(event) {
    if (event.key === 'Escape') {
      window.HansoTheme.closeDesktopMegaMenus();
    }
  });

  window.HansoTheme.desktopMegaMenusInitialized = true;
};

window.HansoTheme.initCustomHeaders = function initCustomHeaders(scope) {
  var root = scope || document;
  var headers = root.querySelectorAll('[data-hanso-header]');

  headers.forEach(function (header) {
    window.HansoTheme.initCustomHeader(header);
  });
};

window.HansoTheme.refreshCustomHeaders = function refreshCustomHeaders() {
  window.HansoTheme.customHeaders.forEach(function (state) {
    if (!state || !state.headerMain) {
      return;
    }

    state.setMeasurements();
    state.update();
  });
};

window.HansoTheme.updateCustomHeadersOnScroll = function updateCustomHeadersOnScroll() {
  window.HansoTheme.customHeaders.forEach(function (state) {
    if (!state) {
      return;
    }

    state.update();
  });
};

window.HansoTheme.destroyCustomHeader = function destroyCustomHeader(header) {
  if (!header || !window.HansoTheme.customHeaders.has(header)) {
    return;
  }

  header.classList.remove('is-nav-sticky');
  window.HansoTheme.customHeaders.delete(header);
};

window.HansoTheme.getFlickityInstance = function getFlickityInstance(element, options) {
  var FlickityConstructor = window.Flickity;

  if (!element || !FlickityConstructor) {
    return null;
  }

  var existingInstance = window.HansoTheme.flickity.instances.get(element);

  if (existingInstance) {
    existingInstance.resize();
    return existingInstance;
  }

  var instance = new FlickityConstructor(element, options || {});
  window.HansoTheme.flickity.instances.set(element, instance);
  return instance;
};

window.HansoTheme.destroyFlickityInstance = function destroyFlickityInstance(element) {
  var instance = window.HansoTheme.flickity.instances.get(element);

  if (!instance) {
    return;
  }

  instance.destroy();
  window.HansoTheme.flickity.instances.delete(element);
};

window.HansoTheme.initGallerySlider = function initGallerySlider(section) {
  if (!section || window.HansoTheme.gallerySliders.has(section)) {
    return;
  }

  var track = section.querySelector('[data-gallery-slider-track]');
  var slides = Array.prototype.slice.call(section.querySelectorAll('[data-gallery-slide]'));
  var barsWrap = section.querySelector('[data-gallery-slider-bars]');
  var prevButton = section.querySelector('[data-gallery-slider-prev]');
  var nextButton = section.querySelector('[data-gallery-slider-next]');
  var gsapInstance = window.HansoTheme.motion.gsap;

  if (!track || !slides.length || !barsWrap) {
    return;
  }

  var flkty = window.HansoTheme.getFlickityInstance(track, {
    cellAlign: 'left',
    contain: true,
    draggable: slides.length > 1,
    pageDots: false,
    prevNextButtons: false,
    wrapAround: false,
    imagesLoaded: true,
    percentPosition: true,
    setGallerySize: true,
    selectedAttraction: 0.018,
    friction: 0.22,
    dragThreshold: 8,
  });

  if (!flkty) {
    return;
  }

  barsWrap.innerHTML = '';

  function getBarTargets() {
    return window.HansoTheme.getCarouselTargetIndexes(section, slides.length);
  }

  function getCurrentTargetPosition() {
    return window.HansoTheme.getCarouselTargetPosition(flkty.selectedIndex, getBarTargets());
  }

  var barTargets = getBarTargets();
  var bars = barTargets.map(function (targetIndex, index) {
    var bar = document.createElement('button');
    bar.type = 'button';
    bar.className = 'hanso-gallery-slider__bar';
    bar.setAttribute('aria-label', 'Go to slide ' + (index + 1));
    bar.addEventListener('click', function () {
      flkty.select(targetIndex);
    });
    barsWrap.appendChild(bar);
    return bar;
  });

  var autoplayState = null;

  function updateBars() {
    var currentPosition = getCurrentTargetPosition();
    bars.forEach(function (bar, index) {
      var isActive = index === currentPosition;
      bar.classList.toggle('is-active', isActive);
      bar.classList.toggle('is-loading', !!(autoplayState && autoplayState.enabled && isActive));
    });
  }

  function bindArrowHover(button) {
    if (!button || !gsapInstance) {
      return;
    }

    function move(event) {
      var rect = button.getBoundingClientRect();
      var x = ((event.clientX - rect.left) / rect.width - 0.5) * 6;
      var y = ((event.clientY - rect.top) / rect.height - 0.5) * 6;
      gsapInstance.to(button, {
        x: x,
        y: y,
        duration: 0.2,
        ease: 'power2.out',
      });
    }

    function reset() {
      gsapInstance.to(button, {
        x: 0,
        y: 0,
        duration: 0.25,
        ease: 'power2.out',
      });
    }

    button.addEventListener('mousemove', move);
    button.addEventListener('mouseleave', reset);
  }

  if (prevButton) {
    prevButton.addEventListener('click', function () {
      var targets = getBarTargets();
      var currentPosition = getCurrentTargetPosition();
      var previousPosition = Math.max(0, currentPosition - 1);
      flkty.select(targets[previousPosition]);
    });
    bindArrowHover(prevButton);
  }

  if (nextButton) {
    nextButton.addEventListener('click', function () {
      var targets = getBarTargets();
      var currentPosition = getCurrentTargetPosition();
      var nextPosition = Math.min(targets.length - 1, currentPosition + 1);
      flkty.select(targets[nextPosition]);
    });
    bindArrowHover(nextButton);
  }

  function updateButtons() {
    var targets = getBarTargets();
    var currentPosition = getCurrentTargetPosition();

    if (prevButton) {
      prevButton.disabled = !targets.length || currentPosition === 0;
    }

    if (nextButton) {
      nextButton.disabled = !targets.length || currentPosition >= targets.length - 1;
    }
  }

  flkty.on('ready', function () {
    updateBars();
    updateButtons();
  });

  flkty.on('change', function () {
    updateBars();
    updateButtons();
    if (autoplayState) {
      autoplayState.restart();
    }
  });

  flkty.on('settle', function () {
    updateButtons();
  });

  autoplayState = window.HansoTheme.createCarouselAutoplay(section, flkty, getBarTargets, getCurrentTargetPosition);
  flkty.resize();
  updateBars();
  updateButtons();
  if (autoplayState) {
    autoplayState.start();
  }

  window.HansoTheme.gallerySliders.set(section, {
    flkty: flkty,
    autoplayState: autoplayState,
  });
};

window.HansoTheme.initProductMainGallery = function initProductMainGallery(section) {
  if (!section || window.HansoTheme.productMainGalleries.has(section)) {
    return;
  }

  var track = section.querySelector('[data-pdp-gallery-track]');
  var slides = Array.prototype.slice.call(section.querySelectorAll('[data-pdp-gallery-slide]'));
  var thumbs = Array.prototype.slice.call(section.querySelectorAll('[data-pdp-gallery-thumb]'));
  var thumbsRail = section.querySelector('[data-pdp-gallery-thumbs]');
  var prevButton = section.querySelector('[data-pdp-gallery-prev]');
  var nextButton = section.querySelector('[data-pdp-gallery-next]');
  var variantInputs = Array.prototype.slice.call(section.querySelectorAll('variant-selects input[type="radio"]'));
  var variantsJsonNode = section.querySelector('variant-selects [data-product-variants-json]');
  var dimensionsOpenButton = section.querySelector('[data-hanso-dimensions-open]');
  var dimensionsModal = section.querySelector('[data-hanso-dimensions-modal]');
  var dimensionsCloseButton = section.querySelector('[data-hanso-dimensions-close]');
  var dimensionsTrack = section.querySelector('[data-hanso-dimensions-track]');
  var dimensionsSlides = Array.prototype.slice.call(section.querySelectorAll('[data-hanso-dimensions-slide]'));
  var dimensionsPrevButton = section.querySelector('[data-hanso-dimensions-prev]');
  var dimensionsNextButton = section.querySelector('[data-hanso-dimensions-next]');
  var dimensionsBarsWrap = section.querySelector('[data-hanso-dimensions-bars]');
  var dimensionsFlkty = null;
  var allVariants = [];
  var galleryOptionChangeUnsubscriber = null;

  if (!track || !slides.length) {
    return;
  }

  if (variantsJsonNode) {
    try {
      allVariants = JSON.parse(variantsJsonNode.textContent || '[]');
    } catch (error) {
      allVariants = [];
    }
  }

  var isMobileGallery = window.matchMedia('(max-width: 991px)').matches;
  var useMobileWrapAround = isMobileGallery && slides.length > 1;

  var flkty = window.HansoTheme.getFlickityInstance(track, {
    cellAlign: isMobileGallery ? 'center' : 'left',
    contain: !isMobileGallery,
    draggable: slides.length > 1,
    pageDots: false,
    prevNextButtons: false,
    wrapAround: useMobileWrapAround,
    adaptiveHeight: !isMobileGallery,
    imagesLoaded: false,
    percentPosition: true,
    selectedAttraction: 0.02,
    friction: 0.24,
    dragThreshold: 8,
  });

  if (!flkty) {
    return;
  }

  var readyState = {
    settled: false,
    timeoutId: null,
  };

  function markGalleryReady() {
    if (readyState.settled) {
      return;
    }
    readyState.settled = true;
    if (readyState.timeoutId) {
      window.clearTimeout(readyState.timeoutId);
      readyState.timeoutId = null;
    }
    section.classList.remove('hanso-product-main-section--loading');
    section.classList.add('hanso-product-main-section--ready');
  }

  function getInitialGalleryImages() {
    var selectedSlide = slides[flkty && typeof flkty.selectedIndex === 'number' ? flkty.selectedIndex : 0] || slides[0];
    var selectedImages = selectedSlide ? Array.prototype.slice.call(selectedSlide.querySelectorAll('.hanso-product-main__image')) : [];

    if (selectedImages.length) {
      return selectedImages;
    }

    return Array.prototype.slice.call(section.querySelectorAll('.hanso-product-main__image[loading="eager"], .hanso-product-main__image[fetchpriority="high"]'));
  }

  function loadDeferredGalleryImage(image) {
    if (!image || image.dataset.pdpDeferredLoaded === 'true') {
      return;
    }

    var src = image.getAttribute('data-src');
    var srcset = image.getAttribute('data-srcset');

    if (srcset) {
      image.setAttribute('srcset', srcset);
    }

    if (src) {
      image.setAttribute('src', src);
    }

    image.dataset.pdpDeferredLoaded = 'true';

    if (flkty) {
      window.requestAnimationFrame(function () {
        flkty.resize();
      });
    }
  }

  function loadGallerySlide(index) {
    var slide = slides[index];
    if (!slide) {
      return;
    }

    Array.prototype.slice.call(slide.querySelectorAll('[data-pdp-deferred-image]')).forEach(loadDeferredGalleryImage);
  }

  function loadNearbyGallerySlides(index) {
    if (!slides.length) {
      return;
    }

    var currentIndex = typeof index === 'number' ? index : flkty.selectedIndex || 0;
    var indexes = [currentIndex, currentIndex - 1, currentIndex + 1];

    indexes.forEach(function (slideIndex) {
      if (slideIndex < 0 || slideIndex >= slides.length) {
        return;
      }

      loadGallerySlide(slideIndex);
    });
  }

  function waitForGalleryImages() {
    var mediaImages = getInitialGalleryImages();
    if (!mediaImages.length) {
      markGalleryReady();
      return;
    }

    var remaining = mediaImages.filter(function (image) {
      return !image.complete;
    });

    if (!remaining.length) {
      window.requestAnimationFrame(markGalleryReady);
      return;
    }

    var pending = remaining.length;
    var resolve = function resolve() {
      pending -= 1;
      if (pending <= 0) {
        window.requestAnimationFrame(markGalleryReady);
      }
    };

    remaining.forEach(function (image) {
      image.addEventListener('load', resolve, { once: true });
      image.addEventListener('error', resolve, { once: true });
    });
  }

  slides.forEach(function (slide) {
    Array.prototype.slice.call(slide.querySelectorAll('.hanso-product-main__image')).forEach(function (image) {
      image.addEventListener('load', function () {
        if (flkty) {
          flkty.resize();
        }
      }, { once: true });
    });
  });

  function keepActiveThumbVisible(behavior) {
    if (!thumbsRail || !thumbs.length) return;
    var activeThumb = thumbs[flkty.selectedIndex];
    if (!activeThumb) return;
    activeThumb.scrollIntoView({
      block: 'nearest',
      inline: 'center',
      behavior: behavior || 'smooth',
    });
  }

  function updateThumbs() {
    thumbs.forEach(function (thumb, index) {
      thumb.classList.toggle('is-active', index === flkty.selectedIndex);
    });
    keepActiveThumbVisible('smooth');
  }

  function updateButtons() {
    if (useMobileWrapAround) {
      if (prevButton) prevButton.disabled = false;
      if (nextButton) nextButton.disabled = false;
      return;
    }
    if (prevButton) prevButton.disabled = flkty.selectedIndex === 0;
    if (nextButton) nextButton.disabled = flkty.selectedIndex === slides.length - 1;
  }

  function getSelectedVariantData() {
    var selectedValues = [];
    var optionGroups = section.querySelectorAll('variant-selects fieldset');

    optionGroups.forEach(function (group) {
      var checked = group.querySelector('input[type="radio"]:checked');

      if (checked) {
        selectedValues.push(checked.value);
      }
    });

    if (allVariants.length && selectedValues.length) {
      var matchedVariant = allVariants.find(function (variant) {
        if (!variant.options || variant.options.length !== selectedValues.length) {
          return false;
        }

        return variant.options.every(function (optionValue, index) {
          return optionValue === selectedValues[index];
        });
      });

      if (matchedVariant) {
        return matchedVariant;
      }
    }

    var selectedVariantScript = section.querySelector('variant-selects [data-selected-variant]');

    if (selectedVariantScript) {
      try {
        return JSON.parse(selectedVariantScript.textContent || 'null');
      } catch (error) {
        return null;
      }
    }

    return null;
  }

  function syncGalleryToSelectedVariant() {
    if (!flkty) return;
    var selectedVariant = getSelectedVariantData();
    var mediaId = selectedVariant && selectedVariant.featured_media ? String(selectedVariant.featured_media.id) : '';

    if (!mediaId) {
      mediaId = section.getAttribute('data-selected-variant-media-id') || '';
    }

    if (!mediaId) {
      return;
    }

    var targetIndex = slides.findIndex(function (slide) {
      return String(slide.getAttribute('data-media-raw-id') || '') === mediaId;
    });

    if (targetIndex >= 0 && flkty.selectedIndex !== targetIndex) {
      loadNearbyGallerySlides(targetIndex);
      flkty.select(targetIndex);
    } else if (targetIndex >= 0) {
      loadNearbyGallerySlides(targetIndex);
    }
  }

  function hasVariantDeepLink() {
    try {
      return new URLSearchParams(window.location.search).has('variant');
    } catch (error) {
      return window.location.search.indexOf('variant=') !== -1;
    }
  }

  function resetGalleryToFirstMedia() {
    if (!flkty || !slides.length) return;

    if (flkty.selectedIndex !== 0) {
      flkty.select(0, false, true);
    }

    updateThumbs();
    updateButtons();
    keepActiveThumbVisible('auto');
  }

  function updateDimensionsCarouselControls() {
    if (!dimensionsFlkty) return;

    if (dimensionsPrevButton) {
      dimensionsPrevButton.disabled = dimensionsFlkty.selectedIndex === 0;
    }

    if (dimensionsNextButton) {
      dimensionsNextButton.disabled = dimensionsFlkty.selectedIndex === dimensionsSlides.length - 1;
    }

    if (dimensionsBarsWrap) {
      Array.prototype.slice.call(dimensionsBarsWrap.children).forEach(function (bar, index) {
        bar.classList.toggle('is-active', index === dimensionsFlkty.selectedIndex);
      });
    }
  }

  function initDimensionsCarousel() {
    if (!dimensionsTrack || dimensionsSlides.length < 2) {
      return;
    }

    dimensionsFlkty = window.HansoTheme.getFlickityInstance(dimensionsTrack, {
      cellAlign: 'left',
      contain: true,
      draggable: true,
      pageDots: false,
      prevNextButtons: false,
      adaptiveHeight: true,
      imagesLoaded: true,
      percentPosition: true,
    });

    if (!dimensionsFlkty) {
      return;
    }

    if (dimensionsBarsWrap && !dimensionsBarsWrap.children.length) {
      dimensionsBarsWrap.innerHTML = dimensionsSlides.map(function (_, index) {
        return '<button type="button" class="hanso-product-main__dimensions-bar" data-hanso-dimensions-bar="' + index + '" aria-label="Go to dimension image ' + (index + 1) + '"></button>';
      }).join('');

      Array.prototype.slice.call(dimensionsBarsWrap.children).forEach(function (bar, index) {
        bar.addEventListener('click', function () {
          dimensionsFlkty.select(index);
        });
      });
    }

    if (dimensionsTrack.dataset.hansoDimensionsCarouselInitialized !== 'true') {
      dimensionsFlkty.on('select', updateDimensionsCarouselControls);
      dimensionsTrack.dataset.hansoDimensionsCarouselInitialized = 'true';
    }
    dimensionsFlkty.resize();
    updateDimensionsCarouselControls();
  }

  function openDimensionsModal() {
    if (!dimensionsModal) {
      return;
    }

    window.HansoTheme.utils.setScrollLock(true);

    if (typeof dimensionsModal.showModal === 'function') {
      dimensionsModal.showModal();
    } else {
      dimensionsModal.setAttribute('open', 'open');
    }

    window.requestAnimationFrame(initDimensionsCarousel);
  }

  function closeDimensionsModal() {
    if (!dimensionsModal) {
      return;
    }

    window.HansoTheme.utils.setScrollLock(false);

    if (typeof dimensionsModal.close === 'function' && dimensionsModal.open) {
      dimensionsModal.close();
    } else {
      dimensionsModal.removeAttribute('open');
    }
  }

  thumbs.forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      var index = Number(thumb.dataset.index || 0);
      loadNearbyGallerySlides(index);
      flkty.select(index);
    });
  });

  if (prevButton) {
    prevButton.addEventListener('click', function () {
      loadNearbyGallerySlides(flkty.selectedIndex - 1);
      flkty.previous();
    });
  }

  if (nextButton) {
    nextButton.addEventListener('click', function () {
      loadNearbyGallerySlides(flkty.selectedIndex + 1);
      flkty.next();
    });
  }

  if (dimensionsOpenButton) {
    dimensionsOpenButton.addEventListener('click', openDimensionsModal);
  }

  if (dimensionsCloseButton) {
    dimensionsCloseButton.addEventListener('click', closeDimensionsModal);
  }

  if (dimensionsPrevButton) {
    dimensionsPrevButton.addEventListener('click', function () {
      if (dimensionsFlkty) {
        dimensionsFlkty.previous();
      }
    });
  }

  if (dimensionsNextButton) {
    dimensionsNextButton.addEventListener('click', function () {
      if (dimensionsFlkty) {
        dimensionsFlkty.next();
      }
    });
  }

  if (dimensionsModal) {
    dimensionsModal.addEventListener('click', function (event) {
      if (event.target === dimensionsModal) {
        closeDimensionsModal();
      }
    });

    dimensionsModal.addEventListener('close', function () {
      window.HansoTheme.utils.setScrollLock(false);
    });

    dimensionsModal.addEventListener('cancel', function () {
      window.HansoTheme.utils.setScrollLock(false);
    });
  }

  variantInputs.forEach(function (input) {
    input.addEventListener('change', function () {
      window.setTimeout(syncGalleryToSelectedVariant, 50);
      window.setTimeout(syncGalleryToSelectedVariant, 180);
    });
  });

  if (typeof subscribe === 'function' && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.optionValueSelectionChange) {
    galleryOptionChangeUnsubscriber = subscribe(window.PUB_SUB_EVENTS.optionValueSelectionChange, function (event) {
      if (!event || !event.data || !event.data.event || !section.contains(event.data.event.target)) {
        return;
      }

      window.requestAnimationFrame(syncGalleryToSelectedVariant);
      window.setTimeout(syncGalleryToSelectedVariant, 160);
    });
  }

  var stickyPurchaseCleanup = null;
  var primaryPurchaseBox = section.querySelector('.hanso-product-main__purchase-box--primary');
  var secondaryPurchaseBox = section.querySelector('.hanso-product-main__purchase-box--secondary');
  var infoColumn = section.querySelector('.hanso-product-main__info-column');
  var variantSelectsElement = section.querySelector('variant-selects');

  if (primaryPurchaseBox && secondaryPurchaseBox) {
    var stickyState = {
      scheduled: false,
      visible: false,
      desktop: null,
    };
    var applyStickyPurchaseVisibility = function applyStickyPurchaseVisibility() {
      stickyState.scheduled = false;
      var isCartPage =
        document.body.classList.contains('template-cart') ||
        window.location.pathname === (window.routes && window.routes.cart_url ? window.routes.cart_url : '/cart');

      if (isCartPage) {
        stickyState.visible = false;
        secondaryPurchaseBox.classList.remove('is-mobile-sticky-active');
        secondaryPurchaseBox.classList.add('is-hidden-by-primary');
        return;
      }

      var isDesktop = window.matchMedia('(min-width: 992px)').matches;
      var rect = primaryPurchaseBox.getBoundingClientRect();
      var viewportHeight = window.innerHeight || document.documentElement.clientHeight || 0;
      var primaryIsVisible = rect.top < viewportHeight * 0.9 && rect.bottom > viewportHeight * 0.12;
      var variantReached = true;
      var infoColumnEndReached = false;

      if (!isDesktop && variantSelectsElement) {
        var variantRect = variantSelectsElement.getBoundingClientRect();
        variantReached = variantRect.top <= viewportHeight * 0.86;
      }

      if (infoColumn) {
        var endRect = infoColumn.getBoundingClientRect();
        infoColumnEndReached = endRect.bottom <= viewportHeight;
      }

      var shouldShowSticky = variantReached && !primaryIsVisible && !infoColumnEndReached;
      if (stickyState.visible !== shouldShowSticky) {
        stickyState.visible = shouldShowSticky;
        secondaryPurchaseBox.classList.toggle('is-mobile-sticky-active', shouldShowSticky);
        secondaryPurchaseBox.classList.toggle('is-hidden-by-primary', !shouldShowSticky);
      }

      if (isDesktop && infoColumn) {
        var infoRect = infoColumn.getBoundingClientRect();
        var stickyLeft = Math.max(16, infoRect.left) + 'px';
        var stickyWidth = Math.max(320, infoRect.width) + 'px';
        if (secondaryPurchaseBox.style.getPropertyValue('--sticky-atc-left') !== stickyLeft) {
          secondaryPurchaseBox.style.setProperty('--sticky-atc-left', stickyLeft);
        }
        if (secondaryPurchaseBox.style.getPropertyValue('--sticky-atc-width') !== stickyWidth) {
          secondaryPurchaseBox.style.setProperty('--sticky-atc-width', stickyWidth);
        }
      } else if (stickyState.desktop !== isDesktop) {
        secondaryPurchaseBox.style.removeProperty('--sticky-atc-left');
        secondaryPurchaseBox.style.removeProperty('--sticky-atc-width');
      }
      stickyState.desktop = isDesktop;
    };
    var updateStickyPurchaseVisibility = function updateStickyPurchaseVisibility() {
      if (stickyState.scheduled) return;
      stickyState.scheduled = true;
      window.requestAnimationFrame(applyStickyPurchaseVisibility);
    };

    updateStickyPurchaseVisibility();
    window.addEventListener('scroll', updateStickyPurchaseVisibility, { passive: true });
    window.addEventListener('resize', updateStickyPurchaseVisibility);
    stickyPurchaseCleanup = function stickyPurchaseCleanup() {
      window.removeEventListener('scroll', updateStickyPurchaseVisibility);
      window.removeEventListener('resize', updateStickyPurchaseVisibility);
    };
  }

  var description = section.querySelector('[data-pdp-description-text]');
  var descriptionToggle = section.querySelector('[data-pdp-description-toggle]');
  if (description && descriptionToggle) {
    var syncDescriptionState = function syncDescriptionState() {
      if (description.dataset.expanded === 'true') {
        description.classList.remove('is-collapsed');
        descriptionToggle.hidden = false;
        descriptionToggle.textContent = 'Show Less';
        return;
      }

      description.classList.add('is-collapsed');
      window.requestAnimationFrame(function () {
        var isOverflowing = description.scrollHeight - description.clientHeight > 4;
        descriptionToggle.hidden = !isOverflowing;
        descriptionToggle.textContent = 'Read More';
        if (!isOverflowing) {
          description.classList.remove('is-collapsed');
        }
      });
    };

    descriptionToggle.addEventListener('click', function () {
      var expanded = description.dataset.expanded === 'true';
      description.dataset.expanded = expanded ? 'false' : 'true';
      syncDescriptionState();
    });

    syncDescriptionState();
  }

  var saleBanner = section.querySelector('[data-pdp-sale-banner]');
  var countdownTimer = null;
  if (saleBanner && saleBanner.dataset.saleEnd) {
    var countdownValues = {
      days: saleBanner.querySelector('[data-countdown-value="days"]'),
      hrs: saleBanner.querySelector('[data-countdown-value="hrs"]'),
      min: saleBanner.querySelector('[data-countdown-value="min"]'),
      secs: saleBanner.querySelector('[data-countdown-value="secs"]'),
    };

    var saleEnd = new Date(saleBanner.dataset.saleEnd).getTime();
    var nextSaleEnd = saleBanner.dataset.saleNextEnd ? new Date(saleBanner.dataset.saleNextEnd).getTime() : NaN;
    var updateCountdown = function updateCountdown() {
      var now = Date.now();
      if (now >= saleEnd && Number.isFinite(nextSaleEnd) && nextSaleEnd > now) {
        saleEnd = nextSaleEnd;
        nextSaleEnd = NaN;
      }
      var remaining = Math.max(0, saleEnd - now);
      var days = Math.floor(remaining / 86400000);
      var hours = Math.floor((remaining % 86400000) / 3600000);
      var minutes = Math.floor((remaining % 3600000) / 60000);
      var seconds = Math.floor((remaining % 60000) / 1000);

      if (countdownValues.days) countdownValues.days.textContent = String(days).padStart(2, '0');
      if (countdownValues.hrs) countdownValues.hrs.textContent = String(hours).padStart(2, '0');
      if (countdownValues.min) countdownValues.min.textContent = String(minutes).padStart(2, '0');
      if (countdownValues.secs) countdownValues.secs.textContent = String(seconds).padStart(2, '0');
    };

    updateCountdown();
    countdownTimer = window.setInterval(updateCountdown, 1000);
  }

  flkty.on('select', function () {
    loadNearbyGallerySlides(flkty.selectedIndex);
    updateThumbs();
    updateButtons();
  });

  flkty.on('settle', function () {
    window.requestAnimationFrame(markGalleryReady);
  });

  updateThumbs();
  updateButtons();
  loadGallerySlide(flkty.selectedIndex || 0);
  flkty.resize();
  keepActiveThumbVisible('auto');

  if (hasVariantDeepLink()) {
    syncGalleryToSelectedVariant();
  } else {
    resetGalleryToFirstMedia();
  }

  readyState.timeoutId = window.setTimeout(markGalleryReady, 1800);
  waitForGalleryImages();
  window.HansoTheme.productMainGalleries.set(section, {
    flkty: flkty,
    countdownTimer: countdownTimer,
    stickyPurchaseCleanup: stickyPurchaseCleanup,
    readyTimeoutId: readyState.timeoutId,
    syncGalleryToSelectedVariant: syncGalleryToSelectedVariant,
    galleryOptionChangeUnsubscriber: galleryOptionChangeUnsubscriber,
  });
};

window.HansoTheme.initProductMainGalleries = function initProductMainGalleries(scope) {
  var root = scope || document;
  var sections = root.querySelectorAll('[data-hanso-product-main]');

  sections.forEach(function (section) {
    window.HansoTheme.initProductMainGallery(section);
  });
};

window.HansoTheme.destroyProductMainGallery = function destroyProductMainGallery(section) {
  if (!section) {
    return;
  }

  var track = section.querySelector('[data-pdp-gallery-track]');
  if (track) {
    window.HansoTheme.destroyFlickityInstance(track);
  }

  var dimensionsTrack = section.querySelector('[data-hanso-dimensions-track]');
  if (dimensionsTrack) {
    window.HansoTheme.destroyFlickityInstance(dimensionsTrack);
  }

  if (window.HansoTheme.productMainGalleries.has(section)) {
    var gallery = window.HansoTheme.productMainGalleries.get(section);
    if (gallery && gallery.countdownTimer) {
      window.clearInterval(gallery.countdownTimer);
    }
    if (gallery && gallery.readyTimeoutId) {
      window.clearTimeout(gallery.readyTimeoutId);
    }
    if (gallery && gallery.stickyPurchaseCleanup) {
      gallery.stickyPurchaseCleanup();
    }
    if (gallery && typeof gallery.galleryOptionChangeUnsubscriber === 'function') {
      gallery.galleryOptionChangeUnsubscriber();
    }
    var secondaryPurchaseBox = section.querySelector('.hanso-product-main__purchase-box--secondary');
    if (secondaryPurchaseBox) {
      secondaryPurchaseBox.classList.remove('is-mobile-sticky-active', 'is-hidden-by-primary');
      secondaryPurchaseBox.style.removeProperty('--sticky-atc-left');
      secondaryPurchaseBox.style.removeProperty('--sticky-atc-width');
    }
    window.HansoTheme.productMainGalleries.delete(section);
  }
  section.classList.remove('hanso-product-main-section--ready');
  section.classList.add('hanso-product-main-section--loading');
};

window.HansoTheme.productAddonsIcons = window.HansoTheme.productAddonsIcons || {
  plusSmall: '<svg class="hanso-product-addons__tile-action-icon" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M4.5 9H13.5M9 13.5L9 4.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>',
  cartTrash: '<svg class="hanso-product-addons__tile-action-icon" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path stroke="currentColor" stroke-linecap="square" d="M2.996 4.692h11.462l-1.03 10.763H4.027zm8.987-.33L11.206 2H6.25l-.778 2.362m3.256 3.903v3.616"/></svg>',
  collectionGrid: '<svg class="hanso-product-addons__tile-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="3.75" y="3.75" width="6.5" height="6.5" stroke="currentColor" stroke-width="1.5"/><rect x="15.1494" y="2.60645" width="7" height="7" transform="rotate(15 15.1494 2.60645)" stroke="currentColor" stroke-width="1.5" stroke-linecap="square"></rect><rect x="3.75" y="13.75" width="6.5" height="6.5" stroke="currentColor" stroke-width="1.5"/><rect x="13.75" y="13.75" width="6.5" height="6.5" stroke="currentColor" stroke-width="1.5"/></svg>',
};

window.HansoTheme.initFaqImageCarousels = function initFaqImageCarousels(scope) {
  var root = scope || document;
  var carousels = Array.prototype.slice.call(root.querySelectorAll('[data-hanso-faq-carousel]'));

  return carousels.map(function (carousel) {
    var track = carousel.querySelector('[data-hanso-faq-carousel-track]');
    var slides = Array.prototype.slice.call(carousel.querySelectorAll('[data-hanso-faq-carousel-slide]'));
    var prevButton = carousel.querySelector('[data-hanso-faq-carousel-prev]');
    var nextButton = carousel.querySelector('[data-hanso-faq-carousel-next]');
    var barsWrap = carousel.querySelector('[data-hanso-faq-carousel-bars]');

    if (!track || slides.length < 2) {
      return null;
    }

    var flkty = window.HansoTheme.getFlickityInstance(track, {
      cellAlign: 'left',
      contain: true,
      draggable: true,
      pageDots: false,
      prevNextButtons: false,
      adaptiveHeight: true,
      imagesLoaded: true,
      percentPosition: true,
    });

    if (!flkty) {
      return null;
    }

    function updateControls() {
      var selectedIndex = flkty.selectedIndex || 0;
      if (prevButton) {
        prevButton.disabled = selectedIndex === 0;
      }
      if (nextButton) {
        nextButton.disabled = selectedIndex >= slides.length - 1;
      }
      if (barsWrap) {
        Array.prototype.slice.call(barsWrap.children).forEach(function (bar, index) {
          bar.classList.toggle('is-active', index === selectedIndex);
        });
      }
    }

    if (track.dataset.hansoFaqCarouselInitialized !== 'true') {
      if (barsWrap && !barsWrap.children.length) {
        barsWrap.innerHTML = slides.map(function (_, index) {
          return '<button type="button" class="hanso-product-main__dimensions-bar" data-hanso-faq-carousel-bar="' + index + '" aria-label="Go to FAQ image ' + (index + 1) + '"></button>';
        }).join('');

        Array.prototype.slice.call(barsWrap.children).forEach(function (bar, index) {
          bar.addEventListener('click', function () {
            flkty.select(index);
          });
        });
      }

      if (prevButton) {
        prevButton.addEventListener('click', function () {
          flkty.previous();
        });
      }

      if (nextButton) {
        nextButton.addEventListener('click', function () {
          flkty.next();
        });
      }

      flkty.on('select', updateControls);
      track.dataset.hansoFaqCarouselInitialized = 'true';
    }

    flkty.resize();
    updateControls();

    return {
      track: track,
      flkty: flkty,
    };
  }).filter(Boolean);
};

window.HansoTheme.resizeFaqImageCarousels = function resizeFaqImageCarousels(scope) {
  var root = scope || document;
  Array.prototype.slice.call(root.querySelectorAll('[data-hanso-faq-carousel-track]')).forEach(function (track) {
    var flkty = window.HansoTheme.getFlickityInstance(track);
    if (flkty) {
      flkty.resize();
    }
  });
};

window.HansoTheme.initProductAddons = function initProductAddons(section) {
  if (!section || window.HansoTheme.productAddons.has(section)) {
    return;
  }

  var addonsRoot = section.querySelector('[data-hanso-product-addons]');
  if (!addonsRoot) {
    return;
  }

  function parseJson(selector) {
    var node = addonsRoot.querySelector(selector);
    if (!node) return [];
    try {
      return JSON.parse(node.textContent || '[]');
    } catch (error) {
      console.warn('Failed to parse add-ons JSON', selector, error);
      return [];
    }
  }

  var variants = parseJson('[data-product-variants-json]');
  var sidewallConfigs = parseJson('[data-sidewall-configs-json]');
  var accessories = parseJson('[data-accessories-json]');
  var mandatoryUpsells = parseJson('[data-mandatory-upsells-json]');
  var sidewallTiles = addonsRoot.querySelector('[data-hanso-sidewall-tiles]');
  var accessoryTiles = addonsRoot.querySelector('[data-hanso-accessory-tiles]');
  var modal = addonsRoot.querySelector('[data-hanso-addon-modal]');
  var modalTitle = addonsRoot.querySelector('[data-hanso-addon-modal-title]');
  var modalGrid = addonsRoot.querySelector('[data-hanso-addon-modal-grid]');
  var upgradeList = addonsRoot.querySelector('[data-hanso-upgrade-list]');
  var hasOptionalUpgradeUpsells = addonsRoot.getAttribute('data-optional-upgrade-upsells') === 'true';
  var productHandle = addonsRoot.getAttribute('data-product-handle') || '';
  var earlyBirdDiscount = Number(section.getAttribute('data-early-bird-discount')) || 0;
  var earlyBirdAccessoryDiscount = Number(section.getAttribute('data-early-bird-accessory-discount')) || 0;
  var formId = addonsRoot.getAttribute('data-form-id');
  var secondaryFormId = addonsRoot.getAttribute('data-secondary-form-id');
  var forms = [formId ? document.getElementById(formId) : null, secondaryFormId ? document.getElementById(secondaryFormId) : null].filter(Boolean);
  var variantInputs = Array.prototype.slice.call(section.querySelectorAll('variant-selects input[type="radio"]'));
  var state = {
    sidewalls: {},
    accessories: {},
    upgrades: {},
    currentModal: null,
    optionChangeUnsubscriber: null,
    variantChangeUnsubscriber: null,
    lastValidVariant: null,
    currentVariantId: null,
    selectionIsTransient: false,
    variantSyncFrame: null,
    variantSyncTimer: null,
  };
  var sidewallFallbackImages = [
    'https://cdn.shopify.com/s/files/1/0605/1810/5319/files/side-wall-1-new.png',
    'https://cdn.shopify.com/s/files/1/0605/1810/5319/files/side-wall-2-new.png',
    'https://cdn.shopify.com/s/files/1/0605/1810/5319/files/side-wall-3-new.png',
    'https://cdn.shopify.com/s/files/1/0605/1810/5319/files/side-wall-4-new.png',
  ];
  var darkGraySwatchFallback = 'https://cdn.shopify.com/s/files/1/0605/1810/5319/files/dark-grey.svg';

  function normalizeValue(value) {
    return String(value || '')
      .replace(/&apos;/g, "'")
      .replace(/['"]/g, '')
      .trim()
      .toLowerCase();
  }

  function isDefaultTitle(value) {
    return normalizeValue(value).replace(/[\s_-]+/g, '-') === 'default-title';
  }

  function normalizeDimensionValue(value) {
    return String(value || '')
      .replace(/&apos;/g, "'")
      .replace(/['"]/g, '')
      .replace(/\s*(side|wall)\s*/gi, '')
      .trim()
      .toLowerCase();
  }

  function getCurrentSelections() {
    var selections = [];
    var groups = section.querySelectorAll('variant-selects fieldset');
    groups.forEach(function (group) {
      var checked = group.querySelector('input[type="radio"]:checked');
      if (checked) {
        selections.push(checked.value);
      }
    });
    return {
      values: selections,
      groupCount: groups.length,
    };
  }

  function getCurrentOptionMap() {
    var optionMap = {};
    var groups = section.querySelectorAll('variant-selects fieldset');

    groups.forEach(function (group) {
      var legend = group.querySelector('.hanso-product-main__option-title');
      var checked = group.querySelector('input[type="radio"]:checked');
      if (!legend || !checked) return;

      var optionName = (legend.childNodes[0] && legend.childNodes[0].textContent ? legend.childNodes[0].textContent : legend.textContent || '')
        .replace(/[.:]/g, '')
        .trim()
        .toLowerCase();

      optionMap[optionName] = checked.value;
    });

    return optionMap;
  }

  function getOptionMapValue(optionMap, keys) {
    if (!optionMap || !Array.isArray(keys)) return '';

    for (var i = 0; i < keys.length; i += 1) {
      if (optionMap[keys[i]]) {
        return optionMap[keys[i]];
      }
    }

    return '';
  }

  function getSelectedVariant() {
    var selectionState = getCurrentSelections();
    var selections = selectionState.values;
    var expectedOptionCount = variants[0] && variants[0].options ? variants[0].options.length : selectionState.groupCount;
    var hasCompleteSelection = selectionState.groupCount === expectedOptionCount && selections.length === expectedOptionCount;

    if (!hasCompleteSelection) {
      state.selectionIsTransient = true;
      return state.lastValidVariant || variants[0] || null;
    }

    var selectedVariant = variants.find(function (variant) {
      if (!variant.options || variant.options.length !== selections.length) return false;
      return variant.options.every(function (optionValue, index) {
        return normalizeValue(optionValue) === normalizeValue(selections[index]);
      });
    }) || null;

    state.selectionIsTransient = false;
    if (selectedVariant) {
      state.lastValidVariant = selectedVariant;
    }

    return selectedVariant;
  }

  function getCurrentContext() {
    var variant = getSelectedVariant();
    if (!variant) return null;

    var optionMap = state.selectionIsTransient ? {} : getCurrentOptionMap();
    var size = getOptionMapValue(optionMap, ['size', 'pergola size', 'awning size']) || variant.option1 || '';
    var color = getOptionMapValue(optionMap, ['color', 'frame color', 'pergola color']) || variant.option2 || '';
    var style = getOptionMapValue(optionMap, ['style', 'mounting style']) || variant.option3 || '';
    var canvasColor = getOptionMapValue(optionMap, ['canvas color']) || variant.option3 || '';
    var sizeParts = size.split('x');
    var width = normalizeDimensionValue(sizeParts[0]);
    var length = normalizeDimensionValue(sizeParts[1]);

    return {
      variant: variant,
      size: size,
      color: color,
      style: style,
      canvasColor: canvasColor,
      width: width,
      length: length,
    };
  }

  function getMatchingSidewallConfig(context) {
    if (!context) return null;
    var exactMatch = sidewallConfigs.find(function (config) {
      var configName = normalizeValue(config.name || '');
      var contextName = normalizeValue(context.size + ' | ' + context.style);

      if (configName && configName === contextName) {
        return true;
      }

      return normalizeDimensionValue(config.width) === context.width &&
        normalizeDimensionValue(config.length) === context.length &&
        normalizeValue(config.style) === normalizeValue(context.style);
    });

    return exactMatch || null;
  }

  function getResolvedSides(config, context) {
    var sides = config && Array.isArray(config.sides) ? config.sides.slice() : [];
    if (!sides.length || !context) return sides;

    var dimensions = sides.map(function (side) {
      return normalizeDimensionValue(side.dimension);
    }).filter(Boolean);
    var uniqueDimensions = dimensions.filter(function (dimension, index) {
      return dimensions.indexOf(dimension) === index;
    });
    var shouldDeriveSideDimensions = (sides.length === 3 || sides.length === 4) &&
      context.width &&
      context.length &&
      uniqueDimensions.length === 1 &&
      (uniqueDimensions[0] !== context.width || uniqueDimensions[0] !== context.length);

    if (!shouldDeriveSideDimensions) {
      return sides;
    }

    var derivedDimensions = [context.width, context.width, context.length, context.length];
    return sides.map(function (side, index) {
      var clonedSide = Object.assign({}, side);
      clonedSide.dimension = derivedDimensions[index] || side.dimension;
      return clonedSide;
    });
  }

  function getMatchingAddonVariant(product, context, sideDimension) {
    if (!product || !product.variants || !product.variants.length) return null;
    var normalizedColor = normalizeValue(context && context.color);
    var normalizedSize = normalizeValue(context && context.size);
    var normalizedSide = normalizeDimensionValue(sideDimension);
    var productHasColor = Array.isArray(product.options) && product.options.some(function (optionName) {
      return normalizeValue(optionName).indexOf('color') !== -1;
    });
    var productHasMainSize = product.variants.some(function (candidate) {
      return (candidate.options || []).some(function (value) {
        return normalizeValue(value) === normalizedSize;
      });
    });

    var variant = product.variants.find(function (candidate) {
      var optionValues = candidate.options || [];
      var matchesSize = productHasMainSize && normalizedSize ? optionValues.some(function (value) {
        return normalizeValue(value) === normalizedSize;
      }) : true;
      var matchesColor = productHasColor && normalizedColor ? optionValues.some(function (value) {
        return normalizeValue(value) === normalizedColor;
      }) : true;
      var matchesSide = normalizedSide ? optionValues.some(function (value) {
        return normalizeDimensionValue(value).indexOf(normalizedSide) === 0;
      }) : true;
      return matchesSize && matchesColor && matchesSide;
    });

    return variant || product.variants.find(function (candidate) { return candidate.available; }) || product.variants[0];
  }

  function getColorOptionIndex(product) {
    if (!product || !Array.isArray(product.options)) return -1;
    return product.options.findIndex(function (optionName) {
      return normalizeValue(optionName).indexOf('color') !== -1;
    });
  }

  function getVariantColorLabel(product, variant) {
    var colorIndex = getColorOptionIndex(product);
    if (colorIndex < 0 || !variant || !Array.isArray(variant.options)) return '';
    return variant.options[colorIndex] || '';
  }

  function variantMatchesSideContext(product, variant, context, sideDimension) {
    if (!variant) return false;

    var normalizedSize = normalizeValue(context && context.size);
    var normalizedSide = normalizeDimensionValue(sideDimension);
    var productHasMainSize = product.variants.some(function (candidate) {
      return (candidate.options || []).some(function (value) {
        return normalizeValue(value) === normalizedSize;
      });
    });
    var matchesSize = productHasMainSize && normalizedSize ? (variant.options || []).some(function (value) {
      return normalizeValue(value) === normalizedSize;
    }) : true;
    var matchesSide = normalizedSide ? (variant.options || []).some(function (value) {
      return normalizeDimensionValue(value).indexOf(normalizedSide) === 0;
    }) : true;

    return matchesSize && matchesSide;
  }

  function isHiddenSidewallVariant(variant) {
    if (!variant) return false;
    var variantText = [
      variant.title,
      variant.public_title,
      Array.isArray(variant.options) ? variant.options.join(' ') : '',
    ].join(' ');

    return normalizeValue(variantText).indexOf('motorized louvers') !== -1;
  }

  function getSidewallProductItems(product, context, sideDimension) {
    if (!product || !Array.isArray(product.variants)) return [];

    var matchingVariants = product.variants.filter(function (variant) {
      return !isHiddenSidewallVariant(variant) && variantMatchesSideContext(product, variant, context, sideDimension);
    });

    if (!matchingVariants.length) {
      var fallbackVariant = getMatchingAddonVariant(product, context, sideDimension);
      if (isHiddenSidewallVariant(fallbackVariant)) {
        fallbackVariant = product.variants.find(function (candidate) {
          return !isHiddenSidewallVariant(candidate) && candidate.available;
        }) || product.variants.find(function (candidate) {
          return !isHiddenSidewallVariant(candidate);
        }) || null;
      }
      return fallbackVariant ? [fallbackVariant] : [];
    }

    return matchingVariants;
  }

  function getColorSwatchMarkup(colorLabel, hasVariantImage) {
    var normalizedColor = normalizeValue(colorLabel).replace(/\s+/g, '-');
    if (!colorLabel) return '';

    if ((normalizedColor === 'dark-gray' || normalizedColor === 'dark-grey') && !hasVariantImage) {
      return '<span class="hanso-product-addons__color-swatch hanso-product-addons__color-swatch--image"><img src="' + darkGraySwatchFallback + '" alt="' + escapeAttribute(colorLabel) + '"></span>';
    }

    return '<span class="hanso-product-addons__color-swatch" style="--addon-swatch-color: ' + escapeAttribute(colorLabel) + ';" aria-hidden="true"></span>';
  }

  function getPreferredVariant(variantsForProduct, context) {
    if (!variantsForProduct || !variantsForProduct.length) return null;
    var normalizedColor = normalizeValue(context && context.color);

    return variantsForProduct.find(function (variant) {
      return (variant.options || []).some(function (value) {
        return normalizeValue(value) === normalizedColor;
      });
    }) || variantsForProduct.find(function (variant) {
      return variant.available;
    }) || variantsForProduct[0];
  }

  function getVariantPayload(product, variant) {
    var colorLabel = getVariantColorLabel(product, variant);
    var rawOptionLabel = variant.public_title || variant.title || colorLabel || '';
    var optionLabel = isDefaultTitle(rawOptionLabel) ? '' : rawOptionLabel;
    return {
      id: variant.id,
      title: variant.title,
      subtitle: colorLabel || optionLabel || '',
      optionLabel: optionLabel,
      image: variant.image || product.image || '',
      colorLabel: colorLabel,
      hasVariantImage: !!variant.has_image,
      price: variant.price || '',
      priceRaw: Number(variant.price_raw) || 0,
      compareAtPrice: variant.compare_at_price || '',
      compareAtPriceRaw: Number(variant.compare_at_price_raw) || 0,
      saveText: getAddonSavings(variant),
      variant: variant,
    };
  }

  function createVariantButtonAttributes(payload) {
    if (!payload) return '';

    return [
      'data-variant-id="' + escapeAttribute(payload.id) + '"',
      'data-subtitle="' + escapeAttribute(payload.optionLabel || payload.subtitle || '') + '"',
      'data-image="' + escapeAttribute(payload.image || '') + '"',
      'data-price="' + escapeAttribute(payload.price || '') + '"',
      'data-price-raw="' + escapeAttribute(payload.priceRaw || 0) + '"',
      'data-compare-price="' + escapeAttribute(payload.compareAtPrice || '') + '"',
      'data-compare-price-raw="' + escapeAttribute(payload.compareAtPriceRaw || 0) + '"',
      'data-save-text="' + escapeAttribute(payload.saveText || '') + '"',
    ].join(' ');
  }

  function getVariantOptionLabel(payload) {
    if (!payload) return 'Variant';
    var label = payload.optionLabel || payload.subtitle || payload.colorLabel || payload.title || 'Variant';
    return isDefaultTitle(label) ? 'Variant' : label;
  }

  function createVariantSelectMarkup(item) {
    if (!item || !item.variantChoices || item.variantChoices.length <= 1) return '';

    return [
      '<div class="hanso-product-addons__variant-select-field">',
      '<label class="hanso-product-addons__variant-select-label">Choose variant</label>',
      '<div class="hanso-product-addons__variant-select-wrap">',
      '<select class="hanso-product-addons__variant-select" data-addon-variant-select>',
      item.variantChoices.map(function (choice) {
        var isSelected = String(choice.id) === String(item.variantId);
        return [
          '<option value="' + escapeAttribute(choice.id) + '" ',
          createVariantButtonAttributes(choice),
          isSelected ? ' selected' : '',
          '>',
          escapeAttribute(getVariantOptionLabel(choice)),
          '</option>',
        ].join('');
      }).join(''),
      '</select>',
      '</div>',
      '</div>',
    ].join('');
  }

  function syncAddonInputs() {
    if (!forms.length) return;

    forms.forEach(function (form) {
      Array.prototype.slice.call(form.querySelectorAll('[data-addon-input]')).forEach(function (input) {
        input.remove();
      });
    });

    var index = 1;

    function appendAddonInput(variantId) {
      if (!variantId) return;

      var quantityInput = document.createElement('input');
      quantityInput.type = 'hidden';
      quantityInput.name = 'items[' + index + '][quantity]';
      quantityInput.value = '1';
      quantityInput.setAttribute('data-addon-input', 'true');

      var idInput = document.createElement('input');
      idInput.type = 'hidden';
      idInput.name = 'items[' + index + '][id]';
      idInput.value = variantId;
      idInput.setAttribute('data-addon-input', 'true');

      forms.forEach(function (form) {
        form.appendChild(quantityInput.cloneNode(true));
        form.appendChild(idInput.cloneNode(true));
      });
      index += 1;
    }

    if (!hasOptionalUpgradeUpsells) {
      mandatoryUpsells.forEach(function (upsell) {
        if (!upsell || upsell.available === false) return;
        appendAddonInput(upsell.variantId);
      });
    }

    ['sidewalls', 'accessories', 'upgrades'].forEach(function (type) {
      Object.keys(state[type]).forEach(function (key) {
        var item = state[type][key];
        if (!item || !item.variantId) return;
        appendAddonInput(item.variantId);
      });
    });
  }

  function createTileMarkup(config) {
    var priceMarkup = config.priceMarkup || '';
    var tileSubtitle = isDefaultTitle(config.subtitle || '') ? '' : config.subtitle;
    var actionAttributes = config.isFilled
      ? ' data-addon-remove data-addon-remove-type="' + config.type + '" data-addon-remove-index="' + config.index + '" role="button" tabindex="0" aria-label="Remove ' + escapeAttribute(config.title || 'add-on') + '"'
      : '';
    var tileContent = [
      '<span class="hanso-product-addons__tile-media">',
      config.image ? '<img src="' + config.image + '" alt="' + (config.title || '') + '">' : config.icon,
      '</span>',
      '<span class="hanso-product-addons__tile-footer">',
      '<span class="hanso-product-addons__tile-copy">',
      '<span class="hanso-product-addons__tile-title">' + config.title + '</span>',
      tileSubtitle ? '<span class="hanso-product-addons__tile-subtitle">' + tileSubtitle + '</span>' : '',
      priceMarkup,
      '</span>',
      !config.isFilled ? '<span class="hanso-product-addons__tile-action"><span class="hanso-product-addons__tile-action-icon-wrap">' + config.actionIcon + '</span></span>' : '',
      '</span>',
    ].join('');

    if (config.isFilled) {
      return [
        '<div class="hanso-product-addons__tile is-filled" data-addon-tile data-addon-type="' + config.type + '" data-addon-index="' + config.index + '">',
        '<button type="button" class="hanso-product-addons__tile-main" data-addon-open data-addon-type="' + config.type + '" data-addon-index="' + config.index + '">',
        tileContent,
        '</button>',
        '<button type="button" class="hanso-product-addons__tile-remove"' + actionAttributes + '>',
        '<span class="hanso-product-addons__tile-action-icon-wrap">' + window.HansoTheme.productAddonsIcons.cartTrash + '</span>',
        '</button>',
        '</div>',
      ].join('');
    }

    return [
      '<button type="button" class="hanso-product-addons__tile' + (config.isFilled ? ' is-filled' : '') + '" data-addon-open data-addon-type="' + config.type + '" data-addon-index="' + config.index + '">',
      tileContent,
      '</button>',
    ].join('');
  }

  function escapeAttribute(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;');
  }

  function formatAddonMoney(cents) {
    var normalizedCents = Number(cents) || 0;
    var activeCurrency = window.Shopify && Shopify.currency && Shopify.currency.active
      ? Shopify.currency.active
      : 'USD';

    try {
      return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: activeCurrency,
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(normalizedCents / 100);
    } catch (error) {
      return '$' + (normalizedCents / 100).toFixed(2);
    }
  }

  function updateProductFormsState(selectedVariant) {
    var hasVariant = !!(selectedVariant && selectedVariant.id);
    var isAvailable = hasVariant && selectedVariant.available !== false;

    forms.forEach(function (form) {
      var variantInput = form.querySelector('input[name="id"].product-variant-id, input[name="id"]');
      var submitButton = form.querySelector('[name="add"]');
      var submitText = submitButton ? submitButton.querySelector('span') : null;

      if (variantInput) {
        if (hasVariant) {
          variantInput.value = selectedVariant.id;
          variantInput.disabled = false;
        } else {
          variantInput.value = '';
          variantInput.disabled = true;
        }
      }

      if (submitButton) {
        var addText = submitButton.getAttribute('data-add-to-cart-text') || 'Add to cart';
        var soldOutText = submitButton.getAttribute('data-sold-out-text') || 'Sold out';
        var unavailableText = submitButton.getAttribute('data-unavailable-text') || 'Unavailable';
        submitButton.disabled = !isAvailable;

        if (submitText) {
          submitText.textContent = !hasVariant ? unavailableText : (isAvailable ? addText : soldOutText);
        }
      }
    });
  }

  function getAddonSavings(variant) {
    if (variant && variant.save_text) {
      return variant.save_text;
    }

    var compareAtPriceRaw = Number(variant && variant.compare_at_price_raw) || 0;
    var priceRaw = Number(variant && variant.price_raw) || 0;

    if (!compareAtPriceRaw || compareAtPriceRaw <= priceRaw) {
      return '';
    }

    return 'Save ' + formatAddonMoney(compareAtPriceRaw - priceRaw);
  }

  function createAddonPriceMarkup(variant, classes) {
    if (!variant || !variant.price) {
      return '';
    }

    var priceWrapperClass = classes && classes.wrapper ? classes.wrapper : 'hanso-product-addons__price-wrapper';
    var priceClass = classes && classes.price ? classes.price : 'hanso-product-addons__price';
    var compareClass = classes && classes.compare ? classes.compare : 'hanso-product-addons__compare-price';
    var saveClass = classes && classes.save ? classes.save : 'hanso-product-addons__save-badge';
    var saveText = getAddonSavings(variant);
    var hasCompareAtPrice = variant.compare_at_price && Number(variant.compare_at_price_raw) > Number(variant.price_raw);

    return [
      '<span class="' + priceWrapperClass + (hasCompareAtPrice ? ' is-on-sale' : '') + '">',
      '<span class="' + priceClass + '">' + variant.price + '</span>',
      hasCompareAtPrice ? '<span class="' + compareClass + '">' + variant.compare_at_price + '</span>' : '',
      saveText ? '<span class="' + saveClass + '">' + saveText + '</span>' : '',
      '</span>',
    ].join('');
  }

  function refreshAffirmMessages(totalPrice, attempt) {
    var amount = Number(totalPrice) || 0;
    if (!amount) return;

    Array.prototype.slice.call(section.querySelectorAll('.hanso-product-main__affirm-message')).forEach(function (message) {
      message.classList.add('affirm-as-low-as');
      message.setAttribute('data-page-type', 'product');
      message.setAttribute('data-amount', String(amount));
      message.setAttribute('data-affirm-type', message.getAttribute('data-affirm-type') || 'logo');
      message.setAttribute('data-affirm-color', message.getAttribute('data-affirm-color') || 'blue');
    });

    if (window.affirm && window.affirm.ui) {
      window.affirm.ui.ready(function () {
        window.affirm.ui.refresh();
      });
    }

    if (!attempt) {
      window.setTimeout(function () {
        refreshAffirmMessages(amount, 1);
      }, 180);
    }
  }

  function updateProductPricing() {
    var selectedVariant = getSelectedVariant();
    updateProductFormsState(selectedVariant);
    if (!selectedVariant) {
      Array.prototype.slice.call(section.querySelectorAll('.hanso-product-main__price-row')).forEach(function (row) {
        row.classList.remove('is-on-sale');
      });
      return;
    }

    var selectedPrice = Number(selectedVariant.price) || 0;
    var selectedCompare = Number(selectedVariant.compare_at_price) || selectedPrice;
    var selectedFullPrice = Math.max(selectedPrice, selectedCompare);
    var totalPrice = earlyBirdDiscount > 0
      ? Math.round(selectedFullPrice * (100 - earlyBirdDiscount) / 100)
      : selectedPrice;
    var compareTotal = selectedFullPrice;
    var baseSavings = Math.max(0, compareTotal - totalPrice);

    if (!hasOptionalUpgradeUpsells) {
      mandatoryUpsells.forEach(function (upsell) {
        if (!upsell || upsell.available === false) return;
        var priceRaw = Number(upsell.price_raw) || 0;
        var compareRaw = Number(upsell.compare_at_price_raw) || priceRaw;
        totalPrice += earlyBirdAccessoryDiscount > 0
          ? Math.round(Math.max(priceRaw, compareRaw) * (100 - earlyBirdAccessoryDiscount) / 100)
          : priceRaw;
        compareTotal += compareRaw > priceRaw ? compareRaw : priceRaw;
      });
    }

    ['sidewalls', 'accessories', 'upgrades'].forEach(function (type) {
      Object.keys(state[type]).forEach(function (key) {
        var item = state[type][key];
        if (!item || !item.variant) return;
        var priceRaw = Number(item.variant.price_raw) || 0;
        var compareRaw = Number(item.variant.compare_at_price_raw) || priceRaw;
        totalPrice += earlyBirdAccessoryDiscount > 0
          ? Math.round(Math.max(priceRaw, compareRaw) * (100 - earlyBirdAccessoryDiscount) / 100)
          : priceRaw;
        compareTotal += compareRaw > priceRaw ? compareRaw : priceRaw;
      });
    });

    var savings = Math.max(0, compareTotal - totalPrice);

    Array.prototype.slice.call(section.querySelectorAll('.hanso-product-main__price-row')).forEach(function (row) {
      var compareNode = row.querySelector('.hanso-product-main__compare-price');
      var priceNode = row.querySelector('.hanso-product-main__price');
      var savingsNode = row.querySelector('.hanso-product-main__savings-badge');

      row.classList.toggle('is-on-sale', savings > 0);

      if (!compareNode && savings > 0) {
        compareNode = document.createElement('span');
        compareNode.className = 'hanso-product-main__compare-price';
        row.insertBefore(compareNode, priceNode || row.firstChild);
      }

      if (compareNode) {
        compareNode.textContent = formatAddonMoney(compareTotal);
        compareNode.hidden = savings <= 0;
      }

      if (priceNode) {
        priceNode.textContent = formatAddonMoney(totalPrice);
      }

      if (!savingsNode && savings > 0) {
        savingsNode = document.createElement('span');
        savingsNode.className = 'hanso-product-main__savings-badge';
        row.appendChild(savingsNode);
      }

      if (savingsNode) {
        savingsNode.textContent = 'Save ' + formatAddonMoney(savings);
        savingsNode.hidden = savings <= 0;
      }
    });

    refreshAffirmMessages(totalPrice);
  }

  function renderSidewallTiles() {
    if (!sidewallTiles) return;
    var context = getCurrentContext();
    var config = getMatchingSidewallConfig(context);
    var sides = getResolvedSides(config, context);

    if (!config || !sides.length) {
      sidewallTiles.innerHTML = '<div class="hanso-product-addons__empty">No matching sidewall add-ons for the currently selected pergola configuration.</div>';
      state.sidewalls = {};
      syncAddonInputs();
      return;
    }

    sidewallTiles.innerHTML = sides.map(function (side, index) {
      var selected = state.sidewalls[index];
      var previewProduct = side.products && side.products[0] ? side.products[0] : null;
      var previewVariant = previewProduct ? getMatchingAddonVariant(previewProduct, context, side.dimension) : null;
      var fallbackImage = sidewallFallbackImages[index] || '';
      return createTileMarkup({
        type: 'sidewall',
        index: index,
        isFilled: !!selected,
        image: selected ? selected.image : (fallbackImage || (previewVariant && previewVariant.image ? previewVariant.image : (previewProduct ? previewProduct.image : ''))),
        icon: '',
        title: selected ? selected.title : ('Select ' + side.dimension + ' Side'),
        subtitle: selected ? selected.subtitle : '',
        priceMarkup: selected ? createAddonPriceMarkup(selected.variant, {
          wrapper: 'hanso-product-addons__tile-price-wrapper',
          price: 'hanso-product-addons__tile-price',
          compare: 'hanso-product-addons__tile-compare-price product__price product__price--compare',
          save: 'hanso-product-addons__tile-save-badge product__price-savings',
        }) : '',
        actionIcon: selected ? window.HansoTheme.productAddonsIcons.cartTrash : window.HansoTheme.productAddonsIcons.plusSmall,
      });
    }).join('');
  }

  function renderAccessoryTiles() {
    if (!accessoryTiles) return;

    accessoryTiles.innerHTML = [0, 1].map(function (index) {
      var selected = state.accessories[index];
      return createTileMarkup({
        type: 'accessory',
        index: index,
        isFilled: !!selected,
        image: selected ? selected.image : '',
        icon: selected ? '' : window.HansoTheme.productAddonsIcons.collectionGrid,
        title: selected ? selected.title : 'Select Accessory',
        subtitle: selected ? selected.subtitle : '',
        priceMarkup: selected ? createAddonPriceMarkup(selected.variant, {
          wrapper: 'hanso-product-addons__tile-price-wrapper',
          price: 'hanso-product-addons__tile-price',
          compare: 'hanso-product-addons__tile-compare-price product__price product__price--compare',
          save: 'hanso-product-addons__tile-save-badge product__price-savings',
        }) : '',
        actionIcon: selected ? window.HansoTheme.productAddonsIcons.cartTrash : window.HansoTheme.productAddonsIcons.plusSmall,
      });
    }).join('');
  }

  function isAwningWaterGuardUpsell(upsell) {
    return productHandle === 'electric-retractable-awning' &&
      upsell &&
      (upsell.handle === 'waterguard-awning-water-baffle' || normalizeValue(upsell.title) === 'hanso water guard awning water baffle');
  }

  function getAwningWaterGuardVariant(upsell) {
    if (!isAwningWaterGuardUpsell(upsell) || !Array.isArray(upsell.variants) || !upsell.variants.length) {
      return null;
    }

    var optionMap = getCurrentOptionMap();
    var selectedSizeValue = getOptionMapValue(optionMap, ['awning size', 'size']);
    var selectedColorValue = getOptionMapValue(optionMap, ['frame color', 'color']);
    var selectedSize = selectedSizeValue ? normalizeDimensionValue(String(selectedSizeValue).split('x')[0]) : '';
    var selectedColor = normalizeValue(selectedColorValue);

    return upsell.variants.find(function (variant) {
      var variantOptions = variant.options || [];
      var titleParts = String(variant.public_title || variant.title || '').split('/');
      var variantSize = normalizeDimensionValue(variant.option1 || variantOptions[0] || titleParts[0] || '');
      var variantColor = normalizeValue(variant.option2 || variantOptions[1] || titleParts[1] || '');
      var matchesSize = selectedSize ? variantSize === selectedSize : true;
      var matchesColor = selectedColor ? variantColor === selectedColor : true;

      return matchesSize && matchesColor;
    }) || upsell.variants.find(function (variant) {
      var variantOptions = variant.options || [];
      var titleParts = String(variant.public_title || variant.title || '').split('/');
      var variantSize = normalizeDimensionValue(variant.option1 || variantOptions[0] || titleParts[0] || '');
      return selectedSize ? variantSize === selectedSize : false;
    }) || upsell.variants.find(function (variant) {
      return variant.available;
    }) || upsell.variants[0];
  }

  function getDefaultUpsellVariant(upsell) {
    if (!upsell || !Array.isArray(upsell.variants) || !upsell.variants.length) {
      return upsell;
    }

    return upsell.variants.find(function (variant) {
      return String(variant.id) === String(upsell.variantId);
    }) || upsell.variants.find(function (variant) {
      return variant.available;
    }) || upsell.variants[0];
  }

  function getResolvedUpsellVariant(upsell) {
    return getAwningWaterGuardVariant(upsell) || getDefaultUpsellVariant(upsell);
  }

  function getUpsellVariantFromData(upsell) {
    if (!upsell) return null;
    var variant = getResolvedUpsellVariant(upsell);

    return {
      id: variant.id || upsell.variantId,
      title: variant.public_title || variant.title || (Array.isArray(variant.options) ? variant.options.join(' / ') : ''),
      price: variant.price || formatAddonMoney(variant.price_raw),
      price_raw: Number(variant.price_raw) || 0,
      compare_at_price: variant.compare_at_price || '',
      compare_at_price_raw: Number(variant.compare_at_price_raw) || 0,
      save_text: variant.save_text || getAddonSavings(variant),
      image: variant.image || upsell.image || '',
    };
  }

  function renderUpgradeList() {
    if (!upgradeList || !hasOptionalUpgradeUpsells) return;

    upgradeList.innerHTML = mandatoryUpsells.map(function (upsell, index) {
      if (!upsell || upsell.available === false) return '';
      var isSelected = !!state.upgrades[index];
      var variant = getUpsellVariantFromData(upsell);
      var hasInfo = !!upsell.hasInfo;
      var upgradeVariantLabel = isAwningWaterGuardUpsell(upsell) && variant && variant.title ? variant.title : '';

      if (isSelected && variant) {
        state.upgrades[index].variantId = variant.id;
        state.upgrades[index].variant = variant;
        state.upgrades[index].image = variant.image || upsell.image || '';
      }

      return [
        '<button type="button" class="hanso-product-addons__upgrade-card' + (isSelected ? ' is-selected' : '') + (hasInfo ? ' has-info' : '') + '" data-hanso-upgrade-toggle data-upgrade-index="' + index + '" aria-pressed="' + (isSelected ? 'true' : 'false') + '">',
        '<span class="hanso-product-addons__upgrade-checkbox" aria-hidden="true">',
        '<svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M4.25 8.2L6.7 10.55L11.75 5.45" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>',
        '</span>',
        upsell.image ? '<span class="hanso-product-addons__upgrade-media"><img src="' + escapeAttribute(upsell.image) + '" alt="' + escapeAttribute(upsell.title || 'Upgrade') + '"></span>' : '',
        '<span class="hanso-product-addons__upgrade-copy">',
        '<span class="hanso-product-addons__upgrade-title">' + escapeAttribute(upsell.title || '') + '</span>',
        upgradeVariantLabel ? '<span class="hanso-product-addons__upgrade-variant-label">' + escapeAttribute(upgradeVariantLabel) + '</span>' : '',
        upsell.description ? '<span class="hanso-product-addons__upgrade-text">' + escapeAttribute(upsell.description) + '</span>' : '',
        createAddonPriceMarkup(variant, {
          wrapper: 'hanso-product-addons__upgrade-price-wrapper',
          price: 'hanso-product-addons__upgrade-price',
          compare: 'hanso-product-addons__upgrade-compare-price product__price product__price--compare',
          save: 'hanso-product-addons__upgrade-save-badge product__price-savings',
        }),
        '</span>',
        hasInfo ? '<span class="hanso-product-addons__upgrade-info" data-hanso-mandatory-upsell-open="mandatory-upsell-popup-' + escapeAttribute(addonsRoot.getAttribute('data-section-id') || '') + '-' + (index + 1) + '" role="button" tabindex="0" aria-label="Learn more about ' + escapeAttribute(upsell.title || 'upgrade') + '"><svg viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9 16.25C13.0041 16.25 16.25 13.0041 16.25 9C16.25 4.99594 13.0041 1.75 9 1.75C4.99594 1.75 1.75 4.99594 1.75 9C1.75 13.0041 4.99594 16.25 9 16.25Z" stroke="currentColor" stroke-width="1.5"/><path d="M9 8.25V12.25" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/><path d="M9 5.75H9.01" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg></span>' : '',
        '</button>',
      ].join('');
    }).join('');
  }

  function closeModal() {
    if (!modal) return;
    window.HansoTheme.utils.setScrollLock(false);
    if (typeof modal.close === 'function' && modal.open) {
      modal.close();
    }
    state.currentModal = null;
  }

  function openMandatoryUpsellModal(modalId) {
    var mandatoryModal = addonsRoot.querySelector('[data-hanso-mandatory-upsell-modal="' + modalId + '"]');
    if (!mandatoryModal) return;

    window.HansoTheme.utils.setScrollLock(true);
    if (typeof mandatoryModal.showModal === 'function') {
      mandatoryModal.showModal();
    } else {
      mandatoryModal.setAttribute('open', 'open');
    }
  }

  function closeMandatoryUpsellModal(mandatoryModal) {
    if (!mandatoryModal) return;

    window.HansoTheme.utils.setScrollLock(false);
    if (typeof mandatoryModal.close === 'function' && mandatoryModal.open) {
      mandatoryModal.close();
    } else {
      mandatoryModal.removeAttribute('open');
    }
  }

  function openModal(type, index) {
    if (!modal || !modalGrid || !modalTitle) return;

    state.currentModal = { type: type, index: index };
    var context = getCurrentContext();
    var items = [];

    if (type === 'sidewall') {
      var config = getMatchingSidewallConfig(context);
      var sides = getResolvedSides(config, context);
      var side = sides ? sides[index] : null;
      modalTitle.textContent = side ? ('Select ' + side.dimension + ' Side') : 'Select Sidewall';
      items = side && side.products ? side.products.reduce(function (list, product) {
        var variantsForProduct = getSidewallProductItems(product, context, side.dimension);
        var selectedVariant = getPreferredVariant(variantsForProduct, context);
        if (!selectedVariant) return list;
        var selectedPayload = getVariantPayload(product, selectedVariant);
        list.push({
          title: product.title,
          subtitle: selectedPayload.subtitle,
          description: product.description || '',
          image: selectedPayload.image,
          colorLabel: selectedPayload.colorLabel,
          hasVariantImage: selectedPayload.hasVariantImage,
          price: selectedPayload.price,
          compareAtPrice: selectedPayload.compareAtPrice,
          compareAtPriceRaw: selectedPayload.compareAtPriceRaw,
          saveText: selectedPayload.saveText,
          variant: selectedPayload.variant,
          variantId: selectedPayload.id,
          variantChoices: variantsForProduct.map(function (variant) {
            return getVariantPayload(product, variant);
          }),
        });
        return list;
      }, []) : [];
    } else {
      modalTitle.textContent = 'Select Accessory';
      items = accessories.map(function (product) {
        var variant = getMatchingAddonVariant(product, context, '');
        var variantChoices = product.variants && product.variants.length > 1 ? product.variants.map(function (candidate) {
          return getVariantPayload(product, candidate);
        }) : [];
        return variant ? {
          title: product.title,
          subtitle: getVariantPayload(product, variant).subtitle || '',
          description: product.description || '',
          image: variant.image || product.image || '',
          price: variant.price || '',
          compareAtPrice: variant.compare_at_price || '',
          compareAtPriceRaw: variant.compare_at_price_raw || 0,
          saveText: getAddonSavings(variant),
          variant: variant,
          variantId: variant.id,
          variantChoices: variantChoices,
        } : null;
      }).filter(Boolean);
    }

    if (!items.length) {
      modalGrid.innerHTML = '<div class="hanso-product-addons__empty">No add-ons available for this selection right now.</div>';
    } else {
      modalGrid.innerHTML = items.map(function (item) {
        var selectedPayload = getVariantPayload({ image: item.image, options: [] }, item.variant);
        selectedPayload.subtitle = item.subtitle || selectedPayload.subtitle;
        selectedPayload.image = item.image || selectedPayload.image;
        selectedPayload.price = item.price || selectedPayload.price;
        selectedPayload.compareAtPrice = item.compareAtPrice || selectedPayload.compareAtPrice;
        selectedPayload.compareAtPriceRaw = Number(item.compareAtPriceRaw) || selectedPayload.compareAtPriceRaw;
        selectedPayload.saveText = item.saveText || selectedPayload.saveText;
        var variantSelectMarkup = createVariantSelectMarkup(item);

        return [
          '<article class="hanso-product-addons__product-card">',
          item.image ? '<div class="hanso-product-addons__product-media"><img src="' + item.image + '" alt="' + item.title + '" data-addon-product-image></div>' : '',
          '<h4 class="hanso-product-addons__product-title">' + item.title + '</h4>',
          item.colorLabel && !variantSelectMarkup ? '<div class="hanso-product-addons__product-color">' + getColorSwatchMarkup(item.colorLabel, item.hasVariantImage) + '<span>' + item.colorLabel + '</span></div>' : '',
          variantSelectMarkup,
          item.description ? '<div class="hanso-product-addons__product-description">' + item.description + '</div>' : '',
          '<div class="hanso-product-addons__product-meta">',
          createAddonPriceMarkup(item.variant, {
            wrapper: 'hanso-product-addons__product-price-wrapper',
            price: 'hanso-product-addons__product-price',
            compare: 'hanso-product-addons__product-compare-price product__price product__price--compare',
            save: 'hanso-product-addons__product-save-badge product__price-savings',
          }),
          '<button type="button" class="hanso-product-addons__product-button" data-addon-select data-title="' + escapeAttribute(item.title) + '" ' + createVariantButtonAttributes(selectedPayload) + '>Add</button>',
          '</div>',
          '</article>',
        ].join('');
      }).join('');
    }

    if (typeof modal.showModal === 'function') {
      window.HansoTheme.utils.setScrollLock(true);
      modal.showModal();
    } else {
      window.HansoTheme.utils.setScrollLock(true);
      modal.setAttribute('open', 'open');
    }
  }

  function updateModalCardVariant(choiceInput) {
    if (!choiceInput) return;

    var choiceNode = choiceInput.matches && choiceInput.matches('select')
      ? choiceInput.selectedOptions[0]
      : choiceInput;
    if (!choiceNode) return;

    var card = choiceInput.closest('.hanso-product-addons__product-card');
    if (!card) return;

    var variant = {
      id: choiceNode.getAttribute('data-variant-id'),
      price: choiceNode.getAttribute('data-price'),
      price_raw: Number(choiceNode.getAttribute('data-price-raw')) || 0,
      compare_at_price: choiceNode.getAttribute('data-compare-price'),
      compare_at_price_raw: Number(choiceNode.getAttribute('data-compare-price-raw')) || 0,
      save_text: choiceNode.getAttribute('data-save-text') || '',
    };
    var image = choiceNode.getAttribute('data-image') || '';
    var productImage = card.querySelector('[data-addon-product-image]');
    var selectButton = card.querySelector('[data-addon-select]');
    var priceWrapper = card.querySelector('.hanso-product-addons__product-price-wrapper');

    if (productImage && image) {
      productImage.setAttribute('src', image);
    }

    if (selectButton) {
      [
        'variant-id',
        'subtitle',
        'image',
        'price',
        'price-raw',
        'compare-price',
        'compare-price-raw',
        'save-text',
      ].forEach(function (key) {
        var value = choiceNode.getAttribute('data-' + key);
        if (value !== null) {
          selectButton.setAttribute('data-' + key, value);
        }
      });
    }

    if (priceWrapper) {
      priceWrapper.outerHTML = createAddonPriceMarkup(variant, {
        wrapper: 'hanso-product-addons__product-price-wrapper',
        price: 'hanso-product-addons__product-price',
        compare: 'hanso-product-addons__product-compare-price product__price product__price--compare',
        save: 'hanso-product-addons__product-save-badge product__price-savings',
      });
    }
  }

  function renderAll() {
    renderSidewallTiles();
    renderAccessoryTiles();
    renderUpgradeList();
    syncAddonInputs();
    updateProductPricing();
  }

  function removeSelectedAddon(removeType, removeIndex) {
    var stateTypeMap = {
      sidewall: 'sidewalls',
      sidewalls: 'sidewalls',
      accessory: 'accessories',
      accessories: 'accessories',
    };
    var stateType = stateTypeMap[removeType] || removeType;
    var normalizedIndex = String(removeIndex);
    var removeIndexNumber = Number(removeIndex);
    var bucket = state[stateType];

    if (!bucket) return false;

    if (Object.prototype.hasOwnProperty.call(bucket, normalizedIndex)) {
      delete bucket[normalizedIndex];
    }

    if (!Number.isNaN(removeIndexNumber) && Object.prototype.hasOwnProperty.call(bucket, removeIndexNumber)) {
      delete bucket[removeIndexNumber];
    }

    renderAll();
    return true;
  }

  function handleRootClick(event) {
    var mandatoryInfoButton = event.target.closest('[data-hanso-mandatory-upsell-open]');
    if (mandatoryInfoButton) {
      event.preventDefault();
      event.stopPropagation();
      openMandatoryUpsellModal(mandatoryInfoButton.getAttribute('data-hanso-mandatory-upsell-open'));
      return;
    }

    var upgradeToggle = event.target.closest('[data-hanso-upgrade-toggle]');
    if (upgradeToggle) {
      var upgradeIndex = upgradeToggle.getAttribute('data-upgrade-index');
      var upgrade = mandatoryUpsells[upgradeIndex];
      if (!upgrade || upgrade.available === false) return;

      if (state.upgrades[upgradeIndex]) {
        delete state.upgrades[upgradeIndex];
      } else {
        var upgradeVariant = getUpsellVariantFromData(upgrade);
        state.upgrades[upgradeIndex] = {
          variantId: upgradeVariant ? upgradeVariant.id : upgrade.variantId,
          title: upgrade.title,
          image: upgradeVariant && upgradeVariant.image ? upgradeVariant.image : (upgrade.image || ''),
          variant: upgradeVariant,
        };
      }

      renderAll();
      return;
    }

    var mandatoryCloseButton = event.target.closest('[data-hanso-mandatory-upsell-close]');
    if (mandatoryCloseButton) {
      closeMandatoryUpsellModal(mandatoryCloseButton.closest('[data-hanso-mandatory-upsell-modal]'));
      return;
    }

    var openButton = event.target.closest('[data-addon-open]');
    if (openButton) {
      openModal(openButton.getAttribute('data-addon-type'), Number(openButton.getAttribute('data-addon-index')));
      return;
    }

    var selectButton = event.target.closest('[data-addon-select]');
    if (selectButton && state.currentModal) {
      var destination = state.currentModal.type === 'sidewall' ? state.sidewalls : state.accessories;
      destination[state.currentModal.index] = {
        variantId: selectButton.getAttribute('data-variant-id'),
        title: selectButton.getAttribute('data-title'),
        subtitle: selectButton.getAttribute('data-subtitle'),
        image: selectButton.getAttribute('data-image'),
        variant: {
          id: selectButton.getAttribute('data-variant-id'),
          price: selectButton.getAttribute('data-price'),
          price_raw: Number(selectButton.getAttribute('data-price-raw')) || 0,
          compare_at_price: selectButton.getAttribute('data-compare-price'),
          compare_at_price_raw: Number(selectButton.getAttribute('data-compare-price-raw')) || 0,
          save_text: selectButton.getAttribute('data-save-text') || '',
        },
      };
      closeModal();
      renderAll();
      return;
    }

    if (event.target.closest('[data-hanso-addon-modal-close]')) {
      closeModal();
    }
  }

  function handleRootChange(event) {
    var variantSelect = event.target.closest('[data-addon-variant-select]');
    if (!variantSelect) return;

    updateModalCardVariant(variantSelect);
  }

  function handleVariantChange() {
    var selectedVariant = getSelectedVariant();
    if (state.selectionIsTransient) {
      renderUpgradeList();
      syncAddonInputs();
      return;
    }

    var selectedVariantId = selectedVariant && selectedVariant.id ? String(selectedVariant.id) : '';
    if (selectedVariantId !== state.currentVariantId) {
      state.sidewalls = {};
      state.currentVariantId = selectedVariantId;
    }

    renderAll();
  }

  function scheduleVariantChange() {
    if (state.variantSyncFrame) {
      window.cancelAnimationFrame(state.variantSyncFrame);
    }
    if (state.variantSyncTimer) {
      window.clearTimeout(state.variantSyncTimer);
    }

    state.variantSyncFrame = window.requestAnimationFrame(function () {
      state.variantSyncFrame = null;
      handleVariantChange();
    });
    state.variantSyncTimer = window.setTimeout(function () {
      state.variantSyncTimer = null;
      handleVariantChange();
    }, 80);
  }

  addonsRoot.addEventListener('click', handleRootClick);
  addonsRoot.addEventListener('change', handleRootChange);
  function handleAddonRemoveClick(event) {
    var removeButton = event.target.closest('[data-addon-remove], .hanso-product-addons__tile-remove');
    if (!removeButton) return;

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    var removeTile = removeButton.closest('[data-addon-tile], .hanso-product-addons__tile.is-filled');
    var removeType = removeButton.getAttribute('data-addon-remove-type') || (removeTile && removeTile.getAttribute('data-addon-type'));
    var removeIndex = removeButton.getAttribute('data-addon-remove-index') || (removeTile && removeTile.getAttribute('data-addon-index'));

    removeSelectedAddon(removeType, removeIndex);
  }

  addonsRoot.addEventListener('pointerdown', handleAddonRemoveClick, true);
  addonsRoot.addEventListener('click', handleAddonRemoveClick, true);
  addonsRoot.addEventListener('keydown', function (event) {
    if (event.key !== 'Enter' && event.key !== ' ') return;

    var removeButton = event.target.closest('[data-addon-remove]');
    if (!removeButton) return;

    handleAddonRemoveClick(event);
  });
  variantInputs.forEach(function (input) {
    input.addEventListener('change', scheduleVariantChange);
  });
  if (typeof subscribe === 'function' && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.optionValueSelectionChange) {
    state.optionChangeUnsubscriber = subscribe(window.PUB_SUB_EVENTS.optionValueSelectionChange, function (event) {
      if (!event || !event.data || !event.data.event || !section.contains(event.data.event.target)) {
        return;
      }

      scheduleVariantChange();
    });
  }
  if (typeof subscribe === 'function' && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.variantChange) {
    state.variantChangeUnsubscriber = subscribe(window.PUB_SUB_EVENTS.variantChange, function (event) {
      if (!event || !event.data || String(event.data.sectionId) !== String(section.getAttribute('data-section'))) {
        return;
      }

      var confirmedVariant = event.data.variant;
      var localVariant = confirmedVariant && variants.find(function (variant) {
        return String(variant.id) === String(confirmedVariant.id);
      });

      if (localVariant) {
        state.lastValidVariant = localVariant;
      }
      scheduleVariantChange();
    });
  }
  if (modal) {
    modal.addEventListener('click', function (event) {
      if (event.target === modal) {
        closeModal();
      }
    });
    modal.addEventListener('close', function () {
      window.HansoTheme.utils.setScrollLock(false);
    });
    modal.addEventListener('cancel', function () {
      window.HansoTheme.utils.setScrollLock(false);
    });
  }

  Array.prototype.slice.call(addonsRoot.querySelectorAll('[data-hanso-mandatory-upsell-modal]')).forEach(function (mandatoryModal) {
    mandatoryModal.addEventListener('click', function (event) {
      if (event.target === mandatoryModal) {
        closeMandatoryUpsellModal(mandatoryModal);
      }
    });
    mandatoryModal.addEventListener('close', function () {
      window.HansoTheme.utils.setScrollLock(false);
    });
    mandatoryModal.addEventListener('cancel', function () {
      window.HansoTheme.utils.setScrollLock(false);
    });
  });

  state.lastValidVariant = getSelectedVariant();
  state.currentVariantId = state.lastValidVariant && state.lastValidVariant.id ? String(state.lastValidVariant.id) : '';
  renderAll();
  window.HansoTheme.productAddons.set(section, {
    root: addonsRoot,
    variantInputs: variantInputs,
    optionChangeUnsubscriber: state.optionChangeUnsubscriber,
    variantChangeUnsubscriber: state.variantChangeUnsubscriber,
    handleRootClick: handleRootClick,
    handleRootChange: handleRootChange,
    handleVariantChange: scheduleVariantChange,
    variantSyncState: state,
    modal: modal,
  });
};

window.HansoTheme.initProductMainFaq = function initProductMainFaq(section) {
  if (!section || window.HansoTheme.productMainFaqs.has(section)) return;
  var items = Array.prototype.slice.call(section.querySelectorAll('[data-product-main-faq-item]'));
  if (!items.length) return;
  var faqCarouselStates = window.HansoTheme.initFaqImageCarousels(section);
  window.HansoTheme.initPdpFullVideos(section);

  function openItem(item) {
    var answer = item.querySelector('[data-product-main-faq-answer]');
    var question = item.querySelector('[data-product-main-faq-question]');
    if (!answer || !question) return;
    item.classList.add('is-open');
    question.setAttribute('aria-expanded', 'true');
    answer.hidden = false;
    window.HansoTheme.initPdpFullVideos(item);
    window.HansoTheme.resizeFaqImageCarousels(item);
    answer.style.height = '0px';
    void answer.offsetHeight;
    answer.style.transition = 'height 260ms ease';
    answer.style.height = answer.scrollHeight + 'px';
    window.setTimeout(function () {
      if (!item.classList.contains('is-open')) return;
      window.HansoTheme.resizeFaqImageCarousels(item);
      answer.style.height = 'auto';
    }, 260);
  }

  function closeItem(item, instant) {
    var answer = item.querySelector('[data-product-main-faq-answer]');
    var question = item.querySelector('[data-product-main-faq-question]');
    if (!answer || !question) return;
    item.classList.remove('is-open');
    question.setAttribute('aria-expanded', 'false');

    if (instant) {
      answer.style.transition = 'none';
      answer.style.height = '0px';
      answer.hidden = true;
      window.requestAnimationFrame(function () {
        answer.style.transition = '';
      });
      return;
    }

    answer.style.height = answer.scrollHeight + 'px';
    void answer.offsetHeight;
    answer.style.transition = 'height 260ms ease';
    answer.style.height = '0px';
    window.setTimeout(function () {
      if (item.classList.contains('is-open')) return;
      answer.hidden = true;
    }, 260);
  }

  items.forEach(function (item) {
    var question = item.querySelector('[data-product-main-faq-question]');
    var answer = item.querySelector('[data-product-main-faq-answer]');
    if (!question || !answer) return;
    question.addEventListener('click', function () {
      if (item.classList.contains('is-open')) {
        closeItem(item);
        return;
      }
      var questionTop = question.getBoundingClientRect().top;
      var group = item.closest('[data-product-main-faq]');
      var groupItems = group
        ? Array.prototype.slice.call(group.querySelectorAll('[data-product-main-faq-item]'))
        : items;
      groupItems.forEach(function (otherItem) {
        if (otherItem !== item) closeItem(otherItem, true);
      });
      var questionTopAfterSiblingClose = question.getBoundingClientRect().top;
      var scrollDelta = questionTopAfterSiblingClose - questionTop;
      if (Math.abs(scrollDelta) > 1) {
        window.scrollBy(0, scrollDelta);
      }
      openItem(item);
    });

    if (item.classList.contains('is-open') || question.getAttribute('aria-expanded') === 'true') {
      item.classList.add('is-open');
      answer.hidden = false;
      answer.style.height = 'auto';
      window.HansoTheme.initPdpFullVideos(item);
      window.HansoTheme.resizeFaqImageCarousels(item);
    } else {
      answer.hidden = true;
      answer.style.height = '0px';
    }
  });

  window.HansoTheme.productMainFaqs.set(section, {
    faqCarouselStates: faqCarouselStates,
  });
};

window.HansoTheme.destroyProductMainFaq = function destroyProductMainFaq(section) {
  if (!section || !window.HansoTheme.productMainFaqs.has(section)) return;
  var state = window.HansoTheme.productMainFaqs.get(section);
  if (state && state.faqCarouselStates) {
    state.faqCarouselStates.forEach(function (carouselState) {
      if (carouselState && carouselState.track) {
        window.HansoTheme.destroyFlickityInstance(carouselState.track);
      }
    });
  }
  Array.prototype.slice.call(section.querySelectorAll('[data-pdp-full-video-section]')).forEach(function (videoSection) {
    window.HansoTheme.destroyPdpFullVideo(videoSection);
  });
  window.HansoTheme.productMainFaqs.delete(section);
};

window.HansoTheme.initProductAddonsSections = function initProductAddonsSections(scope) {
  var root = scope || document;
  var sections = root.querySelectorAll('[data-hanso-product-main]');
  sections.forEach(function (section) {
    window.HansoTheme.initProductAddons(section);
  });
};

window.HansoTheme.destroyProductAddons = function destroyProductAddons(section) {
  if (!section || !window.HansoTheme.productAddons.has(section)) {
    return;
  }

  var state = window.HansoTheme.productAddons.get(section);
  if (state && state.root && state.handleRootClick) {
    state.root.removeEventListener('click', state.handleRootClick);
  }
  if (state && state.root && state.handleRootChange) {
    state.root.removeEventListener('change', state.handleRootChange);
  }
  if (state && state.variantInputs && state.handleVariantChange) {
    state.variantInputs.forEach(function (input) {
      input.removeEventListener('change', state.handleVariantChange);
    });
  }
  if (state && typeof state.optionChangeUnsubscriber === 'function') {
    state.optionChangeUnsubscriber();
  }
  if (state && typeof state.variantChangeUnsubscriber === 'function') {
    state.variantChangeUnsubscriber();
  }
  if (state && state.variantSyncState) {
    if (state.variantSyncState.variantSyncFrame) {
      window.cancelAnimationFrame(state.variantSyncState.variantSyncFrame);
    }
    if (state.variantSyncState.variantSyncTimer) {
      window.clearTimeout(state.variantSyncState.variantSyncTimer);
    }
  }
  if (state && state.modal && typeof state.modal.close === 'function' && state.modal.open) {
    state.modal.close();
  }
  window.HansoTheme.productAddons.delete(section);
};

window.HansoTheme.destroyGallerySlider = function destroyGallerySlider(section) {
  if (!section) {
    return;
  }

  var track = section.querySelector('[data-gallery-slider-track]');

  if (track) {
    window.HansoTheme.destroyFlickityInstance(track);
  }

  if (window.HansoTheme.gallerySliders.has(section)) {
    var state = window.HansoTheme.gallerySliders.get(section);
    if (state && state.autoplayState) {
      state.autoplayState.destroy();
    }
    window.HansoTheme.gallerySliders.delete(section);
  }
};

window.HansoTheme.initCarouselGallery = function initCarouselGallery(section) {
  if (!section || window.HansoTheme.carouselGalleries.has(section)) {
    return;
  }

  var track = section.querySelector('[data-carousel-gallery-track]');
  var items = Array.prototype.slice.call(section.querySelectorAll('[data-carousel-gallery-item]'));
  var barsWrap = section.querySelector('[data-carousel-gallery-bars]');
  var prevButton = section.querySelector('[data-carousel-gallery-prev]');
  var nextButton = section.querySelector('[data-carousel-gallery-next]');

  if (!track || !items.length || !barsWrap) {
    return;
  }

  var flkty = window.HansoTheme.getFlickityInstance(track, {
    cellAlign: 'left',
    contain: true,
    draggable: items.length > 1,
    pageDots: false,
    prevNextButtons: false,
    wrapAround: false,
    imagesLoaded: true,
    percentPosition: true,
    setGallerySize: true,
    selectedAttraction: 0.018,
    friction: 0.22,
    dragThreshold: 8,
  });

  if (!flkty) {
    return;
  }

  barsWrap.innerHTML = '';

  function getBarTargets() {
    return window.HansoTheme.getCarouselTargetIndexes(section, items.length);
  }

  function getCurrentTargetPosition() {
    return window.HansoTheme.getCarouselTargetPosition(flkty.selectedIndex, getBarTargets());
  }

  var barTargets = getBarTargets();
  var bars = barTargets.map(function (targetIndex, index) {
    var bar = document.createElement('button');
    bar.type = 'button';
    bar.className = 'hanso-carousel-gallery__bar';
    bar.setAttribute('aria-label', 'Go to gallery item ' + (index + 1));
    bar.addEventListener('click', function () {
      flkty.select(targetIndex);
    });
    barsWrap.appendChild(bar);
    return bar;
  });

  var autoplayState = window.HansoTheme.createCarouselAutoplay(section, flkty, getBarTargets, getCurrentTargetPosition);

  function updateBars() {
    var currentPosition = getCurrentTargetPosition();
    bars.forEach(function (bar, index) {
      var isActive = index === currentPosition;
      bar.classList.toggle('is-active', isActive);
      bar.classList.toggle('is-loading', !!(autoplayState && autoplayState.enabled && isActive));
    });
  }

  function updateButtons() {
    var targets = getBarTargets();
    var currentPosition = getCurrentTargetPosition();
    if (prevButton) prevButton.disabled = currentPosition === 0;
    if (nextButton) nextButton.disabled = currentPosition >= targets.length - 1;
  }

  if (prevButton) {
    prevButton.addEventListener('click', function () {
      var targets = getBarTargets();
      var currentPosition = getCurrentTargetPosition();
      var previousPosition = Math.max(0, currentPosition - 1);
      flkty.select(targets[previousPosition]);
    });
  }

  if (nextButton) {
    nextButton.addEventListener('click', function () {
      var targets = getBarTargets();
      var currentPosition = getCurrentTargetPosition();
      var nextPosition = Math.min(targets.length - 1, currentPosition + 1);
      flkty.select(targets[nextPosition]);
    });
  }

  flkty.on('select', function () {
    updateBars();
    updateButtons();
    if (autoplayState) {
      autoplayState.restart();
    }
  });

  updateBars();
  updateButtons();
  flkty.resize();

  if (autoplayState) {
    autoplayState.start();
  }

  window.HansoTheme.carouselGalleries.set(section, {
    flkty: flkty,
    autoplayState: autoplayState,
  });
};

window.HansoTheme.initCarouselGalleries = function initCarouselGalleries(scope) {
  var root = scope || document;
  var sections = root.querySelectorAll('[data-carousel-gallery-section]');

  sections.forEach(function (section) {
    window.HansoTheme.initCarouselGallery(section);
  });
};

window.HansoTheme.destroyCarouselGallery = function destroyCarouselGallery(section) {
  if (!section) {
    return;
  }

  var track = section.querySelector('[data-carousel-gallery-track]');

  if (track) {
    window.HansoTheme.destroyFlickityInstance(track);
  }

  if (window.HansoTheme.carouselGalleries.has(section)) {
    var state = window.HansoTheme.carouselGalleries.get(section);
    if (state && state.autoplayState) {
      state.autoplayState.destroy();
    }
    window.HansoTheme.carouselGalleries.delete(section);
  }
};

window.HansoTheme.initCollectionPergolaGrid = function initCollectionPergolaGrid(section) {
  if (!section || window.HansoTheme.collectionPergolaGrids.has(section)) {
    return;
  }

  var track = section.querySelector('[data-collection-pergola-grid-track]');
  var cards = Array.prototype.slice.call(section.querySelectorAll('[data-collection-pergola-grid-card]'));
  var controls = section.querySelector('[data-collection-pergola-grid-controls]');
  var dotsWrap = section.querySelector('[data-collection-pergola-grid-dots]');
  var arrowsWrap = section.querySelector('[data-collection-pergola-grid-arrows]');

  if (!track || !cards.length || !controls || !dotsWrap || !arrowsWrap) {
    return;
  }

  var state = {
    flkty: null,
    resizeTimer: null,
    delayedTimers: [],
    handleResize: null,
    lastHeight: 0,
    lastViewportWidth: document.documentElement.clientWidth || window.innerWidth,
  };

  function clearDelayedTimers() {
    state.delayedTimers.forEach(function (timerId) {
      window.clearTimeout(timerId);
    });
    state.delayedTimers = [];
  }

  function clearHeights() {
    state.lastHeight = 0;
    track.style.removeProperty('--collection-pergola-card-min-height');

    cards.forEach(function (card) {
      card.style.minHeight = '';
    });

    var viewport = track.querySelector('.flickity-viewport');
    if (viewport) {
      viewport.style.height = '';
      viewport.style.minHeight = '';
    }
  }

  function syncHeights() {
    if (!window.matchMedia('(max-width: 767px)').matches) {
      clearHeights();
      return;
    }

    window.requestAnimationFrame(function () {
      var tallest = 0;

      cards.forEach(function (card) {
        card.style.minHeight = '';
      });

      cards.forEach(function (card) {
        tallest = Math.max(tallest, Math.ceil(card.getBoundingClientRect().height), card.scrollHeight);
      });

      if (!tallest) {
        return;
      }

      if (Math.abs(tallest - state.lastHeight) <= 1) {
        cards.forEach(function (card) {
          card.style.minHeight = state.lastHeight + 'px';
        });

        var stableViewport = track.querySelector('.flickity-viewport');
        if (stableViewport) {
          stableViewport.style.height = state.lastHeight + 'px';
          stableViewport.style.minHeight = state.lastHeight + 'px';
        }
        return;
      }

      state.lastHeight = tallest;
      track.style.setProperty('--collection-pergola-card-min-height', tallest + 'px');

      cards.forEach(function (card) {
        card.style.minHeight = tallest + 'px';
      });

      var viewport = track.querySelector('.flickity-viewport');
      if (viewport) {
        viewport.style.height = tallest + 'px';
        viewport.style.minHeight = tallest + 'px';
      }
    });
  }

  function resetControls() {
    dotsWrap.innerHTML = '';
    arrowsWrap.innerHTML = '';
    controls.classList.remove('is-active');
  }

  function buildControls(flkty) {
    if (!flkty || cards.length < 2) {
      resetControls();
      return;
    }

    controls.classList.add('is-active');

    dotsWrap.innerHTML = cards
      .map(function (_, index) {
        return (
          '<button type="button" class="hanso-collection-pergola-grid__bar' +
          (index === 0 ? ' is-active' : '') +
          '" aria-label="Go to pergola ' +
          (index + 1) +
          '" data-index="' +
          index +
          '"></button>'
        );
      })
      .join('');

    arrowsWrap.innerHTML =
      '<button class="hanso-collection-pergola-grid__arrow hanso-collection-pergola-grid__arrow--prev slider-prev" aria-label="Previous slide" type="button">' +
      '<span class="hanso-collection-pergola-grid__arrow-icon hanso-collection-pergola-grid__arrow-icon--prev">' +
      '<svg xmlns="http://www.w3.org/2000/svg" class="hanso-collection-pergola-grid__arrow-svg" width="7" height="12" viewBox="0 0 7 12" fill="none">' +
      '<path d="M1 10.4133L5.69333 5.70667L1 1" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>' +
      '</svg></span></button>' +
      '<button class="hanso-collection-pergola-grid__arrow slider-next" aria-label="Next slide" type="button">' +
      '<span class="hanso-collection-pergola-grid__arrow-icon">' +
      '<svg xmlns="http://www.w3.org/2000/svg" class="hanso-collection-pergola-grid__arrow-svg" width="7" height="12" viewBox="0 0 7 12" fill="none">' +
      '<path d="M1 10.4133L5.69333 5.70667L1 1" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>' +
      '</svg></span></button>';

    var prevButton = arrowsWrap.querySelector('.slider-prev');
    var nextButton = arrowsWrap.querySelector('.slider-next');
    var dotButtons = Array.prototype.slice.call(dotsWrap.querySelectorAll('button[data-index]'));

    function updateControls() {
      dotButtons.forEach(function (button, index) {
        var isActive = index === flkty.selectedIndex;
        button.classList.toggle('is-active', isActive);
      });

      if (prevButton) {
        prevButton.disabled = flkty.selectedIndex === 0;
      }

      if (nextButton) {
        nextButton.disabled = flkty.selectedIndex === cards.length - 1;
      }
    }

    if (prevButton) {
      prevButton.addEventListener('click', function () {
        flkty.previous();
      });
    }

    if (nextButton) {
      nextButton.addEventListener('click', function () {
        flkty.next();
      });
    }

    dotButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        flkty.select(Number(button.dataset.index || 0));
      });
    });

    flkty.on('select', updateControls);
    updateControls();
  }

  function setupSlider() {
    var isMobile = window.matchMedia('(max-width: 767px)').matches;
    var selectedIndex = state.flkty ? state.flkty.selectedIndex : 0;

    clearDelayedTimers();

    if (state.flkty) {
      window.HansoTheme.destroyFlickityInstance(track);
      state.flkty = null;
    }

    if (!isMobile) {
      resetControls();
      clearHeights();
      return;
    }

    state.flkty = window.HansoTheme.getFlickityInstance(track, {
      cellAlign: 'left',
      contain: true,
      wrapAround: false,
      pageDots: false,
      prevNextButtons: false,
      draggable: cards.length > 1,
      imagesLoaded: true,
      percentPosition: true,
      setGallerySize: false,
      selectedAttraction: 0.018,
      friction: 0.24,
      dragThreshold: 8,
    });

    if (!state.flkty) {
      resetControls();
      return;
    }

    buildControls(state.flkty);
    if (selectedIndex > 0) {
      state.flkty.select(Math.min(selectedIndex, cards.length - 1), false, true);
    }
    syncHeights();

    state.flkty.on('ready', syncHeights);
    state.flkty.on('settle', syncHeights);
    state.flkty.resize();

    [120, 350, 800].forEach(function (delay) {
      state.delayedTimers.push(
        window.setTimeout(function () {
          syncHeights();
          if (state.flkty) {
            state.flkty.resize();
          }
        }, delay)
      );
    });
  }

  state.handleResize = function handleResize() {
    var viewportWidth = document.documentElement.clientWidth || window.innerWidth;

    // Mobile browser chrome changes viewport height while scrolling. Rebuilding
    // Flickity for those height-only resize events resets the active card.
    if (Math.abs(viewportWidth - state.lastViewportWidth) <= 2) {
      return;
    }

    state.lastViewportWidth = viewportWidth;

    if (state.resizeTimer) {
      window.clearTimeout(state.resizeTimer);
    }

    state.resizeTimer = window.setTimeout(setupSlider, 140);
  };

  window.addEventListener('resize', state.handleResize);
  setupSlider();
  window.HansoTheme.collectionPergolaGrids.set(section, state);
};

window.HansoTheme.initCollectionPergolaGrids = function initCollectionPergolaGrids(scope) {
  var root = scope || document;
  var sections = root.querySelectorAll('[data-collection-pergola-grid-section]');

  sections.forEach(function (section) {
    window.HansoTheme.initCollectionPergolaGrid(section);
  });
};

window.HansoTheme.destroyCollectionPergolaGrid = function destroyCollectionPergolaGrid(section) {
  if (!section || !window.HansoTheme.collectionPergolaGrids.has(section)) {
    return;
  }

  var state = window.HansoTheme.collectionPergolaGrids.get(section);
  var track = section.querySelector('[data-collection-pergola-grid-track]');
  var dotsWrap = section.querySelector('[data-collection-pergola-grid-dots]');
  var arrowsWrap = section.querySelector('[data-collection-pergola-grid-arrows]');
  var controls = section.querySelector('[data-collection-pergola-grid-controls]');
  var cards = section.querySelectorAll('[data-collection-pergola-grid-card]');

  if (state && state.resizeTimer) {
    window.clearTimeout(state.resizeTimer);
  }

  if (state && state.delayedTimers) {
    state.delayedTimers.forEach(function (timerId) {
      window.clearTimeout(timerId);
    });
  }

  if (state && state.handleResize) {
    window.removeEventListener('resize', state.handleResize);
  }

  if (track) {
    window.HansoTheme.destroyFlickityInstance(track);
    var viewport = track.querySelector('.flickity-viewport');
    if (viewport) {
      viewport.style.height = '';
      viewport.style.minHeight = '';
    }
  }

  cards.forEach(function (card) {
    card.style.minHeight = '';
  });

  if (dotsWrap) {
    dotsWrap.innerHTML = '';
  }

  if (arrowsWrap) {
    arrowsWrap.innerHTML = '';
  }

  if (controls) {
    controls.classList.remove('is-active');
  }

  window.HansoTheme.collectionPergolaGrids.delete(section);
};

window.HansoTheme.initLouverTechnologySection = function initLouverTechnologySection(section) {
  if (!section || window.HansoTheme.louverTechnologySections.has(section)) {
    return;
  }

  var track = section.querySelector('[data-louver-technology-track]');
  var items = Array.prototype.slice.call(section.querySelectorAll('[data-louver-technology-item]'));
  var controls = section.querySelector('[data-louver-technology-controls]');
  var barsWrap = section.querySelector('[data-louver-technology-bars]');
  var arrowsWrap = section.querySelector('[data-louver-technology-arrows]');
  var forceCarousel = section.dataset.forceCarousel === 'true';

  if (!track || !items.length || !controls || !barsWrap || !arrowsWrap) {
    return;
  }

  var state = {
    flkty: null,
    resizeTimer: null,
    handleResize: null,
  };

  function resetControls() {
    barsWrap.innerHTML = '';
    arrowsWrap.innerHTML = '';
    controls.classList.remove('is-active');
  }

  function applyResponsiveModeFlag() {
    var isDesktop = window.matchMedia('(min-width: 992px)').matches;
    section.dataset.desktopCarousel = isDesktop && (forceCarousel || items.length > 3) ? 'true' : 'false';
  }

  function buildControls(flkty) {
    var targets = window.HansoTheme.getCarouselTargetIndexes(section, items.length);

    if (!flkty || !targets.length || (window.matchMedia('(min-width: 992px)').matches && items.length <= 3 && !forceCarousel)) {
      resetControls();
      return;
    }

    controls.classList.add('is-active');
    barsWrap.innerHTML = '';
    arrowsWrap.innerHTML = '';

    function getTargets() {
      return window.HansoTheme.getCarouselTargetIndexes(section, items.length);
    }

    function getCurrentTargetPosition() {
      return window.HansoTheme.getCarouselTargetPosition(flkty.selectedIndex, getTargets());
    }

    var bars = getTargets().map(function (targetIndex, index) {
      var bar = document.createElement('button');
      bar.type = 'button';
      bar.className = 'hanso-louver-technology__bar';
      bar.setAttribute('aria-label', 'Go to feature ' + (index + 1));
      bar.addEventListener('click', function () {
        flkty.select(targetIndex);
      });
      barsWrap.appendChild(bar);
      return bar;
    });

    var prevButton = document.createElement('button');
    prevButton.type = 'button';
    prevButton.className = 'hanso-louver-technology__arrow';
    prevButton.setAttribute('aria-label', 'Previous feature');
    prevButton.innerHTML =
      '<span class="hanso-louver-technology__arrow-icon hanso-louver-technology__arrow-icon--prev"><svg class="hanso-louver-technology__arrow-svg" viewBox="0 0 7 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 10.4133L5.69333 5.70667L1 1" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path></svg></span>';

    var nextButton = document.createElement('button');
    nextButton.type = 'button';
    nextButton.className = 'hanso-louver-technology__arrow';
    nextButton.setAttribute('aria-label', 'Next feature');
    nextButton.innerHTML =
      '<span class="hanso-louver-technology__arrow-icon"><svg class="hanso-louver-technology__arrow-svg" viewBox="0 0 7 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 10.4133L5.69333 5.70667L1 1" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path></svg></span>';

    arrowsWrap.appendChild(prevButton);
    arrowsWrap.appendChild(nextButton);

    function updateBars() {
      var currentPosition = getCurrentTargetPosition();
      bars.forEach(function (bar, index) {
        bar.classList.toggle('is-active', currentPosition === index);
      });
    }

    function updateButtons() {
      var currentPosition = getCurrentTargetPosition();
      var currentTargets = getTargets();
      prevButton.disabled = currentPosition === 0;
      nextButton.disabled = currentPosition >= currentTargets.length - 1;
    }

    prevButton.addEventListener('click', function () {
      var currentTargets = getTargets();
      var currentPosition = getCurrentTargetPosition();
      flkty.select(currentTargets[Math.max(0, currentPosition - 1)]);
    });

    nextButton.addEventListener('click', function () {
      var currentTargets = getTargets();
      var currentPosition = getCurrentTargetPosition();
      flkty.select(currentTargets[Math.min(currentTargets.length - 1, currentPosition + 1)]);
    });

    flkty.on('select', function () {
      updateBars();
      updateButtons();
    });

    updateBars();
    updateButtons();
  }

  function setupCarousel() {
    applyResponsiveModeFlag();

    var isDesktop = window.matchMedia('(min-width: 992px)').matches;
    var shouldCarousel = !isDesktop || forceCarousel || items.length > 3;

    if (!shouldCarousel) {
      if (state.flkty) {
        window.HansoTheme.destroyFlickityInstance(track);
        state.flkty = null;
      }
      resetControls();
      return;
    }

    if (state.flkty) {
      window.HansoTheme.destroyFlickityInstance(track);
      state.flkty = null;
    }

    state.flkty = window.HansoTheme.getFlickityInstance(track, {
      cellAlign: 'left',
      contain: true,
      wrapAround: false,
      pageDots: false,
      prevNextButtons: false,
      draggable: items.length > 1,
      imagesLoaded: true,
      percentPosition: true,
      setGallerySize: true,
      selectedAttraction: 0.018,
      friction: 0.24,
      dragThreshold: 8,
    });

    if (!state.flkty) {
      resetControls();
      return;
    }

    buildControls(state.flkty);
    state.flkty.resize();
  }

  state.handleResize = function handleResize() {
    if (state.resizeTimer) {
      window.clearTimeout(state.resizeTimer);
    }

    state.resizeTimer = window.setTimeout(function () {
      setupCarousel();
    }, 120);
  };

  setupCarousel();
  window.addEventListener('resize', state.handleResize);
  window.HansoTheme.louverTechnologySections.set(section, state);
};

window.HansoTheme.initLouverTechnologySections = function initLouverTechnologySections(scope) {
  var root = scope || document;
  var sections = root.querySelectorAll('[data-louver-technology-section]');

  sections.forEach(function (section) {
    window.HansoTheme.initLouverTechnologySection(section);
  });
};

window.HansoTheme.destroyLouverTechnologySection = function destroyLouverTechnologySection(section) {
  if (!section || !window.HansoTheme.louverTechnologySections.has(section)) {
    return;
  }

  var state = window.HansoTheme.louverTechnologySections.get(section);
  var track = section.querySelector('[data-louver-technology-track]');
  var barsWrap = section.querySelector('[data-louver-technology-bars]');
  var arrowsWrap = section.querySelector('[data-louver-technology-arrows]');
  var controls = section.querySelector('[data-louver-technology-controls]');

  if (state && state.resizeTimer) {
    window.clearTimeout(state.resizeTimer);
  }

  if (state && state.handleResize) {
    window.removeEventListener('resize', state.handleResize);
  }

  if (track) {
    window.HansoTheme.destroyFlickityInstance(track);
  }

  if (barsWrap) {
    barsWrap.innerHTML = '';
  }

  if (arrowsWrap) {
    arrowsWrap.innerHTML = '';
  }

  if (controls) {
    controls.classList.remove('is-active');
  }

  window.HansoTheme.louverTechnologySections.delete(section);
};

window.HansoTheme.initPdpLouverFeatureGrid = function initPdpLouverFeatureGrid(section) {
  if (!section || window.HansoTheme.pdpLouverFeatureGrids.has(section)) {
    return;
  }

  var track = section.querySelector('[data-pdp-louver-feature-grid-track]');
  var items = Array.prototype.slice.call(section.querySelectorAll('[data-pdp-louver-feature-grid-item]'));
  var controls = section.querySelector('[data-pdp-louver-feature-grid-controls]');
  var barsWrap = section.querySelector('[data-pdp-louver-feature-grid-bars]');
  var arrowsWrap = section.querySelector('[data-pdp-louver-feature-grid-arrows]');

  if (!track || !items.length || !controls || !barsWrap || !arrowsWrap) {
    return;
  }

  var state = {
    flkty: null,
    resizeTimer: null,
    handleResize: null,
  };

  function resetControls() {
    barsWrap.innerHTML = '';
    arrowsWrap.innerHTML = '';
    controls.classList.remove('is-active');
  }

  function buildControls(flkty) {
    if (!flkty) {
      resetControls();
      return;
    }

    controls.classList.add('is-active');
    barsWrap.innerHTML = '';
    arrowsWrap.innerHTML = '';

    var bars = items.map(function (_item, index) {
      var bar = document.createElement('button');
      bar.type = 'button';
      bar.className = 'hanso-louver-technology__bar';
      bar.setAttribute('aria-label', 'Go to feature ' + (index + 1));
      bar.addEventListener('click', function () {
        flkty.select(index);
      });
      barsWrap.appendChild(bar);
      return bar;
    });

    var prevButton = document.createElement('button');
    prevButton.type = 'button';
    prevButton.className = 'hanso-louver-technology__arrow';
    prevButton.setAttribute('aria-label', 'Previous feature');
    prevButton.innerHTML =
      '<span class="hanso-louver-technology__arrow-icon hanso-louver-technology__arrow-icon--prev"><svg class="hanso-louver-technology__arrow-svg" viewBox="0 0 7 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 10.4133L5.69333 5.70667L1 1" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path></svg></span>';

    var nextButton = document.createElement('button');
    nextButton.type = 'button';
    nextButton.className = 'hanso-louver-technology__arrow';
    nextButton.setAttribute('aria-label', 'Next feature');
    nextButton.innerHTML =
      '<span class="hanso-louver-technology__arrow-icon"><svg class="hanso-louver-technology__arrow-svg" viewBox="0 0 7 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 10.4133L5.69333 5.70667L1 1" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path></svg></span>';

    arrowsWrap.appendChild(prevButton);
    arrowsWrap.appendChild(nextButton);

    function updateControls() {
      bars.forEach(function (bar, index) {
        bar.classList.toggle('is-active', flkty.selectedIndex === index);
      });
      prevButton.disabled = flkty.selectedIndex === 0;
      nextButton.disabled = flkty.selectedIndex >= items.length - 1;
    }

    prevButton.addEventListener('click', function () {
      flkty.select(Math.max(0, flkty.selectedIndex - 1));
    });

    nextButton.addEventListener('click', function () {
      flkty.select(Math.min(items.length - 1, flkty.selectedIndex + 1));
    });

    flkty.on('select', updateControls);
    updateControls();
  }

  function setupCarousel() {
    var shouldCarousel = window.matchMedia('(max-width: 991px)').matches && items.length > 1;

    if (!shouldCarousel) {
      if (state.flkty) {
        window.HansoTheme.destroyFlickityInstance(track);
        state.flkty = null;
      }
      resetControls();
      return;
    }

    if (state.flkty) {
      window.HansoTheme.destroyFlickityInstance(track);
      state.flkty = null;
    }

    state.flkty = window.HansoTheme.getFlickityInstance(track, {
      cellAlign: 'left',
      contain: true,
      wrapAround: false,
      pageDots: false,
      prevNextButtons: false,
      draggable: true,
      imagesLoaded: true,
      percentPosition: true,
      setGallerySize: true,
      selectedAttraction: 0.018,
      friction: 0.24,
      dragThreshold: 8,
    });

    if (!state.flkty) {
      resetControls();
      return;
    }

    buildControls(state.flkty);
    state.flkty.resize();
  }

  state.handleResize = function handleResize() {
    if (state.resizeTimer) {
      window.clearTimeout(state.resizeTimer);
    }

    state.resizeTimer = window.setTimeout(setupCarousel, 120);
  };

  setupCarousel();
  window.addEventListener('resize', state.handleResize);
  window.HansoTheme.pdpLouverFeatureGrids.set(section, state);
};

window.HansoTheme.initPdpLouverFeatureGrids = function initPdpLouverFeatureGrids(scope) {
  var root = scope || document;
  var sections = root.querySelectorAll('.hanso-pdp-sections__louver-technology');

  sections.forEach(function (section) {
    window.HansoTheme.initPdpLouverFeatureGrid(section);
  });
};

window.HansoTheme.destroyPdpLouverFeatureGrid = function destroyPdpLouverFeatureGrid(section) {
  if (!section || !window.HansoTheme.pdpLouverFeatureGrids.has(section)) {
    return;
  }

  var state = window.HansoTheme.pdpLouverFeatureGrids.get(section);
  var track = section.querySelector('[data-pdp-louver-feature-grid-track]');
  var controls = section.querySelector('[data-pdp-louver-feature-grid-controls]');
  var barsWrap = section.querySelector('[data-pdp-louver-feature-grid-bars]');
  var arrowsWrap = section.querySelector('[data-pdp-louver-feature-grid-arrows]');

  if (state && state.resizeTimer) {
    window.clearTimeout(state.resizeTimer);
  }

  if (state && state.handleResize) {
    window.removeEventListener('resize', state.handleResize);
  }

  if (track) {
    window.HansoTheme.destroyFlickityInstance(track);
  }

  if (barsWrap) {
    barsWrap.innerHTML = '';
  }

  if (arrowsWrap) {
    arrowsWrap.innerHTML = '';
  }

  if (controls) {
    controls.classList.remove('is-active');
  }

  window.HansoTheme.pdpLouverFeatureGrids.delete(section);
};

window.HansoTheme.initPdpGridGalleryCarousel = function initPdpGridGalleryCarousel(section) {
  if (!section || window.HansoTheme.pdpGridGalleryCarousels.has(section)) {
    return;
  }

  var track = section.querySelector('[data-pdp-grid-gallery-carousel-track]');
  var items = Array.prototype.slice.call(section.querySelectorAll('[data-pdp-grid-gallery-carousel-item]'));
  var barsWrap = section.querySelector('[data-pdp-grid-gallery-carousel-bars]');
  var prevButton = section.querySelector('[data-pdp-grid-gallery-carousel-prev]');
  var nextButton = section.querySelector('[data-pdp-grid-gallery-carousel-next]');

  if (!track || !items.length || !barsWrap) {
    return;
  }

  section.dataset.desktopCarousel = 'true';

  var flkty = window.HansoTheme.getFlickityInstance(track, {
    cellAlign: 'left',
    contain: true,
    draggable: items.length > 1,
    pageDots: false,
    prevNextButtons: false,
    wrapAround: false,
    imagesLoaded: true,
    percentPosition: true,
    setGallerySize: true,
    selectedAttraction: 0.018,
    friction: 0.24,
    dragThreshold: 8,
  });

  if (!flkty) {
    return;
  }

  function getBarTargets() {
    return window.HansoTheme.getCarouselTargetIndexes(section, items.length);
  }

  function getCurrentTargetPosition() {
    return window.HansoTheme.getCarouselTargetPosition(flkty.selectedIndex, getBarTargets());
  }

  function buildBars() {
    barsWrap.innerHTML = '';

    return getBarTargets().map(function (targetIndex, index) {
      var bar = document.createElement('button');
      bar.type = 'button';
      bar.className = 'hanso-video-testimonials__bar';
      bar.setAttribute('aria-label', 'Go to gallery item ' + (index + 1));
      bar.addEventListener('click', function () {
        flkty.select(targetIndex);
      });
      barsWrap.appendChild(bar);
      return bar;
    });
  }

  var bars = buildBars();

  function updateBars() {
    var currentPosition = getCurrentTargetPosition();
    bars.forEach(function (bar, index) {
      bar.classList.toggle('is-active', currentPosition === index);
    });
  }

  function updateButtons() {
    var targets = getBarTargets();
    var currentPosition = getCurrentTargetPosition();

    if (prevButton) {
      prevButton.disabled = currentPosition === 0;
    }

    if (nextButton) {
      nextButton.disabled = currentPosition >= targets.length - 1;
    }
  }

  if (prevButton) {
    prevButton.addEventListener('click', function () {
      var targets = getBarTargets();
      var currentPosition = getCurrentTargetPosition();
      flkty.select(targets[Math.max(0, currentPosition - 1)]);
    });
  }

  if (nextButton) {
    nextButton.addEventListener('click', function () {
      var targets = getBarTargets();
      var currentPosition = getCurrentTargetPosition();
      flkty.select(targets[Math.min(targets.length - 1, currentPosition + 1)]);
    });
  }

  flkty.on('select', function () {
    updateBars();
    updateButtons();
  });

  var state = {
    flkty: flkty,
    resizeTimer: null,
    handleResize: null,
  };

  function handleResize() {
    if (state.resizeTimer) {
      window.clearTimeout(state.resizeTimer);
    }

    state.resizeTimer = window.setTimeout(function () {
      bars = buildBars();
      updateBars();
      updateButtons();
      flkty.resize();
    }, 120);
  }

  state.handleResize = handleResize;

  updateBars();
  updateButtons();
  flkty.resize();
  window.addEventListener('resize', handleResize);

  window.HansoTheme.pdpGridGalleryCarousels.set(section, state);
};

window.HansoTheme.initPdpGridGalleryCarousels = function initPdpGridGalleryCarousels(scope) {
  var root = scope || document;
  var sections = root.querySelectorAll('[data-pdp-grid-gallery-carousel-section]');

  sections.forEach(function (section) {
    window.HansoTheme.initPdpGridGalleryCarousel(section);
  });
};

window.HansoTheme.destroyPdpGridGalleryCarousel = function destroyPdpGridGalleryCarousel(section) {
  if (!section || !window.HansoTheme.pdpGridGalleryCarousels.has(section)) {
    return;
  }

  var state = window.HansoTheme.pdpGridGalleryCarousels.get(section);
  var track = section.querySelector('[data-pdp-grid-gallery-carousel-track]');
  var barsWrap = section.querySelector('[data-pdp-grid-gallery-carousel-bars]');

  if (state && state.resizeTimer) {
    window.clearTimeout(state.resizeTimer);
  }

  if (state && state.handleResize) {
    window.removeEventListener('resize', state.handleResize);
  }

  if (track) {
    window.HansoTheme.destroyFlickityInstance(track);
  }

  if (barsWrap) {
    barsWrap.innerHTML = '';
  }

  window.HansoTheme.pdpGridGalleryCarousels.delete(section);
};

window.HansoTheme.initProductGridCarousel = function initProductGridCarousel(section) {
  if (!section || window.HansoTheme.productGridCarousels.has(section)) {
    return;
  }

  var track = section.querySelector('[data-product-grid-track]');
  var cards = Array.prototype.slice.call(section.querySelectorAll('[data-product-grid-card]'));
  var barsWrap = section.querySelector('[data-product-grid-bars]');
  var prevButton = section.querySelector('[data-product-grid-prev]');
  var nextButton = section.querySelector('[data-product-grid-next]');

  if (!track || !cards.length || !barsWrap) {
    return;
  }

  var flkty = window.HansoTheme.getFlickityInstance(track, {
    cellAlign: 'left',
    contain: true,
    draggable: cards.length > 1,
    pageDots: true,
    prevNextButtons: false,
    wrapAround: false,
    imagesLoaded: true,
    percentPosition: true,
    setGallerySize: true,
    watchCSS: true,
    selectedAttraction: 0.018,
    friction: 0.24,
    dragThreshold: 8,
  });

  if (!flkty) {
    return;
  }

  barsWrap.innerHTML = '';

  function getBarTargets() {
    if (document.body.classList.contains('template-sale-test') && section.clientWidth < 992) {
      return cards.map(function (_, index) { return index; });
    }
    return window.HansoTheme.getCarouselTargetIndexes(section, cards.length);
  }

  function getCurrentTargetPosition() {
    return window.HansoTheme.getCarouselTargetPosition(flkty.selectedIndex, getBarTargets());
  }

  var bars = [];
  var autoplayState = null;

  function renderBars() {
    barsWrap.innerHTML = '';
    bars = getBarTargets().map(function (targetIndex, index) {
      var bar = document.createElement('button');
      bar.type = 'button';
      bar.className = 'hanso-product-grid__bar';
      bar.setAttribute('aria-label', 'Go to product ' + (index + 1));
      bar.addEventListener('click', function () { flkty.select(targetIndex); });
      barsWrap.appendChild(bar);
      return bar;
    });
    updateBars();
    updateButtons();
  }

  function updateBars() {
    var currentPosition = getCurrentTargetPosition();
    bars.forEach(function (bar, index) {
      var isActive = currentPosition === index;
      bar.classList.toggle('is-active', isActive);
      bar.classList.toggle('is-loading', !!(autoplayState && autoplayState.enabled && isActive));
    });
  }

  function updateButtons() {
    var targets = getBarTargets();
    var currentPosition = getCurrentTargetPosition();

    if (prevButton) {
      prevButton.disabled = !targets.length || currentPosition === 0;
    }

    if (nextButton) {
      nextButton.disabled = !targets.length || currentPosition >= targets.length - 1;
    }
  }

  renderBars();
  var resizeObserver = null;
  if (document.body.classList.contains('template-sale-test') && window.ResizeObserver) {
    resizeObserver = new ResizeObserver(function () {
      if (bars.length !== getBarTargets().length) {
        flkty.resize();
        renderBars();
      }
    });
    resizeObserver.observe(section);
  }

  if (prevButton) {
    prevButton.addEventListener('click', function () {
      var targets = getBarTargets();
      var currentPosition = getCurrentTargetPosition();
      var previousPosition = Math.max(0, currentPosition - 1);
      flkty.select(targets[previousPosition]);
    });
  }

  if (nextButton) {
    nextButton.addEventListener('click', function () {
      var targets = getBarTargets();
      var currentPosition = getCurrentTargetPosition();
      var nextPosition = Math.min(targets.length - 1, currentPosition + 1);
      flkty.select(targets[nextPosition]);
    });
  }

  flkty.on('select', function () {
    updateBars();
    updateButtons();
    if (autoplayState) {
      autoplayState.restart();
    }
  });

  autoplayState = window.HansoTheme.createCarouselAutoplay(section, flkty, getBarTargets, getCurrentTargetPosition);
  updateBars();
  updateButtons();
  flkty.resize();
  if (autoplayState) {
    autoplayState.start();
  }

  window.HansoTheme.productGridCarousels.set(section, {
    flkty: flkty,
    autoplayState: autoplayState,
    resizeObserver: resizeObserver,
  });
};

window.HansoTheme.initLogoShowcaseTicker = function initLogoShowcaseTicker(section) {
  if (!section || window.HansoTheme.logoShowcaseTickers.has(section)) {
    return;
  }

  var ticker = section.querySelector('[data-logo-showcase-ticker]');
  var track = section.querySelector('[data-logo-showcase-ticker-track]');
  var groups = section.querySelectorAll('[data-logo-showcase-ticker-group]');

  if (!ticker || !track || groups.length < 2) {
    return;
  }

  var firstGroup = groups[0];
  var state = {
    section: section,
    ticker: ticker,
    track: track,
    firstGroup: firstGroup,
    groupWidth: 0,
    offset: 0,
    speed: 0,
    rafId: null,
    lastTime: 0,
    paused: false,
    resizeHandler: null,
    enterHandler: null,
    leaveHandler: null,
    loadHandler: null,
  };

  function clearGeneratedClones() {
    state.track.querySelectorAll('[data-logo-showcase-generated-clone="true"]').forEach(function (clone) {
      clone.remove();
    });
  }

  function buildTrackCopies() {
    clearGeneratedClones();

    var safetyCount = 0;
    var targetWidth = ticker.clientWidth + (state.groupWidth * 2);

    while (state.track.scrollWidth < targetWidth && safetyCount < 8) {
      var clone = state.firstGroup.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      clone.setAttribute('data-logo-showcase-generated-clone', 'true');
      state.track.appendChild(clone);
      safetyCount += 1;
    }
  }

  function measure() {
    state.groupWidth = firstGroup.getBoundingClientRect().width;
    state.offset = 0;
    state.track.style.transform = 'translate3d(0, 0, 0)';

    if (state.groupWidth > 0) {
      buildTrackCopies();
    }

    var durationSeconds = parseFloat(getComputedStyle(section).getPropertyValue('--logo-showcase-ticker-speed')) || 30;
    state.speed = state.groupWidth > 0 ? state.groupWidth / durationSeconds : 0;
  }

  function step(timestamp) {
    if (!state.lastTime) {
      state.lastTime = timestamp;
    }

    var delta = (timestamp - state.lastTime) / 1000;
    state.lastTime = timestamp;

    if (!state.paused && state.groupWidth > 0 && state.speed > 0) {
      state.offset -= state.speed * delta;

      if (Math.abs(state.offset) >= state.groupWidth) {
        state.offset += state.groupWidth;
      }

      state.track.style.transform = 'translate3d(' + state.offset + 'px, 0, 0)';
    }

    state.rafId = window.requestAnimationFrame(step);
  }

  state.enterHandler = function enterHandler() {
    state.paused = true;
  };

  state.leaveHandler = function leaveHandler() {
    state.paused = false;
    state.lastTime = 0;
  };

  state.resizeHandler = function resizeHandler() {
    measure();
  };

  state.loadHandler = function loadHandler() {
    measure();
  };

  ticker.addEventListener('mouseenter', state.enterHandler);
  ticker.addEventListener('mouseleave', state.leaveHandler);
  window.addEventListener('resize', state.resizeHandler);
  section.querySelectorAll('img').forEach(function (image) {
    image.addEventListener('load', state.loadHandler);
  });

  measure();
  state.rafId = window.requestAnimationFrame(step);
  window.HansoTheme.logoShowcaseTickers.set(section, state);
};

window.HansoTheme.initLogoShowcaseTickers = function initLogoShowcaseTickers(scope) {
  var root = scope || document;
  var sections = root.querySelectorAll('.hanso-logo-showcase-section');

  sections.forEach(function (section) {
    window.HansoTheme.initLogoShowcaseTicker(section);
  });
};

window.HansoTheme.destroyLogoShowcaseTicker = function destroyLogoShowcaseTicker(section) {
  if (!section || !window.HansoTheme.logoShowcaseTickers.has(section)) {
    return;
  }

  var state = window.HansoTheme.logoShowcaseTickers.get(section);

  if (state.rafId) {
    window.cancelAnimationFrame(state.rafId);
  }

  if (state.ticker) {
    state.ticker.removeEventListener('mouseenter', state.enterHandler);
    state.ticker.removeEventListener('mouseleave', state.leaveHandler);
  }

  window.removeEventListener('resize', state.resizeHandler);
  section.querySelectorAll('img').forEach(function (image) {
    image.removeEventListener('load', state.loadHandler);
  });

  window.HansoTheme.logoShowcaseTickers.delete(section);
};

window.HansoTheme.initLogoShowcaseCarousel = function initLogoShowcaseCarousel(section) {
  if (!section || window.HansoTheme.logoShowcaseCarousels.has(section)) {
    return;
  }

  if (section.querySelector('[data-logo-showcase-ticker]')) {
    return;
  }

  var track = section.querySelector('[data-logo-showcase-track]');
  var items = Array.prototype.slice.call(section.querySelectorAll('[data-logo-showcase-item]'));
  var isMobile = window.matchMedia('(max-width: 889px)').matches;

  if (!track || items.length < 2 || !isMobile) {
    return;
  }

  items.forEach(function (item, index) {
    item.setAttribute('data-logo-source-index', index);
  });

  var flkty = window.HansoTheme.getFlickityInstance(track, {
    cellAlign: 'left',
    contain: true,
    draggable: true,
    prevNextButtons: false,
    pageDots: false,
    wrapAround: false,
    freeScroll: false,
    percentPosition: true,
    imagesLoaded: true,
    watchCSS: true,
    autoPlay: 5000,
    pauseAutoPlayOnHover: true,
    selectedAttraction: 0.018,
    friction: 0.24,
    dragThreshold: 8,
  });

  if (!flkty) {
    return;
  }

  window.HansoTheme.logoShowcaseCarousels.set(section, {
    flkty: flkty,
    track: track,
  });
};

window.HansoTheme.initLogoShowcaseCarousels = function initLogoShowcaseCarousels(scope) {
  var root = scope || document;
  var sections = root.querySelectorAll('.hanso-logo-showcase-section');

  sections.forEach(function (section) {
    window.HansoTheme.initLogoShowcaseCarousel(section);
  });
};

window.HansoTheme.destroyLogoShowcaseCarousel = function destroyLogoShowcaseCarousel(section) {
  if (!section || !window.HansoTheme.logoShowcaseCarousels.has(section)) {
    return;
  }

  var state = window.HansoTheme.logoShowcaseCarousels.get(section);

  if (state && state.track) {
    window.HansoTheme.destroyFlickityInstance(state.track);
  }

  window.HansoTheme.logoShowcaseCarousels.delete(section);
};

window.HansoTheme.refreshLogoShowcaseResponsive = function refreshLogoShowcaseResponsive(section) {
  if (!section || section.querySelector('[data-logo-showcase-ticker]')) {
    return;
  }

  var isMobile = window.matchMedia('(max-width: 889px)').matches;
  var hasCarousel = window.HansoTheme.logoShowcaseCarousels.has(section);
  var track = section.querySelector('[data-logo-showcase-track]');

  if (!track) {
    return;
  }

  if (isMobile && !hasCarousel) {
    window.HansoTheme.destroyLogoShowcaseQuote(section);
    window.HansoTheme.initLogoShowcaseCarousel(section);
    window.HansoTheme.initLogoShowcaseQuote(section);

    var mobileState = window.HansoTheme.logoShowcaseCarousels.get(section);
    if (mobileState && mobileState.flkty) {
      mobileState.flkty.resize();
    }
    return;
  }

  if (!isMobile && hasCarousel) {
    window.HansoTheme.destroyLogoShowcaseQuote(section);
    window.HansoTheme.destroyLogoShowcaseCarousel(section);
    window.HansoTheme.initLogoShowcaseQuote(section);
    return;
  }

  if (isMobile && hasCarousel) {
    var state = window.HansoTheme.logoShowcaseCarousels.get(section);
    if (state && state.flkty) {
      state.flkty.resize();
    }
  }
};

window.HansoTheme.initLogoShowcaseResponsive = function initLogoShowcaseResponsive(section) {
  if (!section || window.HansoTheme.logoShowcaseResponsiveHandlers.has(section)) {
    return;
  }

  if (section.querySelector('[data-logo-showcase-ticker]')) {
    return;
  }

  var mediaQuery = window.matchMedia('(max-width: 889px)');
  var state = {
    mediaQuery: mediaQuery,
    handleBreakpointChange: null,
    handleResize: null,
    resizeTimer: null,
  };

  function scheduleRefresh() {
    window.clearTimeout(state.resizeTimer);
    state.resizeTimer = window.setTimeout(function () {
      window.HansoTheme.refreshLogoShowcaseResponsive(section);
    }, 120);
  }

  function handleBreakpointChange() {
    scheduleRefresh();
  }

  function handleResize() {
    scheduleRefresh();
  }

  state.handleBreakpointChange = handleBreakpointChange;
  state.handleResize = handleResize;

  if (typeof mediaQuery.addEventListener === 'function') {
    mediaQuery.addEventListener('change', handleBreakpointChange);
  } else if (typeof mediaQuery.addListener === 'function') {
    mediaQuery.addListener(handleBreakpointChange);
  }

  window.addEventListener('resize', handleResize);

  window.HansoTheme.logoShowcaseResponsiveHandlers.set(section, state);
};

window.HansoTheme.initLogoShowcaseResponsiveHandlers = function initLogoShowcaseResponsiveHandlers(scope) {
  var root = scope || document;
  var sections = root.querySelectorAll('.hanso-logo-showcase-section');

  sections.forEach(function (section) {
    window.HansoTheme.initLogoShowcaseResponsive(section);
  });
};

window.HansoTheme.destroyLogoShowcaseResponsive = function destroyLogoShowcaseResponsive(section) {
  if (!section || !window.HansoTheme.logoShowcaseResponsiveHandlers.has(section)) {
    return;
  }

  var state = window.HansoTheme.logoShowcaseResponsiveHandlers.get(section);

  if (state.resizeTimer) {
    window.clearTimeout(state.resizeTimer);
  }

  if (state.mediaQuery && typeof state.mediaQuery.removeEventListener === 'function') {
    state.mediaQuery.removeEventListener('change', state.handleBreakpointChange);
  } else if (state.mediaQuery && typeof state.mediaQuery.removeListener === 'function') {
    state.mediaQuery.removeListener(state.handleBreakpointChange);
  }

  if (state.handleResize) {
    window.removeEventListener('resize', state.handleResize);
  }

  window.HansoTheme.logoShowcaseResponsiveHandlers.delete(section);
};

window.HansoTheme.initLogoShowcaseQuote = function initLogoShowcaseQuote(section) {
  if (!section || window.HansoTheme.logoShowcaseQuotes.has(section)) {
    return;
  }

  if (section.querySelector('[data-logo-showcase-ticker]')) {
    return;
  }

  var quote = section.querySelector('[data-logo-showcase-quote]');
  var items = Array.prototype.slice.call(section.querySelectorAll('[data-logo-showcase-item]'));
  var logosRow = section.querySelector('.hanso-logo-showcase__logos');
  var autoRotateId = null;
  var activeIndex = -1;
  var itemHandlers = [];

  if (!quote || !items.length) {
    return;
  }

  function getCarouselState() {
    return window.HansoTheme.logoShowcaseCarousels.get(section) || null;
  }

  function stopAutoRotate() {
    if (autoRotateId) {
      window.clearInterval(autoRotateId);
      autoRotateId = null;
    }
  }

  function animateQuoteTo(quoteHtml, direction) {
    var currentQuote = quote.getAttribute('data-current-logo-quote') || quote.innerHTML;

    if (!quoteHtml || currentQuote.trim() === quoteHtml.trim()) {
      quote.setAttribute('data-current-logo-quote', quoteHtml);
      return;
    }

    var gsapInstance = window.HansoTheme.motion && window.HansoTheme.motion.gsap;
    var quoteWrap = quote.closest('.hanso-logo-showcase__quote-wrap');

    quote.setAttribute('data-current-logo-quote', quoteHtml);

    if (!gsapInstance) {
      quote.classList.add('is-changing');
      window.setTimeout(function () {
        quote.innerHTML = quoteHtml;
        quote.classList.remove('is-changing');
      }, 180);
      return;
    }

    var currentHeight = quoteWrap ? quoteWrap.getBoundingClientRect().height : 0;
    var outY = direction >= 0 ? -16 : 16;
    var inY = direction >= 0 ? 18 : -18;

    gsapInstance.killTweensOf(quote);
    quote.classList.add('is-gsap-animating');

    if (quoteWrap && currentHeight > 0) {
      quoteWrap.style.minHeight = currentHeight + 'px';
    }

    gsapInstance.to(quote, {
      y: outY,
      autoAlpha: 0,
      duration: 0.22,
      ease: 'power2.out',
      onComplete: function () {
        quote.innerHTML = quoteHtml;
        gsapInstance.set(quote, { y: inY, autoAlpha: 0 });
        gsapInstance.to(quote, {
          y: 0,
          autoAlpha: 1,
          duration: 0.38,
          ease: 'power3.out',
          onComplete: function () {
            if (quoteWrap) {
              quoteWrap.style.minHeight = '';
            }
            quote.classList.remove('is-gsap-animating');
          },
        });
      },
    });
  }

  function setActiveItem(activeItem) {
    var nextIndex = items.indexOf(activeItem);
    var direction = nextIndex >= activeIndex ? 1 : -1;

    items.forEach(function (item) {
      item.classList.toggle('is-active', item === activeItem);
    });

    var quoteContent = activeItem ? activeItem.querySelector('[data-logo-quote-content]') : null;
    if (quoteContent) {
      animateQuoteTo(quoteContent.innerHTML, direction);
    }

    if (nextIndex >= 0) {
      activeIndex = nextIndex;
    }
  }

  function setActiveByIndex(index, shouldCenter) {
    var normalizedIndex = index;

    if (normalizedIndex < 0) {
      normalizedIndex = items.length - 1;
    }

    if (normalizedIndex >= items.length) {
      normalizedIndex = 0;
    }

    var activeItem = items[normalizedIndex];
    setActiveItem(activeItem);

    if (shouldCenter) {
      scrollItemToCenter(activeItem);
    }
  }

  function startAutoRotate() {
    stopAutoRotate();

    autoRotateId = window.setInterval(function () {
      if (window.matchMedia('(max-width: 889px)').matches) {
        return;
      }

      var activeIndex = items.findIndex(function (item) {
        return item.classList.contains('is-active');
      });

      setActiveByIndex(activeIndex + 1, false);
    }, 5000);
  }

  function restartAutoRotate() {
    startAutoRotate();
  }

  function syncClosestItemOnMobile() {
    var carouselState = getCarouselState();

    if (!logosRow || !window.matchMedia('(max-width: 889px)').matches) {
      return;
    }

    var rowRect = logosRow.getBoundingClientRect();
    var rowCenter = rowRect.left + rowRect.width / 2;
    var visibleItems = Array.prototype.slice.call(logosRow.querySelectorAll('[data-logo-showcase-item]'));
    var closestItem = visibleItems[0] || items[0];
    var closestDistance = Number.POSITIVE_INFINITY;

    visibleItems.forEach(function (item) {
      var itemRect = item.getBoundingClientRect();
      var itemCenter = itemRect.left + itemRect.width / 2;
      var distance = Math.abs(itemCenter - rowCenter);

      if (distance < closestDistance) {
        closestDistance = distance;
        closestItem = item;
      }
    });

    var sourceIndex = Number(closestItem.getAttribute('data-logo-source-index'));
    if (!Number.isNaN(sourceIndex)) {
      setActiveByIndex(sourceIndex, false);
      return;
    }

    setActiveItem(closestItem);
  }

  items.forEach(function (item) {
    var mouseenterHandler = function () {
      if (window.matchMedia('(min-width: 750px)').matches) {
        setActiveItem(item);
        restartAutoRotate();
      }
    };

    var focusinHandler = function () {
      setActiveItem(item);
      restartAutoRotate();
    };

    var clickHandler = function () {
      setActiveItem(item);
      restartAutoRotate();
    };

    var touchstartHandler = function () {
      setActiveItem(item);
      restartAutoRotate();
    };

    item.addEventListener('mouseenter', mouseenterHandler);
    item.addEventListener('focusin', focusinHandler);
    item.addEventListener('click', clickHandler);
    item.addEventListener('touchstart', touchstartHandler, { passive: true });

    itemHandlers.push({
      item: item,
      mouseenterHandler: mouseenterHandler,
      focusinHandler: focusinHandler,
      clickHandler: clickHandler,
      touchstartHandler: touchstartHandler,
    });
  });

  if (logosRow) {
    logosRow.addEventListener('scroll', syncClosestItemOnMobile, { passive: true });
  }

  var carouselState = getCarouselState();
  if (carouselState && carouselState.flkty) {
    carouselState.quoteSyncHandler = function quoteSyncHandler() {
      setActiveByIndex(carouselState.flkty.selectedIndex, false);
    };

    carouselState.flkty.on('select', carouselState.quoteSyncHandler);
    carouselState.flkty.on('settle', carouselState.quoteSyncHandler);
    carouselState.flkty.on('dragStart', stopAutoRotate);
    carouselState.flkty.on('dragEnd', restartAutoRotate);
  }

  setActiveByIndex(0, false);
  syncClosestItemOnMobile();
  startAutoRotate();
  window.HansoTheme.logoShowcaseQuotes.set(section, {
    items: items,
    itemHandlers: itemHandlers,
    logosRow: logosRow,
    syncClosestItemOnMobile: syncClosestItemOnMobile,
    stopAutoRotate: stopAutoRotate,
    restartAutoRotate: restartAutoRotate,
    carouselSelectHandler: carouselState && carouselState.quoteSyncHandler ? carouselState.quoteSyncHandler : null,
  });
};

window.HansoTheme.initLogoShowcaseQuotes = function initLogoShowcaseQuotes(scope) {
  var root = scope || document;
  var sections = root.querySelectorAll('.hanso-logo-showcase-section');

  sections.forEach(function (section) {
    window.HansoTheme.initLogoShowcaseQuote(section);
  });
};

window.HansoTheme.destroyLogoShowcaseQuote = function destroyLogoShowcaseQuote(section) {
  if (!section || !window.HansoTheme.logoShowcaseQuotes.has(section)) {
    return;
  }

  var state = window.HansoTheme.logoShowcaseQuotes.get(section);

  if (state && Array.isArray(state.itemHandlers)) {
    state.itemHandlers.forEach(function (entry) {
      entry.item.removeEventListener('mouseenter', entry.mouseenterHandler);
      entry.item.removeEventListener('focusin', entry.focusinHandler);
      entry.item.removeEventListener('click', entry.clickHandler);
      entry.item.removeEventListener('touchstart', entry.touchstartHandler);
    });
  }

  if (state && state.logosRow && state.syncClosestItemOnMobile) {
    state.logosRow.removeEventListener('scroll', state.syncClosestItemOnMobile);
  }

  var carouselState = window.HansoTheme.logoShowcaseCarousels.get(section);
  if (carouselState && carouselState.flkty && carouselState.quoteSyncHandler) {
    carouselState.flkty.off('select', carouselState.quoteSyncHandler);
    carouselState.flkty.off('settle', carouselState.quoteSyncHandler);
    if (state && state.stopAutoRotate) {
      carouselState.flkty.off('dragStart', state.stopAutoRotate);
    }
    if (state && state.restartAutoRotate) {
      carouselState.flkty.off('dragEnd', state.restartAutoRotate);
    }
  }

  if (state && typeof state.stopAutoRotate === 'function') {
    state.stopAutoRotate();
  }

  window.HansoTheme.logoShowcaseQuotes.delete(section);
};

window.HansoTheme.initProductGridCarousels = function initProductGridCarousels(scope) {
  var root = scope || document;
  var sections = root.querySelectorAll('[data-product-grid-section]');

  sections.forEach(function (section) {
    window.HansoTheme.initProductGridCarousel(section);
  });
};

window.HansoTheme.destroyProductGridCarousel = function destroyProductGridCarousel(section) {
  if (!section) {
    return;
  }

  var track = section.querySelector('[data-product-grid-track]');

  if (track) {
    window.HansoTheme.destroyFlickityInstance(track);
  }

  if (window.HansoTheme.productGridCarousels.has(section)) {
    var state = window.HansoTheme.productGridCarousels.get(section);
    if (state && state.autoplayState) {
      state.autoplayState.destroy();
    }
    if (state && state.resizeObserver) {
      state.resizeObserver.disconnect();
    }
    window.HansoTheme.productGridCarousels.delete(section);
  }
};

window.HansoTheme.pauseVideoTestimonials = function pauseVideoTestimonials(exceptSection, exceptItem) {
  window.HansoTheme.videoTestimonials.forEach(function (instance, section) {
    if (!instance) return;
    instance.items.forEach(function (item) {
      if (section === exceptSection && item === exceptItem) return;
      item.classList.remove('is-playing');
      var video = item.querySelector('video');
      var iframe = item.querySelector('[data-youtube-player]');
      if (video) {
        video.pause();
        video.currentTime = 0;
      }
      if (iframe && iframe.contentWindow) {
        iframe.contentWindow.postMessage(JSON.stringify({ event: 'command', func: 'pauseVideo', args: [] }), '*');
      }
    });
  });
};

window.HansoTheme.getDesktopCarouselStepCount = function getDesktopCarouselStepCount(section, itemsLength) {
  if (!section || itemsLength <= 0) {
    return 0;
  }

  var isDesktop = window.matchMedia('(min-width: 992px)').matches;
  var isCarouselMode = section.dataset.layoutMode === 'carousel';

  if (!isDesktop || !isCarouselMode) {
    return itemsLength;
  }

  return Math.max(1, itemsLength - 2);
};

window.HansoTheme.getCarouselTargetIndexes = function getCarouselTargetIndexes(section, itemsLength) {
  if (!section || itemsLength <= 0) {
    return [];
  }

  var isDesktop = window.matchMedia('(min-width: 992px)').matches;
  var usesDesktopCarousel = section.dataset.desktopCarousel === 'true';

  if (section.matches('[data-product-grid-section]') && isDesktop) {
    return Array.from({ length: Math.max(1, itemsLength - 2) }, function (_, index) {
      return index;
    });
  }

  if (
      isDesktop &&
      (section.dataset.layoutMode === 'carousel' || usesDesktopCarousel) &&
      (section.matches('[data-video-testimonials-section]') || section.matches('[data-blog-posts-section]'))
    ) {
      return Array.from({ length: Math.max(1, itemsLength - 2) }, function (_, index) {
        return index;
      });
    }

      if (section.matches('[data-carousel-gallery-section]') && isDesktop) {
        var desktopItemsVisible = Number(section.dataset.desktopItemsVisible || 2.25);
        var targetCount = Math.max(1, Math.ceil(itemsLength - desktopItemsVisible + 1));

        return Array.from({ length: targetCount }, function (_, index) {
          return index;
        });
      }

      if (section.matches('[data-louver-technology-section]') && isDesktop) {
        if (section.dataset.desktopCarousel === 'true') {
          return Array.from({ length: Math.max(1, itemsLength - 2) }, function (_, index) {
            return index;
          });
        }

        return [];
      }

      if (section.matches('[data-pdp-grid-gallery-carousel-section]') && isDesktop) {
        return Array.from({ length: Math.max(1, itemsLength - 2) }, function (_, index) {
          return index;
        });
      }

      return Array.from({ length: itemsLength }, function (_, index) {
        return index;
      });
    };

window.HansoTheme.getCarouselTargetPosition = function getCarouselTargetPosition(selectedIndex, targetIndexes) {
  if (!targetIndexes || !targetIndexes.length) {
    return 0;
  }

  var resolvedPosition = 0;

  targetIndexes.forEach(function (targetIndex, index) {
    if (selectedIndex >= targetIndex) {
      resolvedPosition = index;
    }
  });

  return resolvedPosition;
};

window.HansoTheme.createCarouselAutoplay = function createCarouselAutoplay(section, flkty, getTargetIndexes, getCurrentPosition) {
  if (!section || !flkty || section.dataset.carouselAutoplay !== 'true') {
    return null;
  }

  var speedSeconds = Number(section.dataset.carouselAutoplaySpeed || 5);
  var delay = Math.max(3, speedSeconds) * 1000;
  var timerId = null;

  function stop() {
    if (timerId) {
      window.clearTimeout(timerId);
      timerId = null;
    }
  }

  function next() {
    var targets = getTargetIndexes();
    if (!targets.length || targets.length < 2) {
      return;
    }

    var currentPosition = getCurrentPosition();
    var nextPosition = currentPosition >= targets.length - 1 ? 0 : currentPosition + 1;
    flkty.select(targets[nextPosition]);
  }

  function start() {
    stop();

    var targets = getTargetIndexes();
    if (targets.length < 2) {
      return;
    }

    timerId = window.setTimeout(next, delay);
  }

  function pause() {
    stop();
  }

  function resume() {
    start();
  }

  return {
    enabled: true,
    start: start,
    stop: stop,
    pause: pause,
    resume: resume,
    restart: start,
    destroy: function destroy() {
      stop();
    },
  };
};

window.HansoTheme.initVideoTestimonials = function initVideoTestimonials(section) {
  if (!section || window.HansoTheme.videoTestimonials.has(section)) return;

  var track = section.querySelector('[data-video-testimonials-track]');
  var items = Array.prototype.slice.call(section.querySelectorAll('[data-video-testimonial-item]'));
  var barsWrap = section.querySelector('[data-video-testimonials-bars]');
  var prevButton = section.querySelector('[data-video-testimonials-prev]');
  var nextButton = section.querySelector('[data-video-testimonials-next]');

  if (!track || !items.length || !barsWrap) return;

  function isDesktopViewport() {
    return window.matchMedia('(min-width: 992px)').matches;
  }

  function isPdpSmallDesktopStatic() {
    return section.classList.contains('hanso-pdp-sections__video-group') && items.length < 4 && isDesktopViewport();
  }

  function shouldUseDesktopCarousel() {
    if (isPdpSmallDesktopStatic()) {
      return false;
    }

    if (
      section.classList.contains('hanso-pdp-sections__video-group') &&
      section.dataset.layoutMode === 'carousel' &&
      isDesktopViewport()
    ) {
      return true;
    }

    return (
      section.dataset.layoutMode === 'pdp-grid' &&
      items.length > 4 &&
      isDesktopViewport()
    );
  }

  function applyResponsiveModeFlag() {
    section.dataset.desktopStaticGrid = isPdpSmallDesktopStatic() ? 'true' : 'false';
    section.dataset.desktopCarousel = shouldUseDesktopCarousel() ? 'true' : 'false';
  }

  applyResponsiveModeFlag();

  var isCarouselMode =
    !isPdpSmallDesktopStatic() && (section.dataset.layoutMode === 'carousel' || section.dataset.desktopCarousel === 'true');
  var isDesktopPdpStaticGrid =
    section.classList.contains('hanso-pdp-sections__video-group') &&
    section.dataset.desktopCarousel !== 'true' &&
    isDesktopViewport();

  if (isDesktopPdpStaticGrid) {
    window.HansoTheme.destroyFlickityInstance(track);
    barsWrap.innerHTML = '';
    if (prevButton) prevButton.disabled = true;
    if (nextButton) nextButton.disabled = true;
  }

  var flkty = window.HansoTheme.getFlickityInstance(track, {
    cellAlign: 'left',
    contain: true,
    draggable: items.length > 1,
    pageDots: false,
    prevNextButtons: false,
    wrapAround: false,
    imagesLoaded: true,
    percentPosition: true,
    watchCSS: !isCarouselMode,
    selectedAttraction: 0.018,
    friction: 0.24,
    dragThreshold: 8,
  });

  if (!flkty) return;

  barsWrap.innerHTML = '';
  function getBarTargets() {
    return window.HansoTheme.getCarouselTargetIndexes(section, items.length);
  }

  function getCurrentTargetPosition() {
    return window.HansoTheme.getCarouselTargetPosition(flkty.selectedIndex, getBarTargets());
  }

  var barTargets = getBarTargets();
  var bars = barTargets.map(function (targetIndex, index) {
    var bar = document.createElement('button');
    bar.type = 'button';
    bar.className = 'hanso-video-testimonials__bar';
    bar.setAttribute('aria-label', 'Go to testimonial ' + (index + 1));
    bar.addEventListener('click', function () { flkty.select(targetIndex); });
    barsWrap.appendChild(bar);
    return bar;
  });

  function updateBars() {
    var currentPosition = getCurrentTargetPosition();
    bars.forEach(function (bar, index) {
      var isActive = currentPosition === index;
      bar.classList.toggle('is-active', isActive);
      bar.classList.toggle('is-loading', !!(autoplayState && autoplayState.enabled && isActive));
    });
  }

  function updateButtons() {
    var targets = getBarTargets();
    var currentPosition = getCurrentTargetPosition();
    if (prevButton) prevButton.disabled = currentPosition === 0;
    if (nextButton) nextButton.disabled = currentPosition >= targets.length - 1;
  }

  if (prevButton) prevButton.addEventListener('click', function () {
    var targets = getBarTargets();
    var currentPosition = getCurrentTargetPosition();
    var previousPosition = Math.max(0, currentPosition - 1);
    flkty.select(targets[previousPosition]);
  });
  if (nextButton) nextButton.addEventListener('click', function () {
    var targets = getBarTargets();
    var currentPosition = getCurrentTargetPosition();
    var nextPosition = Math.min(targets.length - 1, currentPosition + 1);
    flkty.select(targets[nextPosition]);
  });

  var autoplayState = window.HansoTheme.createCarouselAutoplay(section, flkty, getBarTargets, getCurrentTargetPosition);
  var lastSelectedIndex = flkty.selectedIndex;

  function pauseItemsInSection(exceptItem) {
    items.forEach(function (item) {
      if (item === exceptItem) return;
      item.classList.remove('is-playing');

      var video = item.querySelector('video');
      var iframe = item.querySelector('[data-youtube-player]');

      if (video) {
        video.pause();
        video.currentTime = 0;
      }

      if (iframe && iframe.contentWindow) {
        iframe.contentWindow.postMessage(JSON.stringify({ event: 'command', func: 'pauseVideo', args: [] }), '*');
      }
    });
  }

  function playVideoItem(item, options) {
    if (!item) return;

    var settings = options || {};
    var video = item.querySelector('video');
    var iframe = item.querySelector('[data-youtube-player]');

    window.HansoTheme.pauseVideoTestimonials(section, item);
    item.classList.add('is-playing');

    if (autoplayState) autoplayState.pause();

    if (video) {
      if (settings.autoplay) {
        video.muted = true;
        video.loop = true;
        video.setAttribute('muted', 'muted');
        video.setAttribute('loop', 'loop');
      }

      var playPromise = video.play();
      if (playPromise && typeof playPromise.catch === 'function') {
        playPromise.catch(function () {
          item.classList.remove('is-playing');
          if (autoplayState && !section.querySelector('.hanso-video-testimonials__item.is-playing')) {
            autoplayState.resume();
          }
        });
      }
    }

    if (iframe && iframe.contentWindow) {
      if (settings.autoplay) {
        iframe.contentWindow.postMessage(JSON.stringify({ event: 'command', func: 'mute', args: [] }), '*');
      }

      window.setTimeout(function () {
        if (!item.classList.contains('is-playing') || !iframe.contentWindow) return;
        if (settings.autoplay) {
          iframe.contentWindow.postMessage(JSON.stringify({ event: 'command', func: 'setLoop', args: [true] }), '*');
        }
        iframe.contentWindow.postMessage(JSON.stringify({ event: 'command', func: 'playVideo', args: [] }), '*');
      }, settings.autoplay ? 300 : 0);
    }
  }

  items.forEach(function (item) {
    var playButton = item.querySelector('[data-video-testimonial-play]');
    var video = item.querySelector('video');
    var iframe = item.querySelector('[data-youtube-player]');
    var isNativeAutoplayItem = item.hasAttribute('data-video-native-autoplay');
    if (video && !isNativeAutoplayItem) video.pause();
    if (video && isNativeAutoplayItem) {
      video.muted = true;
      video.loop = true;
      video.setAttribute('muted', 'muted');
      video.setAttribute('loop', 'loop');
      item.classList.add('is-playing');
    }
    if (playButton) {
      playButton.addEventListener('click', function () {
        if (video) {
          video.muted = false;
        }
        playVideoItem(item);
      });
    }
    if (video) {
      video.addEventListener('pause', function () {
        item.classList.remove('is-playing');
        if (autoplayState && !section.querySelector('.hanso-video-testimonials__item.is-playing')) {
          autoplayState.resume();
        }
      });
      video.addEventListener('ended', function () {
        item.classList.remove('is-playing');
        video.currentTime = 0;
        if (autoplayState && !section.querySelector('.hanso-video-testimonials__item.is-playing')) {
          autoplayState.resume();
        }
      });
    }
  });

  flkty.on('select', function () {
    var didSlideChange = flkty.selectedIndex !== lastSelectedIndex;
    lastSelectedIndex = flkty.selectedIndex;

    if (didSlideChange) {
      pauseItemsInSection();
    }

    updateBars();
    updateButtons();
    if (autoplayState && !section.querySelector('.hanso-video-testimonials__item.is-playing')) {
      autoplayState.restart();
    }
  });

  updateBars();
  updateButtons();
  flkty.resize();

  var resizeTimer = null;
  function handleResize() {
    if (resizeTimer) {
      window.clearTimeout(resizeTimer);
    }

    resizeTimer = window.setTimeout(function () {
      var previousMode = section.dataset.desktopCarousel === 'true';
      var previousStaticMode = section.dataset.desktopStaticGrid === 'true';
      applyResponsiveModeFlag();
      var nextMode = section.dataset.desktopCarousel === 'true';
      var nextStaticMode = section.dataset.desktopStaticGrid === 'true';

      if (previousMode !== nextMode || previousStaticMode !== nextStaticMode) {
        window.HansoTheme.destroyVideoTestimonials(section);
        window.HansoTheme.initVideoTestimonials(section);
        return;
      }

      updateBars();
      updateButtons();
      flkty.resize();
    }, 120);
  }

  window.addEventListener('resize', handleResize);

  if (autoplayState) {
    autoplayState.start();
  }

  var firstPlayableItem = items.find(function (item) {
    return item.querySelector('video, [data-youtube-player]');
  });

  if (
    firstPlayableItem &&
    section.classList.contains('pdp-hanso-video-testimonials-section-1') &&
    !firstPlayableItem.hasAttribute('data-video-native-autoplay') &&
    section.dataset.firstVideoAutoplayed !== 'true'
  ) {
    section.dataset.firstVideoAutoplayed = 'true';
    window.setTimeout(function () {
      playVideoItem(firstPlayableItem, { autoplay: true });
    }, 400);
  }

  window.HansoTheme.videoTestimonials.set(section, {
    flkty: flkty,
    items: items,
    autoplayState: autoplayState,
    handleResize: handleResize,
  });
};

window.HansoTheme.destroyVideoTestimonials = function destroyVideoTestimonials(section) {
  if (!section) return;
  var track = section.querySelector('[data-video-testimonials-track]');
  if (track) window.HansoTheme.destroyFlickityInstance(track);
  if (window.HansoTheme.videoTestimonials.has(section)) {
    var state = window.HansoTheme.videoTestimonials.get(section);
    if (state && state.autoplayState) {
      state.autoplayState.destroy();
    }
    if (state && state.handleResize) {
      window.removeEventListener('resize', state.handleResize);
    }
    window.HansoTheme.videoTestimonials.delete(section);
  }
};

window.HansoTheme.initVideoTestimonialsSections = function initVideoTestimonialsSections(scope) {
  var root = scope || document;
  var sections = root.querySelectorAll('[data-video-testimonials-section]');
  sections.forEach(function (section) {
    window.HansoTheme.initVideoTestimonials(section);
  });
};

window.HansoTheme.pausePdpBestReviewMedia = function pausePdpBestReviewMedia(activeSection) {
  window.HansoTheme.pdpBestReviews.forEach(function (_, section) {
    var media = section.querySelector('[data-pdp-best-review-media]');
    if (!media || section === activeSection) return;
    media.classList.remove('is-playing');

    var video = section.querySelector('video');
    var iframe = section.querySelector('[data-pdp-best-review-youtube]');
    if (video) {
      video.pause();
      video.currentTime = 0;
    }
    if (iframe && iframe.contentWindow) {
      iframe.contentWindow.postMessage(JSON.stringify({ event: 'command', func: 'pauseVideo', args: [] }), '*');
    }
  });
};

window.HansoTheme.initPdpBestReview = function initPdpBestReview(section) {
  if (!section || window.HansoTheme.pdpBestReviews.has(section)) return;

  var playButton = section.querySelector('[data-pdp-best-review-play]');
  var pauseButton = section.querySelector('[data-pdp-best-review-pause]');
  var media = section.querySelector('[data-pdp-best-review-media]');
  var video = section.querySelector('video');
  var iframe = section.querySelector('[data-pdp-best-review-youtube]');

  if (!media) return;

  function stopPlayback() {
    media.classList.remove('is-playing');
  }

  if (playButton) {
    playButton.addEventListener('click', function () {
      window.HansoTheme.pausePdpBestReviewMedia(section);
      media.classList.add('is-playing');
      if (video) {
        video.play();
      }
      if (iframe && iframe.contentWindow) {
        iframe.contentWindow.postMessage(JSON.stringify({ event: 'command', func: 'playVideo', args: [] }), '*');
      }
    });
  }

  if (pauseButton) {
    pauseButton.addEventListener('click', function () {
      stopPlayback();
      if (video) {
        video.pause();
      }
      if (iframe && iframe.contentWindow) {
        iframe.contentWindow.postMessage(JSON.stringify({ event: 'command', func: 'pauseVideo', args: [] }), '*');
      }
    });
  }

  if (video) {
    video.addEventListener('pause', function () {
      stopPlayback();
    });
    video.addEventListener('ended', function () {
      stopPlayback();
      video.currentTime = 0;
    });
  }

  window.HansoTheme.pdpBestReviews.set(section, { video: video });
};

window.HansoTheme.initPdpBestReviews = function initPdpBestReviews(scope) {
  var root = scope || document;
  var sections = root.querySelectorAll('[data-pdp-best-review]');
  sections.forEach(function (section) {
    window.HansoTheme.initPdpBestReview(section);
  });
};

window.HansoTheme.destroyPdpBestReview = function destroyPdpBestReview(section) {
  if (!section || !window.HansoTheme.pdpBestReviews.has(section)) return;
  window.HansoTheme.pausePdpBestReviewMedia();
  window.HansoTheme.pdpBestReviews.delete(section);
};

window.HansoTheme.initPdpFaqSection = function initPdpFaqSection(section) {
  if (!section || window.HansoTheme.pdpFaqSections.has(section)) return;

  var tabs = Array.prototype.slice.call(section.querySelectorAll('[data-pdp-faq-tab]'));
  var panels = Array.prototype.slice.call(section.querySelectorAll('[data-pdp-faq-panel]'));
  var items = Array.prototype.slice.call(section.querySelectorAll('[data-pdp-faq-item]'));
  var faqCarouselStates = window.HansoTheme.initFaqImageCarousels(section);
  window.HansoTheme.initPdpFullVideos(section);

  function openItem(item) {
    if (!item) return;
    var answer = item.querySelector('[data-pdp-faq-answer]');
    var question = item.querySelector('[data-pdp-faq-question]');
    if (!answer || !question) return;

    item.classList.add('is-open');
    question.setAttribute('aria-expanded', 'true');
    answer.hidden = false;
    window.HansoTheme.initPdpFullVideos(item);
    window.HansoTheme.resizeFaqImageCarousels(item);
    answer.style.height = '0px';
    void answer.offsetHeight;
    answer.style.transition = 'height 260ms ease';
    answer.style.height = answer.scrollHeight + 'px';

    window.setTimeout(function () {
      if (!item.classList.contains('is-open')) return;
      window.HansoTheme.resizeFaqImageCarousels(item);
      answer.style.height = 'auto';
    }, 260);
  }

  function closeItem(item, instant) {
    if (!item) return;
    var answer = item.querySelector('[data-pdp-faq-answer]');
    var question = item.querySelector('[data-pdp-faq-question]');
    if (!answer || !question) return;

    item.classList.remove('is-open');
    question.setAttribute('aria-expanded', 'false');

    if (instant) {
      answer.style.transition = 'none';
      answer.style.height = '0px';
      answer.hidden = true;
      window.requestAnimationFrame(function () {
        answer.style.transition = '';
      });
      return;
    }

    answer.style.height = answer.scrollHeight + 'px';
    void answer.offsetHeight;
    answer.style.transition = 'height 260ms ease';
    answer.style.height = '0px';

    window.setTimeout(function () {
      if (item.classList.contains('is-open')) return;
      answer.hidden = true;
    }, 260);
  }

  function activatePanel(targetId) {
    tabs.forEach(function (tab) {
      var isActive = tab.dataset.faqTarget === targetId;
      tab.classList.toggle('is-active', isActive);
      tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
    });

    panels.forEach(function (panel) {
      var isActive = panel.id === targetId;
      panel.classList.toggle('is-active', isActive);
      panel.hidden = !isActive;

      if (isActive) {
        window.requestAnimationFrame(function () {
          window.HansoTheme.initPdpFullVideos(panel);
          window.HansoTheme.resizeFaqImageCarousels(panel);
        });
      }
    });
  }

  tabs.forEach(function (tab) {
    tab.addEventListener('click', function () {
      activatePanel(tab.dataset.faqTarget);
    });
  });

  items.forEach(function (item) {
    var question = item.querySelector('[data-pdp-faq-question]');
    if (!question) return;

    question.addEventListener('click', function () {
      if (item.classList.contains('is-open')) {
        closeItem(item);
      } else {
        var questionTop = question.getBoundingClientRect().top;
        var panel = item.closest('[data-pdp-faq-panel]');
        var panelItems = panel
          ? Array.prototype.slice.call(panel.querySelectorAll('[data-pdp-faq-item]'))
          : items;

        panelItems.forEach(function (otherItem) {
          if (otherItem !== item) {
            closeItem(otherItem, true);
          }
        });

        var questionTopAfterSiblingClose = question.getBoundingClientRect().top;
        var scrollDelta = questionTopAfterSiblingClose - questionTop;

        if (Math.abs(scrollDelta) > 1) {
          window.scrollBy(0, scrollDelta);
        }

        openItem(item);
      }
    });

    if (item.classList.contains('is-open')) {
      var answer = item.querySelector('[data-pdp-faq-answer]');
      if (answer) {
        answer.hidden = false;
        answer.style.height = 'auto';
        window.HansoTheme.initPdpFullVideos(item);
        window.HansoTheme.resizeFaqImageCarousels(item);
      }
    }
  });

  window.HansoTheme.pdpFaqSections.set(section, {
    faqCarouselStates: faqCarouselStates,
  });
};

window.HansoTheme.initPdpFaqSections = function initPdpFaqSections(scope) {
  var root = scope || document;
  var sections = root.querySelectorAll('[data-pdp-faq-section]');
  sections.forEach(function (section) {
    window.HansoTheme.initPdpFaqSection(section);
  });
};

window.HansoTheme.destroyPdpFaqSection = function destroyPdpFaqSection(section) {
  if (!section || !window.HansoTheme.pdpFaqSections.has(section)) return;
  var state = window.HansoTheme.pdpFaqSections.get(section);
  if (state && state.faqCarouselStates) {
    state.faqCarouselStates.forEach(function (carouselState) {
      if (carouselState && carouselState.track) {
        window.HansoTheme.destroyFlickityInstance(carouselState.track);
      }
    });
  }
  Array.prototype.slice.call(section.querySelectorAll('[data-pdp-full-video-section]')).forEach(function (videoSection) {
    window.HansoTheme.destroyPdpFullVideo(videoSection);
  });
  window.HansoTheme.pdpFaqSections.delete(section);
};

window.HansoTheme.initBlogPosts = function initBlogPosts(section) {
  if (!section || window.HansoTheme.blogPosts.has(section)) return;

  var track = section.querySelector('[data-blog-posts-track]');
  var items = Array.prototype.slice.call(section.querySelectorAll('[data-blog-post-item]'));
  var barsWrap = section.querySelector('[data-blog-posts-bars]');
  var prevButton = section.querySelector('[data-blog-posts-prev]');
  var nextButton = section.querySelector('[data-blog-posts-next]');
  var isCarouselMode = section.dataset.layoutMode === 'carousel';

  if (!track || !items.length || !barsWrap) return;

  var flkty = window.HansoTheme.getFlickityInstance(track, {
    cellAlign: 'left',
    contain: true,
    draggable: items.length > 1,
    pageDots: false,
    prevNextButtons: false,
    wrapAround: false,
    imagesLoaded: true,
    percentPosition: true,
    watchCSS: !isCarouselMode,
    selectedAttraction: 0.018,
    friction: 0.24,
    dragThreshold: 8,
  });

  if (!flkty) return;

  barsWrap.innerHTML = '';
  function getBarTargets() {
    return window.HansoTheme.getCarouselTargetIndexes(section, items.length);
  }

  function getCurrentTargetPosition() {
    return window.HansoTheme.getCarouselTargetPosition(flkty.selectedIndex, getBarTargets());
  }

  var barTargets = getBarTargets();
  var bars = barTargets.map(function (targetIndex, index) {
    var bar = document.createElement('button');
    bar.type = 'button';
    bar.className = 'hanso-blog-posts__bar';
    bar.setAttribute('aria-label', 'Go to blog post ' + (index + 1));
    bar.addEventListener('click', function () { flkty.select(targetIndex); });
    barsWrap.appendChild(bar);
    return bar;
  });

  function updateBars() {
    var currentPosition = getCurrentTargetPosition();
    bars.forEach(function (bar, index) {
      var isActive = currentPosition === index;
      bar.classList.toggle('is-active', isActive);
      bar.classList.toggle('is-loading', !!(autoplayState && autoplayState.enabled && isActive));
    });
  }

  function updateButtons() {
    var targets = getBarTargets();
    var currentPosition = getCurrentTargetPosition();
    if (prevButton) prevButton.disabled = currentPosition === 0;
    if (nextButton) nextButton.disabled = currentPosition >= targets.length - 1;
  }

  if (prevButton) prevButton.addEventListener('click', function () {
    var targets = getBarTargets();
    var currentPosition = getCurrentTargetPosition();
    var previousPosition = Math.max(0, currentPosition - 1);
    flkty.select(targets[previousPosition]);
  });
  if (nextButton) nextButton.addEventListener('click', function () {
    var targets = getBarTargets();
    var currentPosition = getCurrentTargetPosition();
    var nextPosition = Math.min(targets.length - 1, currentPosition + 1);
    flkty.select(targets[nextPosition]);
  });

  var autoplayState = window.HansoTheme.createCarouselAutoplay(section, flkty, getBarTargets, getCurrentTargetPosition);

  flkty.on('select', function () {
    updateBars();
    updateButtons();
    if (autoplayState) {
      autoplayState.restart();
    }
  });

  updateBars();
  updateButtons();
  flkty.resize();
  if (autoplayState) {
    autoplayState.start();
  }
  window.HansoTheme.blogPosts.set(section, { flkty: flkty, autoplayState: autoplayState });
};

window.HansoTheme.initBlogPostsSections = function initBlogPostsSections(scope) {
  var root = scope || document;
  var sections = root.querySelectorAll('[data-blog-posts-section]');
  sections.forEach(function (section) {
    window.HansoTheme.initBlogPosts(section);
  });
};

window.HansoTheme.destroyBlogPosts = function destroyBlogPosts(section) {
  if (!section) return;
  var track = section.querySelector('[data-blog-posts-track]');
  if (track) window.HansoTheme.destroyFlickityInstance(track);
  if (window.HansoTheme.blogPosts.has(section)) {
    var state = window.HansoTheme.blogPosts.get(section);
    if (state && state.autoplayState) {
      state.autoplayState.destroy();
    }
    window.HansoTheme.blogPosts.delete(section);
  }
};

window.HansoTheme.initPressSpotlight = function initPressSpotlight(section) {
  if (!section || window.HansoTheme.pressSpotlights.has(section)) return;

  var video = section.querySelector('.hanso-press-spotlight__video');
  var playButton = section.querySelector('.hanso-press-spotlight__play');
  var track = section.querySelector('[data-press-spotlight-track]');
  var items = Array.prototype.slice.call(section.querySelectorAll('[data-press-spotlight-item]'));
  var barsWrap = section.querySelector('[data-press-spotlight-bars]');
  var prevButton = section.querySelector('[data-press-spotlight-prev]');
  var nextButton = section.querySelector('[data-press-spotlight-next]');
  var mobileQuery = window.matchMedia('(max-width: 889px)');

  var state = {
    flkty: null,
    bars: [],
    handleResize: null,
    handlePlayClick: null,
    handleVideoPause: null,
    handleVideoEnded: null,
  };

  function syncVideoState() {
    if (!video || video.tagName !== 'VIDEO') return;
    section.classList.toggle('is-video-playing', !video.paused && !video.ended);
    if (playButton) {
      playButton.setAttribute('aria-label', video.paused ? 'Play spotlight video' : 'Pause spotlight video');
    }
  }

  if (video && video.tagName === 'VIDEO' && playButton) {
    state.handlePlayClick = function handlePlayClick() {
      if (video.paused) {
        video.play();
      } else {
        video.pause();
      }
      syncVideoState();
    };

    state.handleVideoPause = syncVideoState;
    state.handleVideoEnded = syncVideoState;

    playButton.addEventListener('click', state.handlePlayClick);
    video.addEventListener('pause', state.handleVideoPause);
    video.addEventListener('ended', state.handleVideoEnded);
    video.addEventListener('play', syncVideoState);
  }

  function destroyCarousel() {
    if (track) {
      window.HansoTheme.destroyFlickityInstance(track);
    }
    if (barsWrap) barsWrap.innerHTML = '';
    state.flkty = null;
    state.bars = [];
  }

  function updateBars() {
    if (!state.flkty || !state.bars.length) return;
    state.bars.forEach(function (bar, index) {
      bar.classList.toggle('is-active', index === state.flkty.selectedIndex);
    });
  }

  function updateButtons() {
    if (!state.flkty) return;
    if (prevButton) prevButton.disabled = state.flkty.selectedIndex === 0;
    if (nextButton) nextButton.disabled = state.flkty.selectedIndex >= items.length - 1;
  }

  function initMobileCarousel() {
    if (!track || !items.length || !barsWrap || !mobileQuery.matches) {
      destroyCarousel();
      return;
    }

    if (state.flkty) {
      state.flkty.resize();
      return;
    }

    state.flkty = window.HansoTheme.getFlickityInstance(track, {
      cellAlign: 'left',
      contain: true,
      draggable: items.length > 1,
      pageDots: false,
      prevNextButtons: false,
      wrapAround: false,
      imagesLoaded: true,
      percentPosition: true,
      setGallerySize: true,
      selectedAttraction: 0.018,
      friction: 0.22,
      dragThreshold: 8,
    });

    if (!state.flkty) return;

    barsWrap.innerHTML = '';
    state.bars = items.map(function (item, index) {
      var bar = document.createElement('button');
      bar.type = 'button';
      bar.className = 'hanso-press-spotlight__bar';
      bar.setAttribute('aria-label', 'Go to article ' + (index + 1));
      bar.addEventListener('click', function () {
        state.flkty.select(index);
      });
      barsWrap.appendChild(bar);
      return bar;
    });

    if (prevButton) {
      prevButton.addEventListener('click', function () {
        if (!state.flkty) return;
        state.flkty.previous();
      });
    }

    if (nextButton) {
      nextButton.addEventListener('click', function () {
        if (!state.flkty) return;
        state.flkty.next();
      });
    }

    state.flkty.on('select', function () {
      updateBars();
      updateButtons();
    });

    updateBars();
    updateButtons();
    state.flkty.resize();
  }

  state.handleResize = initMobileCarousel;
  mobileQuery.addEventListener('change', state.handleResize);
  initMobileCarousel();

  window.HansoTheme.pressSpotlights.set(section, state);
};

window.HansoTheme.initPressSpotlights = function initPressSpotlights(scope) {
  var root = scope || document;
  var sections = root.querySelectorAll('[data-press-spotlight-section]');
  sections.forEach(function (section) {
    window.HansoTheme.initPressSpotlight(section);
  });
};

window.HansoTheme.destroyPressSpotlight = function destroyPressSpotlight(section) {
  if (!section || !window.HansoTheme.pressSpotlights.has(section)) return;

  var state = window.HansoTheme.pressSpotlights.get(section);
  var track = section.querySelector('[data-press-spotlight-track]');
  var video = section.querySelector('.hanso-press-spotlight__video');
  var playButton = section.querySelector('.hanso-press-spotlight__play');

  if (track) window.HansoTheme.destroyFlickityInstance(track);
  if (state && state.handleResize) {
    window.matchMedia('(max-width: 889px)').removeEventListener('change', state.handleResize);
  }
  if (video && playButton && state) {
    if (state.handlePlayClick) playButton.removeEventListener('click', state.handlePlayClick);
    if (state.handleVideoPause) video.removeEventListener('pause', state.handleVideoPause);
    if (state.handleVideoEnded) video.removeEventListener('ended', state.handleVideoEnded);
  }

  window.HansoTheme.pressSpotlights.delete(section);
};

window.HansoTheme.initAnimatedStat = function initAnimatedStat(section) {
  if (!section || window.HansoTheme.animatedStats.has(section)) return;

  var numberElement = section.querySelector('[data-animated-stat-number]');
  if (!numberElement) return;

  var beforeElement = section.querySelector('[data-animated-stat-before]');
  var afterElement = section.querySelector('[data-animated-stat-after]');
  var target = parseInt(numberElement.getAttribute('data-target-number'), 10) || 0;
  var duration = parseInt(numberElement.getAttribute('data-duration'), 10) || 1400;
  var hasRun = false;
  var observer = null;

  function formatNumber(value) {
    return Math.max(0, value).toLocaleString('en-US');
  }

  function renderNumber(value) {
    var rawValue = formatNumber(value);
    var targetLength = formatNumber(target).length;
    var paddedValue = rawValue.padStart(targetLength, '0');
    var beforeText = paddedValue.slice(0, 3);
    var afterText = paddedValue.slice(3);

    if (beforeElement && afterElement) {
      beforeElement.textContent = beforeText;
      afterElement.textContent = afterText;
      return;
    }

    numberElement.textContent = Number(paddedValue).toLocaleString('en-US');
  }

  function animateNumber() {
    if (hasRun) return;
    hasRun = true;

    var startTime = null;

    function tick(timestamp) {
      if (!startTime) startTime = timestamp;
      var progress = Math.min((timestamp - startTime) / duration, 1);
      var eased = 1 - Math.pow(1 - progress, 3);
      var current = Math.round(target * eased);

      renderNumber(current);

      if (progress < 1) {
        window.requestAnimationFrame(tick);
      } else {
        renderNumber(target);
      }
    }

    window.requestAnimationFrame(tick);
  }

  if ('IntersectionObserver' in window) {
    observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            animateNumber();
            observer.disconnect();
          }
        });
      },
      { threshold: 0.35 }
    );
    observer.observe(section);
  } else {
    animateNumber();
  }

  window.HansoTheme.animatedStats.set(section, {
    observer: observer,
  });
};

window.HansoTheme.initAnimatedStats = function initAnimatedStats(scope) {
  var root = scope || document;
  var sections = root.querySelectorAll('[data-animated-stat-section]');
  sections.forEach(function (section) {
    window.HansoTheme.initAnimatedStat(section);
  });
};

window.HansoTheme.destroyAnimatedStat = function destroyAnimatedStat(section) {
  if (!section || !window.HansoTheme.animatedStats.has(section)) return;
  var state = window.HansoTheme.animatedStats.get(section);
  if (state && state.observer) {
    state.observer.disconnect();
  }
  window.HansoTheme.animatedStats.delete(section);
};

window.HansoTheme.initBehindScenesSection = function initBehindScenesSection(section) {
  if (!section || window.HansoTheme.behindScenesSections.has(section)) return;

  var media = section.querySelector('[data-behind-scenes-media]');
  var playButton = section.querySelector('[data-behind-scenes-play]');
  var video = section.querySelector('.hanso-behind-scenes__video');
  var youtube = section.querySelector('[data-behind-scenes-youtube]');

  if (!media || !playButton || (!video && !youtube)) return;

  var state = {
    handlePlayClick: null,
    handleVideoPlay: null,
    handleVideoPause: null,
    handleVideoEnded: null,
  };

  function setPlaying(isPlaying) {
    media.classList.toggle('is-video-playing', isPlaying);
    playButton.setAttribute(
      'aria-label',
      isPlaying ? 'Pause behind the scenes video' : playButton.getAttribute('data-play-label') || 'Play behind the scenes video'
    );
  }

  function postYoutubeCommand(command) {
    if (!youtube || !youtube.contentWindow) return;
    youtube.contentWindow.postMessage(
      JSON.stringify({
        event: 'command',
        func: command,
        args: [],
      }),
      '*'
    );
  }

  state.handlePlayClick = function handlePlayClick() {
    var isPlaying = media.classList.contains('is-video-playing');

    if (video) {
      if (isPlaying) {
        video.pause();
      } else {
        video.play();
      }
      return;
    }

    if (!youtube.src && youtube.dataset.src) {
      youtube.src = youtube.dataset.src + '&autoplay=1';
      setPlaying(true);
      return;
    }

    if (isPlaying) {
      postYoutubeCommand('pauseVideo');
      setPlaying(false);
    } else {
      postYoutubeCommand('playVideo');
      setPlaying(true);
    }
  };

  playButton.setAttribute('data-play-label', playButton.getAttribute('aria-label') || 'Play behind the scenes video');
  playButton.addEventListener('click', state.handlePlayClick);

  if (video) {
    state.handleVideoPlay = function () {
      setPlaying(true);
    };
    state.handleVideoPause = function () {
      setPlaying(false);
    };
    state.handleVideoEnded = function () {
      setPlaying(false);
    };

    video.addEventListener('play', state.handleVideoPlay);
    video.addEventListener('pause', state.handleVideoPause);
    video.addEventListener('ended', state.handleVideoEnded);
  }

  window.HansoTheme.behindScenesSections.set(section, state);
};

window.HansoTheme.initBehindScenesSections = function initBehindScenesSections(scope) {
  var root = scope || document;
  var sections = root.querySelectorAll('[data-behind-scenes-section]');
  sections.forEach(function (section) {
    window.HansoTheme.initBehindScenesSection(section);
  });
};

window.HansoTheme.destroyBehindScenesSection = function destroyBehindScenesSection(section) {
  if (!section || !window.HansoTheme.behindScenesSections.has(section)) return;

  var state = window.HansoTheme.behindScenesSections.get(section);
  var playButton = section.querySelector('[data-behind-scenes-play]');
  var video = section.querySelector('.hanso-behind-scenes__video');

  if (playButton && state && state.handlePlayClick) {
    playButton.removeEventListener('click', state.handlePlayClick);
  }

  if (video && state) {
    if (state.handleVideoPlay) video.removeEventListener('play', state.handleVideoPlay);
    if (state.handleVideoPause) video.removeEventListener('pause', state.handleVideoPause);
    if (state.handleVideoEnded) video.removeEventListener('ended', state.handleVideoEnded);
  }

  window.HansoTheme.behindScenesSections.delete(section);
};

window.HansoTheme.initPdpFullVideo = function initPdpFullVideo(section) {
  if (!section || window.HansoTheme.pdpFullVideos.has(section)) return;

  var media = section.querySelector('[data-pdp-full-video-media]');
  var video = section.querySelector('.hanso-pdp-full-video__video');
  var playButtons = Array.prototype.slice.call(section.querySelectorAll('[data-pdp-full-video-play]'));
  var pauseButton = section.querySelector('[data-pdp-full-video-pause]');

  if (!media || !video || !playButtons.length || !pauseButton) return;

  var state = {
    handlePlayClick: null,
    handlePauseClick: null,
    handleVideoPlay: null,
    handleVideoPause: null,
    handleVideoEnded: null,
  };

  function syncVideoState() {
    var isPlaying = !video.paused && !video.ended;
    media.classList.toggle('is-playing', isPlaying);
    section.classList.toggle('is-playing', isPlaying);
  }

  state.handlePlayClick = function handlePlayClick() {
    if (!video.paused && !video.ended) {
      return;
    }

    video.muted = false;
    video.removeAttribute('muted');
    var playPromise = video.play();

    if (playPromise && typeof playPromise.then === 'function') {
      playPromise.then(syncVideoState).catch(syncVideoState);
    } else {
      syncVideoState();
    }
  };

  state.handlePauseClick = function handlePauseClick() {
    video.pause();
    syncVideoState();
  };

  state.handleVideoPlay = syncVideoState;
  state.handleVideoPause = syncVideoState;
  state.handleVideoEnded = syncVideoState;

  playButtons.forEach(function (button) {
    button.addEventListener('click', state.handlePlayClick);
  });
  pauseButton.addEventListener('click', state.handlePauseClick);
  video.addEventListener('play', state.handleVideoPlay);
  video.addEventListener('pause', state.handleVideoPause);
  video.addEventListener('ended', state.handleVideoEnded);
  syncVideoState();

  state.playButtons = playButtons;
  state.pauseButton = pauseButton;
  state.video = video;

  window.HansoTheme.pdpFullVideos.set(section, state);
};

window.HansoTheme.initPdpFullVideos = function initPdpFullVideos(scope) {
  var root = scope || document;
  var sections = root.querySelectorAll('[data-pdp-full-video-section]');
  sections.forEach(function (section) {
    window.HansoTheme.initPdpFullVideo(section);
  });
};

window.HansoTheme.destroyPdpFullVideo = function destroyPdpFullVideo(section) {
  if (!section || !window.HansoTheme.pdpFullVideos.has(section)) return;

  var state = window.HansoTheme.pdpFullVideos.get(section);

  if (state && state.playButtons && state.handlePlayClick) {
    state.playButtons.forEach(function (button) {
      button.removeEventListener('click', state.handlePlayClick);
    });
  }

  if (state && state.pauseButton && state.handlePauseClick) {
    state.pauseButton.removeEventListener('click', state.handlePauseClick);
  }

  if (state && state.video) {
    if (state.handleVideoPlay) state.video.removeEventListener('play', state.handleVideoPlay);
    if (state.handleVideoPause) state.video.removeEventListener('pause', state.handleVideoPause);
    if (state.handleVideoEnded) state.video.removeEventListener('ended', state.handleVideoEnded);
  }

  window.HansoTheme.pdpFullVideos.delete(section);
};

window.HansoTheme.syncMenuDrawerState = function syncMenuDrawerState(details) {
  if (!details) return;
  var toggle = details.querySelector('[data-hanso-menu-toggle]');
  var isOpen = details.hasAttribute('open');
  var customHeader = details.closest('[data-hanso-header]');
  var headerMain = customHeader ? customHeader.querySelector('[data-hanso-header-main]') : null;
  var topbarShell = customHeader ? customHeader.querySelector('[data-hanso-topbar-shell]') : null;

  document.body.classList.toggle('hanso-menu-drawer-open', isOpen);
  document.body.classList.toggle('hideScroll', isOpen);
  document.documentElement.classList.toggle('hideScroll', isOpen);

  if (customHeader && headerMain) {
    customHeader.style.setProperty('--hanso-mobile-header-bottom', headerMain.getBoundingClientRect().bottom + 'px');
    customHeader.style.setProperty('--hanso-mobile-topbar-height', topbarShell ? topbarShell.offsetHeight + 'px' : '0px');
  }

  if (toggle) {
    toggle.classList.toggle('is-open', isOpen);
  }
};

window.HansoTheme.initMenuDrawers = function initMenuDrawers(scope) {
  var root = scope || document;
  var drawers = root.querySelectorAll('[data-hanso-menu-drawer]');

  drawers.forEach(function (drawer) {
    if (!drawer || window.HansoTheme.menuDrawers.has(drawer)) return;

    var onToggle = function onToggle() {
      window.HansoTheme.syncMenuDrawerState(drawer);
    };

    drawer.addEventListener('toggle', onToggle);
    window.HansoTheme.syncMenuDrawerState(drawer);
    window.HansoTheme.menuDrawers.set(drawer, { onToggle: onToggle });
  });
};

window.HansoTheme.destroyMenuDrawer = function destroyMenuDrawer(drawer) {
  if (!drawer || !window.HansoTheme.menuDrawers.has(drawer)) return;
  var entry = window.HansoTheme.menuDrawers.get(drawer);
  if (entry && entry.onToggle) {
    drawer.removeEventListener('toggle', entry.onToggle);
  }
  document.body.classList.remove('hanso-menu-drawer-open');
  document.body.classList.remove('hideScroll');
  document.documentElement.classList.remove('hideScroll');
  window.HansoTheme.menuDrawers.delete(drawer);
};

window.HansoTheme.initFooterAccordion = function initFooterAccordion(footer) {
  if (!footer || window.HansoTheme.footers.has(footer)) return;

  var mobileQuery = window.matchMedia('(max-width: 991px)');
  var columns = Array.prototype.slice.call(footer.querySelectorAll('[data-hanso-footer-column]'));
  var state = {
    handlers: [],
    handleResize: null,
    handleBreakpointChange: null,
  };

  function setColumnOpen(column, shouldOpen) {
    var trigger = column.querySelector('[data-hanso-footer-trigger]');
    var content = column.querySelector('[data-hanso-footer-content]');

    if (!trigger || !content) return;

    column.classList.toggle('is-open', shouldOpen);
    trigger.setAttribute('aria-expanded', shouldOpen ? 'true' : 'false');

    if (!mobileQuery.matches) {
      content.style.maxHeight = '';
      return;
    }

    content.style.maxHeight = shouldOpen ? content.scrollHeight + 'px' : '0px';
  }

  function openAllColumns() {
    columns.forEach(function (column) {
      setColumnOpen(column, true);
    });
  }

  function closeAllColumns() {
    columns.forEach(function (column) {
      setColumnOpen(column, false);
    });
  }

  function refreshOpenColumnHeights() {
    columns.forEach(function (column) {
      if (mobileQuery.matches && column.classList.contains('is-open')) {
        setColumnOpen(column, true);
      }
    });
  }

  columns.forEach(function (column) {
    var trigger = column.querySelector('[data-hanso-footer-trigger]');
    if (!trigger) return;

    var handleTrigger = function handleTrigger(event) {
      if (!mobileQuery.matches) return;

      event.preventDefault();
      setColumnOpen(column, !column.classList.contains('is-open'));
    };

    var handleKeydown = function handleKeydown(event) {
      if (!mobileQuery.matches) return;
      if (event.key !== 'Enter' && event.key !== ' ') return;

      event.preventDefault();
      setColumnOpen(column, !column.classList.contains('is-open'));
    };

    trigger.addEventListener('click', handleTrigger);
    trigger.addEventListener('keydown', handleKeydown);
    state.handlers.push({ trigger: trigger, handleTrigger: handleTrigger, handleKeydown: handleKeydown });
  });

  state.handleResize = refreshOpenColumnHeights;
  state.handleBreakpointChange = function handleBreakpointChange() {
    if (mobileQuery.matches) {
      closeAllColumns();
    } else {
      openAllColumns();
    }
  };

  mobileQuery.addEventListener('change', state.handleBreakpointChange);
  window.addEventListener('resize', state.handleResize);

  if (mobileQuery.matches) {
    closeAllColumns();
  } else {
    openAllColumns();
  }

  window.HansoTheme.footers.set(footer, state);
};

window.HansoTheme.initFooterAccordions = function initFooterAccordions(scope) {
  var root = scope || document;
  var footers = root.querySelectorAll('[data-hanso-footer]');

  footers.forEach(function (footer) {
    window.HansoTheme.initFooterAccordion(footer);
  });
};

window.HansoTheme.destroyFooterAccordion = function destroyFooterAccordion(footer) {
  if (!footer || !window.HansoTheme.footers.has(footer)) return;

  var state = window.HansoTheme.footers.get(footer);
  var columns = Array.prototype.slice.call(footer.querySelectorAll('[data-hanso-footer-column]'));

  if (state && state.handlers) {
    state.handlers.forEach(function (entry) {
      entry.trigger.removeEventListener('click', entry.handleTrigger);
      entry.trigger.removeEventListener('keydown', entry.handleKeydown);
    });
  }

  if (state && state.handleBreakpointChange) {
    window.matchMedia('(max-width: 991px)').removeEventListener('change', state.handleBreakpointChange);
  }

  if (state && state.handleResize) {
    window.removeEventListener('resize', state.handleResize);
  }

  columns.forEach(function (column) {
    var trigger = column.querySelector('[data-hanso-footer-trigger]');
    var content = column.querySelector('[data-hanso-footer-content]');

    column.classList.remove('is-open');
    if (trigger) trigger.setAttribute('aria-expanded', 'false');
    if (content) content.style.maxHeight = '';
  });

  window.HansoTheme.footers.delete(footer);
};

window.HansoTheme.initGallerySliders = function initGallerySliders(scope) {
  var root = scope || document;
  var sliders = root.querySelectorAll('[data-gallery-slider]');

  sliders.forEach(function (slider) {
    window.HansoTheme.initGallerySlider(slider);
  });
};

window.HansoTheme.onReady(function initializeTheme() {
  window.HansoTheme.initMotion();
  window.HansoTheme.initViewportFillHeroes(document);
  window.HansoTheme.initPromoBanners(document);
  window.HansoTheme.initLogoShowcaseTickers(document);
  window.HansoTheme.initLogoShowcaseCarousels(document);
  window.HansoTheme.initLogoShowcaseResponsiveHandlers(document);
  window.HansoTheme.initLogoShowcaseQuotes(document);
    window.HansoTheme.initGallerySliders(document);
    window.HansoTheme.initCarouselGalleries(document);
    window.HansoTheme.initCollectionPergolaGrids(document);
    window.HansoTheme.initLouverTechnologySections(document);
    window.HansoTheme.initPdpLouverFeatureGrids(document);
    window.HansoTheme.initPdpGridGalleryCarousels(document);
    window.HansoTheme.initProductMainGalleries(document);
  window.HansoTheme.initProductAddonsSections(document);
  window.HansoTheme.initProductMainFaq(document);
  window.HansoTheme.initProductGridCarousels(document);
  window.HansoTheme.initVideoTestimonialsSections(document);
  window.HansoTheme.initPressSpotlights(document);
  window.HansoTheme.initAnimatedStats(document);
  window.HansoTheme.initBehindScenesSections(document);
  window.HansoTheme.initPdpFullVideos(document);
  window.HansoTheme.initPdpBestReviews(document);
  window.HansoTheme.initPdpFaqSections(document);
  window.HansoTheme.initBlogPostsSections(document);
    window.HansoTheme.initCustomHeaders(document);
    window.HansoTheme.initMenuDrawers(document);
    window.HansoTheme.initFooterAccordions(document);
    window.HansoTheme.initDesktopMegaMenus();
    document.documentElement.classList.add('js-ready');
  });

window.HansoTheme.onSectionEvent('shopify:section:load', function onSectionLoad(event) {
  document.documentElement.dataset.lastLoadedSection = event.detail.sectionId;
  window.HansoTheme.initGallerySliders(event.target);
  window.HansoTheme.initCarouselGalleries(event.target);
  window.HansoTheme.initCollectionPergolaGrids(event.target);
  window.HansoTheme.initLouverTechnologySections(event.target);
  window.HansoTheme.initPdpLouverFeatureGrids(event.target);
  window.HansoTheme.initPdpGridGalleryCarousels(event.target);
  window.HansoTheme.initProductMainGalleries(event.target);
  window.HansoTheme.initProductAddonsSections(event.target);
  window.HansoTheme.initProductMainFaq(event.target);
  window.HansoTheme.initViewportFillHeroes(document);
  window.HansoTheme.initPromoBanners(event.target);
  window.HansoTheme.initLogoShowcaseTickers(event.target);
  window.HansoTheme.initLogoShowcaseCarousels(event.target);
  window.HansoTheme.initLogoShowcaseResponsiveHandlers(event.target);
  window.HansoTheme.initLogoShowcaseQuotes(event.target);
  window.HansoTheme.initProductGridCarousels(event.target);
  window.HansoTheme.initVideoTestimonialsSections(event.target);
  window.HansoTheme.initPressSpotlights(event.target);
  window.HansoTheme.initAnimatedStats(event.target);
  window.HansoTheme.initBehindScenesSections(event.target);
  window.HansoTheme.initPdpFullVideos(event.target);
  window.HansoTheme.initPdpBestReviews(event.target);
  window.HansoTheme.initPdpFaqSections(event.target);
  window.HansoTheme.initBlogPostsSections(event.target);
  window.HansoTheme.initCustomHeaders(event.target);
  window.HansoTheme.initMenuDrawers(event.target);
  window.HansoTheme.initFooterAccordions(event.target);
  window.HansoTheme.refreshMotion();
  window.HansoTheme.initViewportFillHeroes(document);
  window.HansoTheme.refreshCustomHeaders();
  window.HansoTheme.initDesktopMegaMenus();
});

window.HansoTheme.onSectionEvent('shopify:section:unload', function onSectionUnload(event) {
  var gallerySection = event.target.closest('[data-gallery-slider]');

  if (gallerySection) {
    window.HansoTheme.destroyGallerySlider(gallerySection);
  }

  var carouselGallerySection = event.target.closest('[data-carousel-gallery-section]');

  if (carouselGallerySection) {
    window.HansoTheme.destroyCarouselGallery(carouselGallerySection);
  }

  var collectionPergolaGridSection = event.target.closest('[data-collection-pergola-grid-section]');

  if (collectionPergolaGridSection) {
    window.HansoTheme.destroyCollectionPergolaGrid(collectionPergolaGridSection);
  }

  var louverTechnologySection = event.target.closest('[data-louver-technology-section]');

  if (louverTechnologySection) {
    window.HansoTheme.destroyPdpLouverFeatureGrid(louverTechnologySection);
    window.HansoTheme.destroyLouverTechnologySection(louverTechnologySection);
  }

  var pdpGridGalleryCarouselSection = event.target.closest('[data-pdp-grid-gallery-carousel-section]');

  if (pdpGridGalleryCarouselSection) {
    window.HansoTheme.destroyPdpGridGalleryCarousel(pdpGridGalleryCarouselSection);
  }

  var productGridSection = event.target.closest('[data-product-grid-section]');

  if (productGridSection) {
    window.HansoTheme.destroyProductGridCarousel(productGridSection);
  }

  var productMainSection = event.target.closest('[data-hanso-product-main]');

  if (productMainSection) {
    window.HansoTheme.destroyProductMainGallery(productMainSection);
    window.HansoTheme.destroyProductAddons(productMainSection);
    window.HansoTheme.destroyProductMainFaq(productMainSection);
  }

  var videoTestimonialsSection = event.target.closest('[data-video-testimonials-section]');
  if (videoTestimonialsSection) {
    window.HansoTheme.destroyVideoTestimonials(videoTestimonialsSection);
  }

  var blogPostsSection = event.target.closest('[data-blog-posts-section]');
  if (blogPostsSection) {
    window.HansoTheme.destroyBlogPosts(blogPostsSection);
  }

  var pressSpotlightSection = event.target.closest('[data-press-spotlight-section]');
  if (pressSpotlightSection) {
    window.HansoTheme.destroyPressSpotlight(pressSpotlightSection);
  }

  var animatedStatSection = event.target.closest('[data-animated-stat-section]');
  if (animatedStatSection) {
    window.HansoTheme.destroyAnimatedStat(animatedStatSection);
  }

  var behindScenesSection = event.target.closest('[data-behind-scenes-section]');
  if (behindScenesSection) {
    window.HansoTheme.destroyBehindScenesSection(behindScenesSection);
  }

  var pdpFullVideoSection = event.target.closest('[data-pdp-full-video-section]');
  if (pdpFullVideoSection) {
    window.HansoTheme.destroyPdpFullVideo(pdpFullVideoSection);
  }

  var pdpBestReviewSection = event.target.closest('[data-pdp-best-review]');
  if (pdpBestReviewSection) {
    window.HansoTheme.destroyPdpBestReview(pdpBestReviewSection);
  }

  var pdpFaqSection = event.target.closest('[data-pdp-faq-section]');
  if (pdpFaqSection) {
    window.HansoTheme.destroyPdpFaqSection(pdpFaqSection);
  }

  var promoBannerSection = event.target.closest('[data-hanso-promo-banner]');
  if (promoBannerSection) {
    window.HansoTheme.destroyPromoBanner(promoBannerSection);
  }

  var logoShowcaseSection = event.target.closest('.hanso-logo-showcase-section');
  if (logoShowcaseSection) {
    window.HansoTheme.destroyLogoShowcaseTicker(logoShowcaseSection);
    window.HansoTheme.destroyLogoShowcaseResponsive(logoShowcaseSection);
    window.HansoTheme.destroyLogoShowcaseCarousel(logoShowcaseSection);
    window.HansoTheme.destroyLogoShowcaseQuote(logoShowcaseSection);
  }

  var customHeader = event.target.closest('[data-hanso-header]');

  if (customHeader) {
    window.HansoTheme.destroyCustomHeader(customHeader);
  }

  var menuDrawer = event.target.closest('[data-hanso-menu-drawer]');

  if (menuDrawer) {
    window.HansoTheme.destroyMenuDrawer(menuDrawer);
  }

  var footerAccordion = event.target.closest('[data-hanso-footer]');

  if (footerAccordion) {
    window.HansoTheme.destroyFooterAccordion(footerAccordion);
  }
});

window.HansoTheme.onSectionEvent('shopify:section:reorder', window.HansoTheme.refreshMotion);
window.HansoTheme.onSectionEvent('shopify:section:select', window.HansoTheme.refreshMotion);
window.addEventListener('scroll', window.HansoTheme.updateCustomHeadersOnScroll, { passive: true });
window.addEventListener('resize', function onResize() {
  window.HansoTheme.gallerySliders.forEach(function (gallery) {
    if (gallery && gallery.flkty) {
      gallery.flkty.resize();
    }
  });

  window.HansoTheme.productMainGalleries.forEach(function (gallery) {
    if (gallery && gallery.flkty) {
      gallery.flkty.resize();
    }
  });

  window.HansoTheme.productGridCarousels.forEach(function (grid) {
    if (grid && grid.flkty) {
      grid.flkty.resize();
    }
  });
  window.HansoTheme.videoTestimonials.forEach(function (entry) {
    if (entry && entry.flkty) {
      entry.flkty.resize();
    }
  });
  window.HansoTheme.blogPosts.forEach(function (entry) {
    if (entry && entry.flkty) {
      entry.flkty.resize();
    }
  });
  window.HansoTheme.pressSpotlights.forEach(function (entry) {
    if (entry && entry.flkty) {
      entry.flkty.resize();
    }
  });
  window.HansoTheme.logoShowcaseCarousels.forEach(function (entry) {
    if (entry && entry.flkty) {
      entry.flkty.resize();
    }
  });

  window.HansoTheme.refreshMotion();
  window.HansoTheme.initViewportFillHeroes(document);
  window.HansoTheme.refreshPromoBanners();
  window.HansoTheme.refreshCustomHeaders();
});

window.addEventListener(
  'scroll',
  function onPromoBannerScroll() {
    window.HansoTheme.promoBanners.forEach(function (state) {
      if (state) {
        state.update();
        // console.log("Updated state");
      }
    });
  },
  { passive: true }
);
